import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import ConsumosTelasModal from "./ConsumosTelasModal";
import Baja from "../../Baja";
import BajaMultiple from "../../BajaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";


import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";
import CapturaTallasColores from "../../CapturaTallasColores";

function ListadoPedidos() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  // TF6 — movimientos de producción para el PDF comparativo de surtido
  const URL_ARTICULOS_PROCESOS_SALIDA =
    process.env.REACT_APP_URL_ARTICULOS_PROCESOS_SALIDA;
  const URL_ENTRADAS_ALMACEN = process.env.REACT_APP_URL_ENTRADAS_ALMACEN;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_EXPLOSION = process.env.REACT_APP_URL_EXPLOSION;
  const URL_EXPLOSION_GLOBAL = process.env.REACT_APP_URL_EXPLOSION_GLOBAL;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_TIPOS_TELAS = process.env.REACT_APP_URL_TIPOS_TELAS;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_CATALOGO_PROCESOS = process.env.REACT_APP_URL_CATALOGO_PROCESOS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  // const URL_COMPRADORES = process.env.REACT_APP_URL_COMPRADORES;
  const URL_AREAS_CLIENTES = process.env.REACT_APP_URL_AREAS_CLIENTES;
  const URL_CONSUMO_TELAS = process.env.REACT_APP_URL_CONSUMO_TELAS;
  const URL_COLABORADORES_TALLAS = process.env.REACT_APP_URL_COLABORADORES_TALLAS;
  const URL_COLABORADORES_CLIENTES = process.env.REACT_APP_URL_COLABORADORES_CLIENTES;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;
  const URL_SUBDEPARTAMENTOS = process.env.REACT_APP_URL_SUBDEPARTAMENTOS;
  const URL_DEPARTAMENTOS = process.env.REACT_APP_URL_DEPARTAMENTOS;
  // const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 90);

  let valida = new Date();
  valida.setDate(valida.getDate() + 8);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("2025-12-01");
  // let startDate = moment(inicio).format("YYYY-MM-DD");
  let validador = moment(valida).format("YYYY-MM-DD");
  const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];
  const [pedidos, setPedidos] = useState([]);

  const [articulos, setArticulos] = useState([]);
const [areasClientesOptions, setAreasClientesOptions] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  // const [compradores, setCompradores] = useState([]);
  // const [selectedComprador, setSelectedComprador] = useState("");
  // const [marcas, setMarcas] = useState([]);
  // const [selectedMarca, setSelectedMarca] = useState("");

  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");

  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");

  const [telas, setTelas] = useState([]);
  const [tiposTelas, setTiposTelas] = useState([]);
  const [habilitacion, setHabilitacion] = useState([]);

  const [selectedArticulo, setSelectedArticulo] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [fecha, setFecha] = useState("");
  const [fecha_cancelacion, setFechaCancelacion] = useState("");
  const [fecha_confirmacion, setFechaConfirmacion] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [observacionesMarca, setObservacionesMarca] = useState("NA");
  const [total_general, setTotalGeneral] = useState("");
  const [total_kilos, setTotalUnidaKilos] = useState("");
  const [total_metros, setTotalUnidaMetros] = useState("");
  const [numero_pedido, setNumeroPedido] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [selectedClienteEdit, setSelectedClienteEdit] = useState("");
  const [selectedEmpresaEdit, setSelectedEmpresaEdit] = useState("");
  // (2026-07) tipo de pedido en el modal de editar
  const [selectedTipoEdit, setSelectedTipoEdit] = useState("Por definir");
  // const [selectedCompradorEdit, setSelectedCompradorEdit] = useState("");
  const [selectedColaboradorEdit, setSelectedColaboradorEdit] = useState("");
  const [selectedMarcaEdit, setSelectedMarcaEdit] = useState("");
  // const [selectedPatronistaEdit, setSelectedPatronistaEdit] = useState("");
  // const [selectedMuestristaEdit, setSelectedMuestristaEdit] = useState("");
  // const [selectedPloterEdit, setSelectedPloterEdit] = useState("");
  const [idArticuloEdit, setIdArticuloEdit] = useState("");
  const [pedidoCliente, setPedidoCliente] = useState("");
  // (2026-09) Subcliente del pedido
  const [subClienteEdit, setSubClienteEdit] = useState("NA");

  const [sucursales, setSucursales] = useState([]);
  const [subDepartamentos, setSubDepartamentos] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [articulosPedido, setArticulosPedido] = useState([]);
  const [idArticuloPedido, setIdArticuloPedido] = useState("");
  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [areaFoto, setAreaFoto] = useState("");
  const [sucursalFoto, setSucursalFoto] = useState("");
  const [articuloFoto, setArticuloFoto] = useState("");
  const [observacionFoto, setObservacionFoto] = useState("");
  const [pedidoId, setPedidoId] = useState(null); // o el nombre que estés usando
  const [sucursalId, setSucursalId] = useState(null); // o el nombre que estés usando
  const [modalFicha, setModalFicha] = useState(false);
  const [photoFile, setPhotoFile] = useState(null);
  const [modalBordados, setModalBordados] = useState(false);
  const toggleBordados = () => setModalBordados(!modalBordados);
  const [subiendoBordado, setSubiendoBordado] = useState(false);
  const [bordados, setBordados] = useState([]); // ← lista ya guardada
  // (2026-10) instrucciones e imagen de un bordado guardado se editan por separado
  const [editandoBordado, setEditandoBordado] = useState(null); // { version, texto }
  const [cambiandoImagenBordado, setCambiandoImagenBordado] = useState(null); // version
  const [nuevoBordadoFile, setNuevoBordadoFile] = useState(null);
  const [nuevaObservacion, setNuevaObservacion] = useState("");

  const [total_general_edit, setTotalGeneralEdit] = useState(0);
  const [total_kilos_edit, setTotalKilosEdit] = useState(0);
  const [total_metros_edit, setTotalMetrosEdit] = useState(0);
  const [total_cantidad_edit, setTotalCantidadEdit] = useState(0);

  const [codigo, setCodigo] = useState("");
  const [descripcion, setDescripcion] = useState("");

  const [colores, setColores] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");
  const [tallas, setTallas] = useState([]);
  const [selectedTalla, setSelectedTalla] = useState("");
  const [catalogoProcesos, setCatalogoProcesos] = useState([]);

  const [modalExplosion, setModalExplosion] = useState(false);
  const toggleExplosion = () => setModalExplosion(!modalExplosion);
  const [explosionExistentes, setExplosionExistentes] = useState([]);
  const [codigoExplosion, setCodigoExplosion] = useState("");
  const [idExplosion, setIdExplosion] = useState("");
  const [descripcionExplosion, setDescripcionExplosion] = useState("");

  const [modalExplosionGlobal, setModalExplosionGlobal] = useState(false);
  const toggleExplosionGlobal = () =>
    setModalExplosionGlobal(!modalExplosionGlobal);
  const [explosionGlobalExistente, setExplosionGlobalExistente] = useState([]);

  const [idColoresArticulos, setIdColoresArticulos] = useState("");
  const [modalColores, setModalColores] = useState(false);
  const toggleColores = () => setModalColores(!modalColores);
  const [arrayColores, setArrayColores] = useState([]);

  const [idTallasArticulos, setIdTallasArticulos] = useState("");
  const [modalTallas, setModalTallas] = useState(false);
  const toggleTallas = () => setModalTallas(!modalTallas);
  const [arrayTallas, setArrayTallas] = useState([]);

  const [idCatalogoProcesosArticulos, setIdCatalogoProcesosArticulos] =
    useState("");
  const [modalCatalogoProcesos, setModalCatalogoProcesos] = useState(false);
  const toggleCatalogoProcesos = () =>
    setModalCatalogoProcesos(!modalCatalogoProcesos);
  const [arrayCatalogoProcesos, setArrayCatalogoProcesos] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);

  const [idEditArticuloEdit, setIdEditArticuloEdit] = useState("");
  const [codigoEdit, setCodigoEdit] = useState("");
  const [codigoClienteEdit, setCodigoClienteEdit] = useState("");
  const [nombreEdit, setNombreEdit] = useState("");
  const [descripcionEdit, setDescripcionEdit] = useState("");
  const [precioEtiquetaEdit, setPrecioEtiquetaEdit] = useState("");
  const [ventaEdit, setVentaEdit] = useState("");
  const [observacionesEdit, setObservacionesEdit] = useState("");
  const [condicionesEdit, setCondicionesEdit] = useState("");
  const [observacionesMarcaEdit, setObservacionesMarcaEdit] = useState("");
  const [observacionesProduccionEdit, setObservacionesProduccionEdit] =
    useState("");
  // const [selectedMarcaEdit, setSelectedMarcaEdit] = useState("");
  const [modalEditInfoArticulo, setModalEditInfoArticulo] = useState(false);
  const toggleEditInfoArticulo = () =>
    setModalEditInfoArticulo(!modalEditInfoArticulo);
  const [selectedPendFechaConf, setSelectedPendFechaConf] = useState("");

const [resumenEditPedido, setResumenEditPedido] = useState([]);
// (2026-08) guardado del orden de impresión de todos los artículos a la vez
const [guardandoOrden, setGuardandoOrden] = useState(false);
// (2026-08) renglones que la redistribución por tallas dejó fuera y hay que
// poner en 0 al guardar (si no, quedan duplicando piezas en la base)
const [idsPorCerrar, setIdsPorCerrar] = useState([]);
const [detalleEditPedido, setDetalleEditPedido] = useState([]);
const [cargandoDetalleEdit, setCargandoDetalleEdit] = useState(false);
const [editandoDetalle, setEditandoDetalle] = useState(false);
const [grupoSeleccionadoEdit, setGrupoSeleccionadoEdit] = useState(null);
// (2026-07) El detalle del grupo abre en su propio modal (encima del de edición)
const [modalDetalleGrupo, setModalDetalleGrupo] = useState(false);
const toggleDetalleGrupo = () => setModalDetalleGrupo(!modalDetalleGrupo);

// Alta inline de Telas desde el edit del pedido
const [modalNuevaTela, setModalNuevaTela] = useState(false);
const [savingTela, setSavingTela] = useState(false);
const [nuevaTela, setNuevaTela] = useState({
  nombre: "",
  composicion: "",
  tipoTela: "",
});

const openNuevaTelaEdit = () => {
  setNuevaTela({ nombre: "", composicion: "", tipoTela: "" });
  setModalNuevaTela(true);
};

const guardarNuevaTelaEdit = async () => {
  const nombre = String(nuevaTela.nombre || "").trim();
  const composicion = String(nuevaTela.composicion || "").trim();
  const tipoTela = String(nuevaTela.tipoTela || "").trim();
  if (!nombre || !composicion || !tipoTela) {
    Swal.fire(
      "Atención",
      "Nombre, composición y tipo son requeridos.",
      "warning"
    );
    return;
  }
  try {
    setSavingTela(true);
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    const body = {
      nombre,
      composicion,
      descripcion: nombre,
      unidad: "MT",
      ancho: 0,
      peso: 0,
      rendimiento: 0,
      tiposTelas: tipoTela,
      costo: 0,
      venta: 0,
      observaciones: "NA",
    };
    const res = await axios.post(URL_TELAS, body, { headers });
    const creada = res.data;
    setTelas((prev) => {
      const exists = prev.some(
        (t) => String(t._id) === String(creada._id)
      );
      return exists ? prev : [...prev, creada];
    });

    // Aplica la tela recién creada al grupo en edición
    const nuevaTelaName = creada.nombre;
    const nuevaComp = creada.composicion || "";
    setGrupoSeleccionadoEdit((prev) =>
      prev ? { ...prev, tela: nuevaTelaName, composicion: nuevaComp } : prev
    );
    setResumenEditPedido((prev) =>
      (prev || []).map((r) =>
        r.key === grupoSeleccionadoEdit?.key
          ? { ...r, tela: nuevaTelaName, composicion: nuevaComp }
          : r
      )
    );
    const nuevoDetalle = (detalleEditPedido || []).map((item) => ({
      ...item,
      tela: nuevaTelaName,
      composicion: nuevaComp,
    }));
    setDetalleEditPedido(nuevoDetalle);
    sincronizarDetalleConInputFields(nuevoDetalle);

    setModalNuevaTela(false);
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "No se pudo dar de alta la tela.", "error");
  } finally {
    setSavingTela(false);
  }
};

const [modalAddArticuloEdit, setModalAddArticuloEdit] = useState(false);
const [sucursalesClienteEdit, setSucursalesClienteEdit] = useState([]);
const [areasClienteEdit, setAreasClienteEdit] = useState([]);
const toggleAddArticuloEdit = () =>
  setModalAddArticuloEdit(!modalAddArticuloEdit);

const [nuevoArticuloEdit, setNuevoArticuloEdit] = useState({
  sucursalId: "",
  sucursalNombre: "",
  areaId: "",
  areaNombre: "",
  articuloId: "",
  articuloNombre: "",
  departamentoId: "",
  subDepartamentoId: "",
  colorId: "",
  colorNombre: "",
  tallaId: "",
  tallaNombre: "",
  cantidad: 0,
  precio: 0,
  tela: "",
});

  const [modalPrecosteo, setModalPrecosteo] = useState(false);
  const togglePrecosteo = () => setModalPrecosteo(!modalPrecosteo);
  const [precosteoTelas, setPrecosteoTelas] = useState([]);
  const [precosteoHab, setPrecosteoHab] = useState([]);

const [clientePedidoEdit, setClientePedidoEdit] = useState("");
const [actualizandoPorTallas, setActualizandoPorTallas] = useState(false);

    const [nombreFirmaEdit, setNombreFirmaEdit] = useState("");
    const [puestoFirmaEdit, setPuestoFirmaEdit] = useState("");
    const [nombreCompradorEdit, setNombreCompradorEdit] = useState("");
    const [puestoCompradorEdit, setPuestoCompradorEdit] = useState("");
    const [impuestosEdit, setImpuestosEdit] = useState("");

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      resurtido: "",
      unidad: 0,
      colores: "",
      arrayColoresArticulo: [],
      tallas: "",
      arrayTallasArticulo: [],
      cantidad: 0,
      surtido: 0,
      precio: 0,
      precioEtiqueta: 0,
      descuento: 0,
      total: 0,
      codigoBarras: 0,
    },
  ]);
  const [inputFieldsTela, setInputFieldsTela] = useState([
    {
      id: uuidv4(),
      idTela: "",
      cantidad: 0,
      observaciones: "NA",
    },
  ]);

  const [inputFieldsHab, setInputFieldsHab] = useState([
    {
      id: uuidv4(),
      idHab: "",
      cantidad: 0,
      observaciones: "NA",
    },
  ]);

  const [inputFieldsTelaGlobal, setInputFieldsTelaGlobal] = useState([
    {
      id: uuidv4(),
      idTela: "",
      idColor: "",
      cantidad: 0,
      cantidadPrenda: 0,
      observaciones: "NA",
    },
  ]);

  const [explosion, setExplosion] = useState([]);
  const [explosionHab, setExplosionHab] = useState([]);
  const [modalExplosiones, setModalExplosiones] = useState(false);
  const toggleExplosiones = () => setModalExplosiones(!modalExplosiones);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  // (2026-07) filtro is_active del listado; default "Si" (solo activos)
  const [activo, setActivo] = useState("Si");
  const [selectedStatus, setSelectedStatus] = useState("Abierto");

  const [modalStatus, setModalStatus] = useState(false);
  const toggleStatus = () => setModalStatus(!modalStatus);

  const [modalAutorizaciones, setModalAutorizaciones] = useState(false);

  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;

  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);


  const [modalConsumos, setModalConsumos] = useState(false);
  const toggleConsumos = () => setModalConsumos(!modalConsumos);
  const [consumosPrevios, setConsumosPrevios] = useState([]);

  const [modalCheck, setModalCheck] = useState(false);
const [checks, setChecks] = useState({
  Etiquetas: false,
  Tallas: false,
  Observaciones: false,
  Bordados: false,
  Modelos: false,
});
const [idPedidoEditando, setIdPedidoEditando] = useState(null);


  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  // L94 (2026-06) — al venir de guardar un pedido (PedidosCreate setea
  // localStorage.autoPDFPedido), abrir su PDF azul (PDFOCPorArea, bordados No)
  // en automático cuando carguen los datos. PDFOCPorArea está hoisteada.
  useEffect(() => {
    const autoPDFId = localStorage.getItem("autoPDFPedido");
    if (!autoPDFId || !comments || comments.length === 0) return;
    const ped = comments.find((c) => String(c._id) === String(autoPDFId));
    if (ped) {
      localStorage.removeItem("autoPDFPedido");
      try {
        const empresaObj =
          empresas.find((x) => String(x._id) === String(ped.idEmpresas)) || null;
        PDFOCPorArea(
          ped.fecha,
          ped.colaboradores,
          ped.fecha_cancelacion,
          ped.fecha_confirmacion,
          ped.idClientes,
          ped.clientes,
          ped.pedidoCliente,
          ped.total_kilos,
          ped.total_metros,
          ped.total_general,
          ped.observaciones,
          ped.numero,
          ped._id,
          ped.condiciones,
          ped.nombreFirma,
          ped.puestoFirma,
          ped.nombreComprador,
          ped.puestoComprador,
          ped.impuestos,
          ped.marcas,
          empresaObj,
          // bordados "No"
          false,
          ped.direccionCliente
        );
      } catch (e) {
        console.warn("No se pudo abrir el PDF automático del pedido:", e);
      }
    }
  }, [comments, empresas]);

  // (2026-10) Carga del listado con las fechas del filtro actual. Se llama al
  // montar/cambiar fechas y después de editar, en vez de recargar la página.
  function cargarPedidos() {
    return axios
      .get(`${URL_PEDIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPedidos = response.data;
        // Array para pagination
        let arrayTabla = allPedidos
          // (2026-09) del más nuevo al más viejo: el último pedido capturado
          // arriba, que es el que se está trabajando
          .sort((a, b) => Number(b.idPedido || 0) - Number(a.idPedido || 0))
          .map((a) => {
            return {
              _id: a._id,
              numero: a.idPedido,
              activo: a.is_active,
              // (2026-07) tipo de pedido (Personalizado / Granel / Por definir)
              tipo: a.tipo || "Por definir",
              fecha: a.fecha,
              precioEtiqueta: 0,
              colaboradores:
                a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
              idColaboradores: a.colaboradores[0]._id,
              marcas: a.marcas[0].name,
              idMarcas: a.marcas[0]._id,
              fecha_cancelacion: a.fecha_cancelacion,
              fecha_confirmacion: a.fecha_confirmacion,
              observaciones: a.observaciones,
              observacionesMarca: a.observacionesMarca,
              total_general: a.total_general,
              precioPrenda:
                parseFloat(a.total_general) / parseFloat(a.total_piezas),
              // (2026-09) con el subcliente entre paréntesis: así sale en la
              // tabla, el buscador, el PDF/Excel/mail del listado y los PDF del pedido
              clientes: (() => {
                const nombre = a.clientes[0].nombre_comercial;
                const sub = String(a.subCliente ?? "").trim();
                return sub && sub.toUpperCase() !== "NA" ? `${nombre} (${sub})` : nombre;
              })(),
              idClientes: a.clientes[0]._id,
              // Dirección del cliente (para encabezados de PDF). Solo si la calle
              // NO es "NA" ni vacía. Usa un saneador local tipo s(...).
              direccionCliente: (() => {
                const sc = (x) => String(x || "").trim();
                const _cli = a.clientes?.[0] || {};
                const _calle = sc(_cli.calle);
                if (!_calle || _calle.toUpperCase() === "NA") return "";
                const _l1 = [_cli.numero_ext, _cli.numero_int]
                  .map((x) => sc(x))
                  .filter((x) => x && x.toUpperCase() !== "NA")
                  .join(" ");
                return [
                  [_calle, _l1].filter(Boolean).join(" "),
                  sc(_cli.colonia) && sc(_cli.colonia).toUpperCase() !== "NA"
                    ? "Col. " + sc(_cli.colonia)
                    : "",
                  sc(_cli.cp) &&
                  sc(_cli.cp).toUpperCase() !== "NA" &&
                  sc(_cli.cp) !== "0"
                    ? "C.P. " + sc(_cli.cp)
                    : "",
                ]
                  .filter(Boolean)
                  .join(", ");
              })(),
              total_kilos: a.total_kilos,
              total_metros: a.total_metros,
              status: a.status,
              autorizado: a.autorizado,
              cantidad: parseFloat(a.total_piezas),
              surtido: parseFloat(a.surtido),
              pendiente_surtir: parseFloat(a.pendiente_surtir),
              codigos: a.codigos,
              ficha: a.ficha,
              auditoria: a.auditoria,
              muestraFit: a.muestraFit,
              muestraConfirmacion: a.muestraConfirmacion,
              etiquetas: a.etiquetas,
              fechaEstCodigos: a.fechaEstCodigos,
              fechaRealCodigos: a.fechaRealCodigos,
              fechaEstFicha: a.fechaEstFicha,
              fechaRealFicha: a.fechaRealFicha,
              fechaEstAuditoria: a.fechaEstAuditoria,
              fechaRealAuditoria: a.fechaRealAuditoria,
              fechaEstMuestraFit: a.fechaEstMuestraFit,
              fechaRealMuestraFit: a.fechaRealMuestraFit,
              fechaEstMuestraConfirmacion: a.fechaEstMuestraConfirmacion,
              fechaRealMuestraConfirmacion: a.fechaRealMuestraConfirmacion,
              fechaEstEtiquetas: a.fechaEstEtiquetas,
              fechaRealEtiquetas: a.fechaRealEtiquetas,
              autorizacionCostos: a.autorizacionCostos,
              autorizacionVarios: a.autorizacionVarios,
              // T8 (2026-06) — quien autorizó el pedido
              autorizacionVariosColaborador:
                a.autorizacionVariosColaborador?.[0]?.nombre ||
                a.autorizacionVariosColaborador?.[0]?.name ||
                "",
              // L96 (2026-06) — Autorización Dirección
              autorizacionDireccion: a.autorizacionDireccion,
              autorizacionDireccionColaborador:
                a.autorizacionDireccionColaborador?.[0]?.nombre ||
                a.autorizacionDireccionColaborador?.[0]?.name ||
                "",
              autorizacionFit: a.autorizacionFit,
              autorizacionDiseno: a.autorizacionDiseno,
              autorizacionCalidad: a.autorizacionCalidad,
              autorizacionPloterDiseno: a.autorizacionPloterDiseno,
              autorizacionPloter: a.autorizacionPloter,
              autorizacionSurtir: a.autorizacionSurtir,
              statusTela: a.statusTela,
              statusHabilitacion: a.statusHabilitacion,
              empresas: a.empresas[0].name,
              idEmpresas: a.empresas[0]._id,
              status: a.status,
              pedidoCliente: a.pedidoCliente,
              subCliente: a.subCliente || "NA",
              resurtido: a.resurtido,
              pendFechaConf: a.pendFechaConf,
              ordenCorte: a.ordenCorte,
              condiciones: a.condiciones,

              nombreFirma: a.nombreFirma,
              puestoFirma: a.puestoFirma,
              nombreComprador: a.nombreComprador,
              puestoComprador: a.puestoComprador,
              impuestos: a.impuestos,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);

        // let agrupado = data.reduce(function (groups, item) {
        //   const val = item["_id"];
        //   groups[val] = groups[val] || {
        //     _id: item._id,
        //     surtido: 0,
        //     pendiente_surtir: 0,
        //     cantidad: 0,
        //   };
        //   groups[val].surtido += item.surtido;
        //   groups[val].pendiente_surtir += item.pendiente_surtir;
        //   groups[val].cantidad += item.cantidad;
        //   groups[val]._id = item._id;
        //   groups[val].numero = item.numero;
        //   groups[val].activo = item.activo;
        //   groups[val].fecha = item.fecha;
        //   groups[val].articulos = item.articulos;
        //   groups[val].idArticulo = item.idArticulo;
        //   groups[val].codigo = item.codigo;
        //   groups[val].descripcion = item.descripcion;
        //   groups[val].colores = item.colores;
        //   groups[val].tallas = item.tallas;
        //   groups[val].catalogoProcesos = item.catalogoProcesos;
        //   groups[val].patronista = item.patronista;
        //   groups[val].idPatronista = item.idPatronista;
        //   groups[val].muestrista = item.muestrista;
        //   groups[val].idMuestrista = item.idMuestrista;
        //   groups[val].ploter = item.ploter;
        //   groups[val].idPloter = item.idPloter;
        //   groups[val].colaboradores = item.colaboradores;
        //   groups[val].idColaboradores = item.idColaboradores;
        //   groups[val].fecha_cancelacion = item.fecha_cancelacion;
        //   groups[val].fecha_confirmacion = item.fecha_confirmacion;
        //   groups[val].total_general = item.total_general;
        //   groups[val].precioPrenda = item.precioPrenda;
        //   groups[val].clientes = item.clientes;
        //   groups[val].idClientes = item.idClientes;
        //   groups[val].status = item.status;
        //   groups[val].autorizado = item.autorizado;
        //   groups[val].observaciones = item.observaciones;
        //   groups[val].codigos = item.codigos;
        //   groups[val].ficha = item.ficha;
        //   groups[val].auditoria = item.auditoria;
        //   groups[val].muestraFit = item.muestraFit;
        //   groups[val].muestraConfirmacion = item.muestraConfirmacion;
        //   groups[val].etiquetas = item.etiquetas;
        //   groups[val].fechaEstCodigos = item.fechaEstCodigos;
        //   groups[val].fechaRealCodigos = item.fechaRealCodigos;
        //   groups[val].fechaEstFicha = item.fechaEstFicha;
        //   groups[val].fechaRealFicha = item.fechaRealFicha;
        //   groups[val].fechaEstAuditoria = item.fechaEstAuditoria;
        //   groups[val].fechaRealAuditoria = item.fechaRealAuditoria;
        //   groups[val].fechaEstMuestraFit = item.fechaEstMuestraFit;
        //   groups[val].fechaRealMuestraFit = item.fechaRealMuestraFit;
        //   groups[val].fechaEstMuestraConfirmacion =
        //     item.fechaEstMuestraConfirmacion;
        //   groups[val].fechaRealMuestraConfirmacion =
        //     item.fechaRealMuestraConfirmacion;
        //   groups[val].fechaEstEtiquetas = item.fechaEstEtiquetas;
        //   groups[val].fechaRealEtiquetas = item.fechaRealEtiquetas;
        //   groups[val].autorizacionCostos = item.autorizacionCostos;
        //   groups[val].autorizacionFit = item.autorizacionFit;
        //   groups[val].autorizacionDiseno = item.autorizacionDiseno;
        //   groups[val].autorizacionCalidad = item.autorizacionCalidad;
        //   groups[val].autorizacionPloter = item.autorizacionPloter;
        //   groups[val].autorizacionPloterDiseno = item.autorizacionPloterDiseno;
        //   groups[val].autorizacionSurtir = item.autorizacionSurtir;
        //   groups[val].statusTela = item.statusTela;
        //   groups[val].statusHabilitacion = item.statusHabilitacion;
        //   groups[val].empresas = item.empresas;
        //   groups[val].idEmpresas = item.idEmpresas;
        //   groups[val].compradores = item.compradores;
        //   groups[val].idCompradores = item.idCompradores;
        //   // groups[val].marcas = item.marcas;
        //   // groups[val].idMarcas = item.idMarcas;
        //   groups[val].status = item.status;
        //   groups[val].codigoCliente = item.codigoCliente;
        //   groups[val].venta = item.venta;
        //   groups[val].precioEtiqueta = item.precioEtiqueta;
        //   groups[val].observacionesArticulo = item.observacionesArticulo;
        //   groups[val].observacionesProduccion = item.observacionesProduccion;
        //   groups[val].fotoArticulo = item.fotoArticulo;
        //   groups[val].fotoDiseno = item.fotoDiseno;
        //   groups[val].pedidoCliente = item.pedidoCliente;
        //   groups[val].resurtido = item.resurtido;
        //   groups[val].pendFechaConf = item.pendFechaConf;
        //   return groups;
        // }, []);

        // let dataFinal = Object.values(agrupado);

        setPedidos(data);
        setComments(data);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // (2026-10) Catálogo de artículos; también se refresca al editar un modelo.
  function cargarArticulos() {
    return axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useMemo(() => {
    cargarPedidos();

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_SUCURSALES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSucursales = response.data;
        setSucursales(allSucursales);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_SUBDEPARTAMENTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSubDepartamentos = response.data;
        setSubDepartamentos(allSubDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });

       axios
      .get(URL_DEPARTAMENTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allDepartamentos = response.data;
        setDepartamentos(allDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEmpresas = response.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      });
 axios
    .get(`${URL_AREAS_CLIENTES}`) // Usa la URL correcta
    .then((res) => setAreasClientesOptions(res.data))
    .catch((err) => console.error("Error cargando areas clientes", err));
    // axios
    //   .get(URL_COMPRADORES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((response) => {
    //     let allCompradores = response.data;
    //     setCompradores(allCompradores);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    // axios
    // .get(URL_MARCAS, {
    //   headers: {
    //     Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //   },
    // })
    // .then((response) => {
    //   let allMarcas = response.data;
    //   setMarcas(allMarcas);
    // })
    // .catch((err) => {
    //   console.log(err);
    // });
      
    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allMarcas = response.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });

    cargarArticulos();
    axios
      .get(URL_TELAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTelas = res.data;
        setTelas(allTelas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TIPOS_TELAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setTiposTelas(res.data || []);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_HABILITACION, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allHabilitacion = res.data;
        setHabilitacion(allHabilitacion);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColores = response.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allTallas = response.data;
        setTallas(allTallas);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CATALOGO_PROCESOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCatalogoProcesos = response.data;
        setCatalogoProcesos(allCatalogoProcesos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  // (2026-09) PDF / Excel / mail salen con las mismas columnas y los mismos
  // filtros que la tabla de la pantalla (pedidosFiltrados, sin paginar).
  const columnasListado = [
    "Numero", "Fecha", "Marca", "Cliente", "Empresa",
    "Vendedor", "Fecha Entrega", "Cantidad", "Surtido", "Total",
  ];
  // (2026-10) PDF del listado con el diseño de los reportes nuevos (banda,
  // tarjetas de resumen, tabla en rejilla y pie con páginas). Sin la columna
  // Marca y con el total sólo al final, no en cada hoja.
  const docListadoPDF = (titulo) => {
    const doc = new jsPDF("landscape", "mm", "a4");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const ML = 10;
    const usableW = pageW - ML * 2;

    const negroAzul = [17, 24, 39];
    const azulOscuro = [31, 56, 100];
    const gris = [110, 120, 135];
    const bordeGris = [210, 216, 224];
    const verde = [39, 124, 70];
    const naranja = [214, 110, 40];

    const num = (n) => new Intl.NumberFormat("en-US").format(Number(n || 0));
    const money = (n) =>
      "$" +
      new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(n || 0));
    const fechaCorta = (f) => (f ? moment(f).format("DD/MM/YYYY") : "-");

    const filas = pedidosFiltrados;
    const tot = filas.reduce(
      (t, a) => ({
        cantidad: t.cantidad + Number(a.cantidad || 0),
        surtido: t.surtido + Number(a.surtido || 0),
        monto: t.monto + Number(a.total_general || 0),
      }),
      { cantidad: 0, surtido: 0, monto: 0 }
    );
    const pendiente = Math.max(0, tot.cantidad - tot.surtido);
    const folios = filas.map((a) => Number(a.numero)).filter((n) => !isNaN(n));
    const textoFolios = folios.length
      ? `${Math.min(...folios)} al ${Math.max(...folios)}`
      : "-";

    // ---- Banda de título
    doc.setFillColor(...negroAzul);
    doc.roundedRect(ML, 8, usableW, 18, 2, 2, "F");
    doc.setTextColor(255).setFont(undefined, "bold").setFontSize(14);
    doc.text(`LANGIANI ERP — ${String(titulo).toUpperCase()}`, ML + 5, 16);
    doc.setFont(undefined, "normal").setFontSize(8);
    doc.text(
      `Periodo: ${fechaCorta(selectedFechaInicio)} al ${fechaCorta(selectedFechaFin)}`,
      ML + 5,
      21.5
    );
    doc.setFontSize(7.5);
    doc.text(
      `Fecha de Emisión: ${moment().format("DD/MM/YYYY")}`,
      pageW - ML - 5,
      13.5,
      { align: "right" }
    );
    doc.text(`Pedidos: ${num(filas.length)}`, pageW - ML - 5, 18, {
      align: "right",
    });
    doc.setFont(undefined, "bold");
    doc.text(`Folios: ${textoFolios}`, pageW - ML - 5, 22.5, { align: "right" });
    doc.setTextColor(0).setFont(undefined, "normal");

    // ---- Tarjetas de resumen
    let y = 30;
    const pct = (a, b) => (b > 0 ? ((a / b) * 100).toFixed(0) : 0);
    const tarjetas = [
      { titulo: "TOTAL PEDIDOS", valor: num(filas.length), pie: `Folios ${textoFolios}` },
      { titulo: "MONTO TOTAL", valor: money(tot.monto), pie: "Importe de los pedidos" },
      { titulo: "PIEZAS PEDIDAS", valor: `${num(tot.cantidad)} Pzs`, pie: "Total solicitado" },
      {
        titulo: "PIEZAS SURTIDAS",
        valor: `${num(tot.surtido)} Pzs`,
        pie: `${pct(tot.surtido, tot.cantidad)}% surtido`,
      },
      {
        titulo: "PENDIENTE POR SURTIR",
        valor: `${num(pendiente)} Pzs`,
        pie: `${pct(pendiente, tot.cantidad)}% del total`,
      },
    ];
    const gap = 3;
    const tarjW = (usableW - gap * (tarjetas.length - 1)) / tarjetas.length;
    const tarjH = 18;
    tarjetas.forEach((t, i) => {
      const x = ML + i * (tarjW + gap);
      doc.setFillColor(255).setDrawColor(...bordeGris).setLineWidth(0.25);
      doc.roundedRect(x, y, tarjW, tarjH, 1.5, 1.5, "FD");
      doc.setFont(undefined, "bold").setFontSize(7).setTextColor(...gris);
      doc.text(t.titulo, x + tarjW / 2, y + 5, { align: "center" });
      doc.setFontSize(11).setTextColor(...azulOscuro);
      doc.text(t.valor, x + tarjW / 2, y + 11, { align: "center" });
      doc.setFont(undefined, "normal").setFontSize(6.5).setTextColor(...gris);
      doc.text(t.pie, x + tarjW / 2, y + 15.5, { align: "center" });
      doc.setTextColor(0);
    });
    y += tarjH + 5;

    // ---- Tabla
    doc.autoTable({
      startY: y,
      margin: { left: ML, right: ML, top: 12, bottom: 14 },
      tableWidth: usableW,
      theme: "grid",
      styles: {
        fontSize: 7.5,
        cellPadding: 1.4,
        valign: "middle",
        lineColor: bordeGris,
        lineWidth: 0.15,
        textColor: 40,
      },
      headStyles: {
        fillColor: negroAzul,
        textColor: [255, 255, 255],
        fontStyle: "bold",
        fontSize: 7,
        halign: "center",
      },
      alternateRowStyles: { fillColor: [248, 250, 252] },
      columnStyles: {
        0: { cellWidth: 14, halign: "center", fontStyle: "bold" },
        1: { cellWidth: 20, halign: "center" },
        // 2: Cliente se queda con el ancho que sobre
        3: { cellWidth: 40 },
        4: { cellWidth: 36 },
        5: { cellWidth: 20, halign: "center" },
        6: { cellWidth: 18, halign: "right" },
        7: { cellWidth: 18, halign: "right" },
        8: { cellWidth: 26, halign: "right", fontStyle: "bold" },
      },
      head: [
        [
          "PEDIDO",
          "FECHA CITA VENTA",
          "CLIENTE",
          "EMPRESA",
          "VENDEDOR",
          "FECHA ENTREGA",
          "CANTIDAD",
          "SURTIDO",
          "TOTAL",
        ],
      ],
      body: filas.map((a) => [
        a.numero,
        fechaCorta(a.fecha),
        a.clientes,
        a.empresas,
        a.colaboradores,
        fechaCorta(a.fecha_cancelacion),
        num(a.cantidad),
        num(a.surtido),
        money(a.total_general),
      ]),
      foot: [
        [
          { content: "TOTALES GENERALES", colSpan: 6, styles: { halign: "left" } },
          num(tot.cantidad),
          num(tot.surtido),
          money(tot.monto),
        ],
      ],
      // el total sólo al final, no en cada hoja
      showFoot: "lastPage",
      footStyles: {
        fillColor: [226, 233, 241],
        textColor: azulOscuro,
        fontStyle: "bold",
        halign: "right",
      },
      didParseCell: (h) => {
        if (h.section !== "body" || h.column.index !== 7) return;
        const a = filas[h.row.index];
        if (!a) return;
        const cant = Number(a.cantidad || 0);
        const surt = Number(a.surtido || 0);
        // surtido: verde si ya está completo, naranja si va a medias
        if (cant > 0 && surt >= cant) h.cell.styles.textColor = verde;
        else if (surt > 0) h.cell.styles.textColor = naranja;
      },
    });

    // ---- Pie en todas las hojas
    const paginas = doc.internal.getNumberOfPages();
    for (let p = 1; p <= paginas; p++) {
      doc.setPage(p);
      doc.setDrawColor(...bordeGris).setLineWidth(0.2);
      doc.line(ML, pageH - 10, pageW - ML, pageH - 10);
      doc.setFont(undefined, "normal").setFontSize(7.5).setTextColor(...gris);
      doc.text(
        `LANGIANI ERP System © ${moment().format("YYYY")} | Documento Generado Automáticamente`,
        ML,
        pageH - 5.5
      );
      doc.text(`Página ${p} de ${paginas}`, pageW - ML, pageH - 5.5, {
        align: "right",
      });
      doc.setTextColor(0);
    }
    return doc;
  };

  function PDFTabla() {
    if (!pedidosFiltrados.length) {
      return Swal.fire("Sin datos", "No hay pedidos con los filtros actuales", "warning");
    }
    const doc = docListadoPDF("Listado Pedidos");
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    if (!pedidosFiltrados.length) {
      return Swal.fire("Sin datos", "No hay pedidos con los filtros actuales", "warning");
    }
    const claves = [
      "Numero", "FechaCitaVenta", "Marca", "Cliente", "Empresa",
      "Vendedor", "FechaEntrega", "Cantidad", "Surtido", "Total",
    ];
    const dataExcelLimpia = pedidosFiltrados.map((a) => ({
      Numero: a.numero,
      FechaCitaVenta: a.fecha,
      Marca: a.marcas,
      Cliente: a.clientes,
      Empresa: a.empresas,
      Vendedor: a.colaboradores,
      FechaEntrega: a.fecha_cancelacion,
      Cantidad: Number(a.cantidad || 0),
      Surtido: Number(a.surtido || 0),
      Total: Number(a.total_general || 0),
    }));

    var option = {};
    option.fileName = "ListadoPedidos";
    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoPedidos",
        sheetFilter: claves,
        sheetHeader: columnasListado,
      },
    ];
    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    if (!pedidosFiltrados.length) {
      return Swal.fire("Sin datos", "No hay pedidos con los filtros actuales", "warning");
    }
    const doc = docListadoPDF("Listado Pedidos");
    var base64File = doc.output("datauristring").split(",")[1];
    enviaMailPDF(base64File);
  }

  function enviaMailPDF(base64File) {
    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Pedidos",
          email: mailTo,
          fileName: "ListadoPedidos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Pedidos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          // window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    fecha,
    idColaboradores,
    idMarcas,
    fecha_cancelacion,
    fecha_confirmacion,
    idClientes,
    idEmpresas,
    // idComprador,
    total_kilos,
    total_metros,
    total_general,
    observaciones,
    observacionesMarca,
    numero_pedido,
    idEdit,
    // idMuestrista,
    // idPatronista,
    // idPloter,
    idArticulo,
    pedidoCliente,
    nombreFirma,
    puestoFirma,
    nombreComprador,
    puestoComprador,
    condiciones,
    impuestos,
    // (2026-07) tipo de pedido
    tipo,
    // (2026-09) subcliente
    subCliente,
  ) {
    setSubClienteEdit(subCliente || "NA");
    setFecha(fecha);
    setSelectedColaboradorEdit(idColaboradores);
    setSelectedMarcaEdit(idMarcas);
    setSelectedTipoEdit(tipo || "Por definir");
    setFechaCancelacion(fecha_cancelacion);
    setFechaConfirmacion(fecha_confirmacion);
    setSelectedClienteEdit(idClientes);
    setSelectedEmpresaEdit(idEmpresas);
    // setSelectedCompradorEdit(idComprador);
    setTotalUnidaKilos(total_kilos);
    setTotalUnidaMetros(total_metros);
    setTotalGeneral(total_general);
    setObservaciones(observaciones);
    setObservacionesMarca(observacionesMarca);
    setNumeroPedido(numero_pedido);
    setIdEdit(idEdit);
    // setSelectedPatronistaEdit(idPatronista);
    // setSelectedMuestristaEdit(idMuestrista);
    // setSelectedPloterEdit(idPloter);
    setIdArticuloEdit(idArticulo);
    setPedidoCliente(pedidoCliente);
    setNombreFirmaEdit(nombreFirma);
    setPuestoFirmaEdit(puestoFirma);
    setNombreCompradorEdit(nombreComprador);
    setPuestoCompradorEdit(puestoComprador);
    setCondicionesEdit(condiciones);
    setImpuestosEdit(impuestos);
    toggleEdit();
  }
// L104 (2026-06) — usar logoInstitucionDonnatela cuando la empresa es UNIFORMES INNOVACIÓN
function logoInstSrc(empresa) {
  const t =
    typeof empresa === "string"
      ? empresa
      : empresa?.razonSocial || empresa?.name || "";
  const norm = t
    .normalize("NFD")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .toLowerCase();
  const file = norm.includes("uniformes innovacion")
    ? "logoInstitucionDonnatela.png"
    : "logoInstitucion.png";
  return process.env.PUBLIC_URL + "/" + file;
}
async function PDFOC(
  fecha,
  colaboradores,
  fecha_cancelacion,
  fecha_confirmacion,
  idClientes,
  clientes,
  pedidoCliente,
  total_kilos,
  total_metros,
  total_general,
  observaciones,
  numero,
  idPDFOC,
  condicionesPedido,
  nombreFirma,
  puestoFirma,
  nombreComprador,
  puestoComprador,
  impuestos,
  direccionCliente = ""
) {
  // === Helpers para sanear ===
  const s = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return "";
    return typeof v === "string" ? v : String(v);
  };

  const sn = (v, def = 0) => {
    if (v === null || v === undefined) return def;
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return def;
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  const getFirstName = (arr) => s(arr?.[0]?.name);
  const getFirstAlias = (arr) => s(arr?.[0]?.alias);
  const getFirstId = (arr) => s(arr?.[0]?._id);
  const getArticuloCodigo = (a) => s(a?.articulos?.[0]?.codigo);
  const getArticuloDepto = (a) => s(a?.articulos?.[0]?.subDepartamentos?.[0]?.name);
  const getTela = (a) => {
    const tela = s(a?.tela);
    let comp = s(a?.composicion);
    // L9 (2026-06) — Si el articuloPedido no tiene composicion (era "NA" o vacía),
    // buscamos en el catálogo de Telas por nombre como fallback.
    if (tela && !comp && Array.isArray(telas) && telas.length > 0) {
      const t = telas.find(
        (x) => (x?.nombre || "").trim().toLowerCase() === tela.trim().toLowerCase()
      );
      comp = s(t?.composicion);
    }
    if (tela && comp) return `${tela} - ${comp}`;
    return tela || comp;
  };
  const getObservacionesArticulo = (a) => s(a?.observacionesArticulo);

  const chunk = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  };

  const collatorES = new Intl.Collator("es", {
    sensitivity: "base",
    numeric: true,
  });

  const isSinVar = (name) => {
    const t = s(name).trim().toLowerCase();
    return !t || t === "sin variante" || t === "na";
  };

  try {
    const { data: allArticulosPedido } = await axios.get(
      `${URL_ARTICULOS_PEDIDO}/pedidos/${idPDFOC}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const doc = new jsPDF({ orientation: "landscape" });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 15;
    const marginTop = 15;
    const marginBottom = 15;

    let currentY = 55;

    const ensureRoom = (needed) => {
      if (currentY + needed > pageHeight - marginBottom) {
        doc.addPage();
        currentY = marginTop;
      }
    };

    // ============ LOGO ============
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "/logoInstitucion.png";
    await new Promise((resolve) => {
      img2.onload = () => {
        const maxH = 18;
        const scale = maxH / img2.height;
        const w = img2.width * scale;
        const h = img2.height * scale;
        doc.addImage(img2, "png", (pageWidth - w) / 2, 8, w, h);
        resolve();
      };
      img2.onerror = () => resolve();
    });

    // ============ ENCABEZADO ============
    doc.setFontSize(10);

    doc.text(`Fecha: ${s(fecha)}`, marginLeft, 32);
    doc.text(`Cliente: ${s(clientes)}`, marginLeft, 38);
    // Dirección del cliente (debajo del nombre), solo si viene informada.
    let _yColIzq = 44;
    if (direccionCliente) {
      const _dirLines = doc.splitTextToSize(
        `Dirección: ${direccionCliente}`,
        140
      ).slice(0, 2);
      doc.text(_dirLines, marginLeft, _yColIzq);
      _yColIzq += _dirLines.length * 5 + 1;
    }
    doc.text(`Comprador: ${s(nombreComprador)}`, marginLeft, _yColIzq);
    doc.text(`Puesto: ${s(puestoComprador)}`, marginLeft, _yColIzq + 6);

    const rightX = pageWidth - marginLeft - 70;
    doc.text(`Pedido: ${s(numero)}`, rightX, 38);
    doc.text(`Vendedor: ${s(nombreFirma)}`, rightX, 44);
    doc.text(`Puesto: ${s(puestoFirma)}`, rightX, 50);
    // L87 (2026-06) — Fecha Entrega (se captura en PedidosCreate como fecha_cancelacion)
    doc.text(`Entrega: ${s(fecha_cancelacion)}`, rightX, 56);

    let totalPiezasGlobal = 0;
    let totalDineroGlobal = 0;

    // ============ AGRUPAR POR SUCURSAL / AREA / ARTICULO / TELA ============
    // (2026-07) Imprimir los artículos en el orden capturado (campo `orden`):
    // orden>0 primero por ese número; los demás al final (sort estable).
    allArticulosPedido.sort(
      (a, b) =>
        (Number(a?.orden) > 0 ? Number(a.orden) : Infinity) -
        (Number(b?.orden) > 0 ? Number(b.orden) : Infinity)
    );
    const sucursalMap = {};
    allArticulosPedido.forEach((a) => {
      const sucSan =
        getFirstAlias(a.sucursales) || getFirstId(a.sucursales) || "Sin Sucursal";
      const areaSan =
        getFirstName(a.areasClientes) || getFirstId(a.areasClientes) || "Sin Área";

      const articuloSan = `${getArticuloCodigo(a)} ${getArticuloDepto(a)}`.trim();
      const articulo = articuloSan || "Artículo sin nombre";
      const tela = getTela(a) || "Sin Tela";

      // (2026-09) El precio entra en la clave: cuando un mismo artículo se
      // vende a dos precios (p. ej. tallas extra grandes más caras) se imprime
      // como dos bloques, cada uno con su precio, en vez de mostrar el del
      // primer renglón para todo.
      const precioSan = sn(a?.precio, 0);
      const clave = `${sucSan}||${areaSan}||${articulo}||${tela}||${precioSan}`;

      if (!sucursalMap[clave]) sucursalMap[clave] = [];
      sucursalMap[clave].push(a);
    });

    // ============ RECORRER GRUPOS ============
    for (const clave in sucursalMap) {
      const grupo = sucursalMap[clave];
      const [sucursal, areaNombre, articuloNombre, telaNombre] = clave.split("||");

      const precioUnitario = sn(grupo[0]?.precio, 0);

      // juntar observacionesArticulo únicas del grupo
      const observacionesArticuloGrupo = [
        ...new Set(
          grupo
            .map((a) => getObservacionesArticulo(a).trim())
            .filter((x) => x)
        ),
      ].join(" / ");

      doc.setFont(undefined, "bold");
      doc.setFontSize(10);

      ensureRoom(20);

      const sucursalMostrar = s(sucursal);
      if (sucursalMostrar && sucursalMostrar !== "1") {
        doc.text(sucursalMostrar, marginLeft, currentY);
        currentY += 5;
      }

      doc.text(
        `${s(areaNombre) || "Sin Área"} - Modelo: ${s(articuloNombre) || "Artículo sin nombre"} - Tela: ${s(telaNombre) || "Sin Tela"} - Precio: ${new Intl.NumberFormat(
          "en-US",
          { style: "currency", currency: "USD", maximumFractionDigits: 2 }
        ).format(precioUnitario)}`,
        marginLeft,
        currentY
      );

      currentY += 5;

      // ===== OBSERVACIONES DEL ARTÍCULO ABAJO DEL MODELO =====
      if (observacionesArticuloGrupo) {
        doc.setFont(undefined, "normal");
        doc.setFontSize(8.5);

        const maxWidthObsArticulo = pageWidth - marginLeft * 2;
        const obsArticuloLines = doc.splitTextToSize(
          `Observaciones del artículo: ${observacionesArticuloGrupo}`,
          maxWidthObsArticulo
        );

        const obsArticuloHeight = obsArticuloLines.length * 4;
        ensureRoom(obsArticuloHeight + 2);

        doc.text(obsArticuloLines, marginLeft, currentY);
        currentY += obsArticuloHeight + 2;
      } else {
        currentY += 1;
      }

      doc.setFont(undefined, "normal");
      doc.setFontSize(9);

      // ============ AGRUPAR POR COLOR -> VARIANTE -> TALLA ============
      const data = {};
      const totalVariante = {};
      const tallasMap = new Map();

      grupo.forEach((a) => {
        const color = getFirstName(a.colores) || "Sin color";
        const tallaName = s(a?.tallas?.[0]?.name?.trim()) || "Sin talla";
        const varianteNameRaw = s(a?.tallas?.[0]?.variantesTallas?.[0]?.name?.trim());
        const varianteName = varianteNameRaw ? varianteNameRaw : "Sin variante";
        const cantidad = sn(a?.cantidad, 0);

        if (!data[color]) data[color] = {};
        if (!data[color][varianteName]) data[color][varianteName] = {};
        if (!data[color][varianteName][tallaName]) data[color][varianteName][tallaName] = 0;
        data[color][varianteName][tallaName] += cantidad;

        if (!totalVariante[color]) totalVariante[color] = {};
        if (!totalVariante[color][varianteName]) totalVariante[color][varianteName] = 0;
        totalVariante[color][varianteName] += cantidad;

        tallasMap.set(tallaName, true);
      });

      Object.keys(data).forEach((color) => {
        Object.keys(data[color] || {}).forEach((variante) => {
          const tot = sn(totalVariante?.[color]?.[variante], 0);
          if (tot <= 0) {
            delete data[color][variante];
            if (totalVariante[color]) delete totalVariante[color][variante];
          }
        });
        if (!Object.keys(data[color] || {}).length) {
          delete data[color];
          delete totalVariante[color];
        }
      });

      const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];

      const tallasOrdenadas = Array.from(tallasMap.keys()).sort((a, b) => {
        const indexA = ordenTallas.indexOf(a);
        const indexB = ordenTallas.indexOf(b);
        return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
      });

      let totalPiezasGrupo = 0;
      Object.keys(totalVariante || {}).forEach((color) => {
        Object.keys(totalVariante[color] || {}).forEach((variante) => {
          totalPiezasGrupo += sn(totalVariante[color][variante], 0);
        });
      });

      totalPiezasGlobal += totalPiezasGrupo;
      totalDineroGlobal = sn(total_general, 0);

      const usableWidth = pageWidth - marginLeft * 2;
      const colorW = 30;
      const totalW = 12;
      const minTallaW = 5.8;

      const maxTallasPerRow = Math.max(
        1,
        Math.floor((usableWidth - colorW - totalW) / minTallaW)
      );

      const chunkSize = Math.max(1, Math.min(maxTallasPerRow, tallasOrdenadas.length));
      const tallasChunks = chunk(tallasOrdenadas, chunkSize);
      const colores = Object.keys(data);

      for (let ci = 0; ci < tallasChunks.length; ci++) {
        const chunkTallas = tallasChunks[ci];
        const nTallas = chunkTallas.length;
        const tallaW = (usableWidth - colorW - totalW) / Math.max(1, nTallas);

        const colStyles = {
          0: { cellWidth: colorW },
          [1 + nTallas]: { cellWidth: totalW },
        };

        for (let i = 0; i < nTallas; i++) {
          colStyles[1 + i] = { cellWidth: tallaW };
        }

        const headChunk = [["Color", ...chunkTallas, "Total"]];
        const bodyChunk = [];

        for (const color of colores) {
          const variantesRaw = Object.keys(data[color] || {});
          const variantes = variantesRaw.sort((a, b) => {
            const aSin = isSinVar(a);
            const bSin = isSinVar(b);

            if (aSin && !bSin) return -1;
            if (!aSin && bSin) return 1;

            const cleanA = s(a).trim();
            const cleanB = s(b).trim();

            const baseA = cleanA.split(/[+-]/)[0].trim();
            const baseB = cleanB.split(/[+-]/)[0].trim();

            const baseCompare = collatorES.compare(baseA, baseB);
            if (baseCompare !== 0) return baseCompare;

            const aHasPlus = cleanA.includes("+");
            const bHasPlus = cleanB.includes("+");
            const aHasMinus = cleanA.includes("-");
            const bHasMinus = cleanB.includes("-");

            if (aHasPlus && !bHasPlus) return -1;
            if (!aHasPlus && bHasPlus) return 1;

            if (aHasMinus && !bHasMinus) return -1;
            if (!aHasMinus && bHasMinus) return 1;

            const numA = parseInt(cleanA.match(/[+-]\s*(\d+)/)?.[1] || 0, 10);
            const numB = parseInt(cleanB.match(/[+-]\s*(\d+)/)?.[1] || 0, 10);

            return numA - numB;
          });

          let firstVar = true;

          for (const variante of variantes) {
            const totVar = sn(totalVariante?.[color]?.[variante], 0);
            if (totVar <= 0) continue;

            const row = new Array(1 + nTallas + 1).fill("");

            const tituloVar = isSinVar(variante) ? "" : s(variante);
            const colorTxt = firstVar ? s(color) : "";

            row[0] = tituloVar
              ? (colorTxt ? `${colorTxt}\n${tituloVar}` : tituloVar)
              : (colorTxt ? colorTxt : "");

            chunkTallas.forEach((talla, idx) => {
              const val = sn(data?.[color]?.[variante]?.[talla], 0);
              row[1 + idx] = val > 0 ? String(val) : "";
            });

            row[row.length - 1] = String(totVar);

            const tieneAlgoEnChunk =
              row.slice(1, 1 + nTallas).some((x) => String(x || "").trim() !== "") ||
              String(row[0] || "").trim() !== "";

            if (tieneAlgoEnChunk) bodyChunk.push(row);

            firstVar = false;
          }
        }

        ensureRoom(22);

        doc.autoTable({
          head: headChunk,
          body: bodyChunk,
          startY: currentY,
          margin: { left: marginLeft, right: marginLeft },
          tableWidth: usableWidth,
          // L29 (2026-06) — tabla profesional con zebra + color corporativo
          theme: "grid",
          styles: {
            fontSize: 10,
            cellPadding: 1.2,
            valign: "middle",
            halign: "center",
            overflow: "linebreak",
            lineColor: [210, 216, 224],
            lineWidth: 0.15,
          },
          headStyles: {
            fillColor: [42, 90, 138],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 10,
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: [251, 252, 253],
          },
          columnStyles: colStyles,
          didParseCell: (hookData) => {
            if (hookData.section === "body") {
              if (hookData.column.index === 0) {
                hookData.cell.styles.halign = "left";
                hookData.cell.styles.fontStyle = "bold";
              }
              if (hookData.column.index === hookData.row.cells.length - 1) {
                hookData.cell.styles.fontStyle = "bold";
                hookData.cell.styles.textColor = [42, 90, 138];
              }
            }
          },
        });

        currentY = doc.autoTable.previous.finalY + 4;

        if (tallasChunks.length > 1) {
          doc.setFontSize(8);
          doc.setFont(undefined, "italic");
          doc.text(
            `Tallas ${ci + 1}/${tallasChunks.length}`,
            pageWidth - marginLeft,
            currentY,
            { align: "right" }
          );
          doc.setFont(undefined, "normal");
          currentY += 5;
        }
      }

      // L29 (2026-06) — Total Artículo como chip
      ensureRoom(10);
      const chipText = `TOTAL ARTÍCULO: ${totalPiezasGrupo}`;
      doc.setFontSize(9.5);
      doc.setFont(undefined, "bold");
      const chipPad = 3;
      const chipW = doc.getTextWidth(chipText) + chipPad * 2;
      const chipH = 6;
      const chipX = pageWidth - marginLeft - chipW;
      doc.setFillColor(245, 247, 250);
      doc.setDrawColor(42, 90, 138);
      doc.setLineWidth(0.3);
      doc.roundedRect(chipX, currentY, chipW, chipH, 1.5, 1.5, "FD");
      doc.setLineWidth(0.2);
      doc.setTextColor(42, 90, 138);
      doc.text(chipText, chipX + chipPad, currentY + chipH - 1.7);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      doc.setDrawColor(0);
      currentY += chipH + 3;

      ensureRoom(4);
      doc.setDrawColor(210, 216, 224);
      doc.line(marginLeft, currentY, pageWidth - marginLeft, currentY);
      doc.setDrawColor(0);
      currentY += 5;
    }

    // ============ RESUMEN GENERAL — L29 mini-tabla bordada ============
    ensureRoom(45);

    const impuestosSi = String(impuestos || "").trim().toUpperCase() !== "NO";
    const subtotal = sn(totalDineroGlobal, 0);
    const iva = impuestosSi ? subtotal * 0.16 : 0;
    const totalConIVA = subtotal + iva;
    const fmtMoney = (n) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(n);

    doc.setFont(undefined, "bold");
    doc.setFontSize(11);
    doc.setTextColor(42, 90, 138);
    doc.text("RESUMEN GENERAL", pageWidth - marginLeft, currentY, { align: "right" });
    doc.setTextColor(0);
    currentY += 3;

    const resumenRows = [
      ["Piezas totales", `${totalPiezasGlobal}`],
      ["Subtotal", fmtMoney(subtotal)],
    ];
    if (impuestosSi) {
      resumenRows.push(["IVA (16%)", fmtMoney(iva)]);
      resumenRows.push(["Total", fmtMoney(totalConIVA)]);
    } else {
      resumenRows.push(["Total", fmtMoney(subtotal)]);
    }

    const resumenW = 95;
    const resumenLabelW = 45;
    const resumenX = pageWidth - marginLeft - resumenW;

    doc.autoTable({
      startY: currentY,
      margin: { left: resumenX, right: marginLeft },
      tableWidth: resumenW,
      body: resumenRows,
      theme: "grid",
      styles: {
        fontSize: 10,
        cellPadding: 1.5,
        lineColor: [210, 216, 224],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: {
          cellWidth: resumenLabelW,
          fillColor: [245, 247, 250],
          textColor: [110, 120, 135],
          fontStyle: "bold",
        },
        1: {
          cellWidth: resumenW - resumenLabelW,
          halign: "right",
        },
      },
      didParseCell: (h) => {
        if (h.row.index === resumenRows.length - 1) {
          h.cell.styles.fillColor = [42, 90, 138];
          h.cell.styles.textColor = [255, 255, 255];
          h.cell.styles.fontStyle = "bold";
          h.cell.styles.fontSize = 11;
        }
      },
    });

    currentY = doc.autoTable.previous.finalY + 8;

    // ============ CONDICIONES — L29/L31 caja con label band ============
    // L31 (2026-06) — sanear tabs/CR para que splitTextToSize envuelva, ancho con margen extra
    const condiciones = s(condicionesPedido).trim().replace(/\t/g, "  ").replace(/\r/g, "");
    if (condiciones) {
      ensureRoom(16);
      doc.setFillColor(42, 90, 138);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, 6, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      doc.text("CONDICIONES DE LA COTIZACIÓN", marginLeft + 3, currentY + 4.2);
      doc.setTextColor(0);
      currentY += 6;

      doc.setFont(undefined, "normal");
      doc.setFontSize(9);
      const maxWidth = pageWidth - marginLeft * 2;
      const lines = doc.splitTextToSize(condiciones, maxWidth - 12);
      const lineHeight = 4.2;
      const blockHeight = lines.length * lineHeight;

      ensureRoom(blockHeight + 8);
      doc.setFillColor(245, 247, 250);
      doc.setDrawColor(210, 216, 224);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, blockHeight + 5, "FD");
      doc.setDrawColor(0);
      doc.text(lines, marginLeft + 3, currentY + 4);
      currentY += blockHeight + 9;
    }

    // L35 (2026-06) — Caja MONARCH del final removida; solo queda la del header.

    // ============ FIRMA ============
    const signatureGap = 10;
    const lineWidth = 90;

    ensureRoom(signatureGap + 12);

    currentY += signatureGap;
    doc.setFont(undefined, "bold");
    doc.setFontSize(11);
    doc.text("FIRMA CLIENTE", pageWidth / 2, currentY, { align: "center" });
    currentY += 8;

    const lineStartX = (pageWidth - lineWidth) / 2;
    const lineEndX = lineStartX + lineWidth;
    doc.setDrawColor(0);
    doc.line(lineStartX, currentY, lineEndX, currentY);

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDFOC:", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
}

// ============================================================================
// FICHA TÉCNICA DE BORDADOS (estilo Word): banda + rejilla de celdas con borde
// (imagen arriba, observación debajo). Autocontenida: hace su propio addPage
// y su propia paginación. Reutilizable en los PDFs que imprimen bordados.
// ============================================================================
async function dibujarFichaBordados(doc, bordadosFinal, opts) {
  const {
    getCloudinaryUrl,
    loadImagePDF,
    pageWidth,
    marginLeft,
    marginTop = 15,
    brandColor,
    lightBg = [245, 247, 250],
    borderColor = [210, 216, 224],
    labelColor = [110, 120, 135],
    s = (v) => (v == null ? "" : String(v)),
  } = opts || {};

  if (!Array.isArray(bordadosFinal) || !bordadosFinal.length) return;

  const pageHeight = doc.internal.pageSize.getHeight();
  const marginBottom = 15;
  const usableW = pageWidth - marginLeft * 2;

  // Carga robusta: fetch → blob → dataURL (evita "tainted canvas" por CORS);
  // fallback al loader que pase el archivo.
  const cargarImagen = async (url) => {
    if (!url) return null;
    try {
      const resp = await fetch(url, { mode: "cors" });
      if (resp.ok) {
        const blob = await resp.blob();
        const dataUrl = await new Promise((res) => {
          const r = new FileReader();
          r.onloadend = () => res(r.result);
          r.onerror = () => res(null);
          r.readAsDataURL(blob);
        });
        if (dataUrl) return dataUrl;
      }
    } catch (e) {
      /* fallback abajo */
    }
    if (typeof loadImagePDF === "function") {
      return await loadImagePDF(url).catch(() => null);
    }
    return null;
  };

  doc.addPage();
  let y = marginTop;

  const room = (needed) => {
    if (y + needed > pageHeight - marginBottom) {
      doc.addPage();
      y = marginTop;
    }
  };

  // Banda "FICHA TÉCNICA DE BORDADOS"
  doc.setFillColor(...brandColor);
  doc.rect(marginLeft, y, usableW, 9, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont(undefined, "bold");
  doc.setFontSize(12.5);
  doc.text("FICHA TÉCNICA DE BORDADOS", pageWidth / 2, y + 6.3, {
    align: "center",
  });
  doc.setTextColor(0);
  doc.setFont(undefined, "normal");
  y += 14;

  const cols = 3;
  const cellGap = 6;
  const cellW = (usableW - cellGap * (cols - 1)) / cols;
  const cellPad = 3;
  const imgAreaH = 46;
  const capFont = 8.5;
  const capLineH = 4;
  const headFont = 8;
  const headLineH = 3.6;

  // (2026-09) Antes cada artículo abría su propia banda de ancho completo y su
  // bordado quedaba solo en el renglón, así que una ficha de 6 bordados se iba
  // a 3 hojas. Ahora cada bordado es una tarjeta (artículo + área arriba,
  // imagen y observación abajo) y van de 3 por renglón.
  const normaliza = (v) =>
    s(v)
      .replace(/\s*-\s*/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toUpperCase();

  const vistos = new Set();
  const tarjetas = [];

  for (const item of bordadosFinal) {
    const articulo = s(item.articulo);
    const area = s(item.area);

    for (const bordado of Array.isArray(item.bordados) ? item.bordados : []) {
      // el mismo artículo con el mismo bordado sale una sola vez
      const clave = [
        normaliza(area),
        normaliza(articulo),
        s(bordado.public_id),
        normaliza(bordado.observacion),
      ].join("||");

      if (vistos.has(clave)) continue;
      vistos.add(clave);
      tarjetas.push({ articulo, area, bordado });
    }
  }

  for (let i = 0; i < tarjetas.length; i += cols) {
    const rowItems = tarjetas.slice(i, i + cols);

    // preparar: cargar imagen y medir textos para nivelar el alto de la fila
    const prepared = [];
    let maxCapH = 0;
    let maxHeadH = 0;

    for (const t of rowItems) {
      const imgData = await cargarImagen(getCloudinaryUrl(t.bordado.public_id));

      doc.setFont(undefined, "bold").setFontSize(headFont);
      const headLines = doc.splitTextToSize(
        `${s(t.articulo)}   ·   ${s(t.area)}`,
        cellW - cellPad * 2
      );

      doc.setFont(undefined, "normal").setFontSize(capFont);
      const capLines = t.bordado.observacion
        ? doc.splitTextToSize(String(t.bordado.observacion), cellW - cellPad * 2)
        : [];

      const headH = headLines.length * headLineH + 3;
      const capH = capLines.length * capLineH;
      if (headH > maxHeadH) maxHeadH = headH;
      if (capH > maxCapH) maxCapH = capH;

      prepared.push({ imgData, headLines, capLines });
    }

    const rowH =
      maxHeadH + imgAreaH + (maxCapH > 0 ? maxCapH + 4 : 2) + cellPad;
    room(rowH + 4);

    let cx = marginLeft;
    for (const cell of prepared) {
      // borde de la celda
      doc.setDrawColor(...borderColor);
      doc.setLineWidth(0.3);
      doc.rect(cx, y, cellW, rowH);

      // encabezado de la tarjeta: artículo · área
      doc.setFillColor(...lightBg);
      doc.rect(cx, y, cellW, maxHeadH, "F");
      doc.setDrawColor(...borderColor);
      doc.rect(cx, y, cellW, maxHeadH);
      doc.setDrawColor(0);
      doc.setFont(undefined, "bold").setFontSize(headFont);
      doc.setTextColor(...brandColor);
      cell.headLines.forEach((linea, k) => {
        doc.text(linea, cx + cellPad, y + 4 + k * headLineH);
      });
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");

      const yImg = y + maxHeadH;

      // imagen centrada en el área de la foto
      if (cell.imgData) {
        const props = doc.getImageProperties(cell.imgData);
        let w = cellW - cellPad * 2;
        let h = (props.height * w) / props.width;
        const maxH = imgAreaH - cellPad * 2;
        if (h > maxH) {
          h = maxH;
          w = (props.width * h) / props.height;
        }
        const ox = cx + (cellW - w) / 2;
        const oy = yImg + cellPad + (imgAreaH - cellPad * 2 - h) / 2;
        doc.addImage(cell.imgData, "PNG", ox, oy, w, h);
      } else {
        doc.setFontSize(7);
        doc.setTextColor(150);
        doc.text("Sin imagen", cx + cellW / 2, yImg + imgAreaH / 2, {
          align: "center",
        });
        doc.setTextColor(0);
      }

      // caption (observación) debajo de una línea divisoria
      if (cell.capLines.length) {
        doc.setDrawColor(...borderColor);
        doc.line(cx, yImg + imgAreaH, cx + cellW, yImg + imgAreaH);
        doc.setDrawColor(0);
        doc.setFont(undefined, "normal");
        doc.setFontSize(capFont);
        doc.setTextColor(...labelColor);
        doc.text(cell.capLines, cx + cellPad, yImg + imgAreaH + capLineH + 1);
        doc.setTextColor(0);
      }
      cx += cellW + cellGap;
    }
    y += rowH + cellGap;
  }

  doc.setLineWidth(0.2);
  return y;
}

async function PDFOCPorArea(
  fecha,
  colaboradores,
  fecha_cancelacion,
  fecha_confirmacion,
  idClientes,
  clientes,
  pedidoCliente,
  total_kilos,
  total_metros,
  total_general,
  observaciones,
  numero,
  idPDFOC,
  condicionesPedido,
  nombreFirma,
  puestoFirma,
  nombreComprador,
  puestoComprador,
  impuestos,
  marcas,
  // L32 (2026-06) — datos fiscales de la empresa propia (Empresas model)
  empresa = null,
  // L41 (2026-06) — incluir página de bordados
  incluirBordados = false,
  direccionCliente = ""
) {
  // === Helpers para sanear ===
  const s = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return "";
    return typeof v === "string" ? v : String(v);
  };

  const sn = (v, def = 0) => {
    if (v === null || v === undefined) return def;
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return def;
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  const getFirstName = (arr) => s(arr?.[0]?.name);
  const getFirstAlias = (arr) => s(arr?.[0]?.alias);
  const getFirstId = (arr) => s(arr?.[0]?._id);
  const getArticuloCodigo = (a) => s(a?.articulos?.[0]?.codigo);
  const getArticuloDepto = (a) => s(a?.articulos?.[0]?.subDepartamentos?.[0]?.name);
  const getTela = (a) => {
    const tela = s(a?.tela);
    let comp = s(a?.composicion);
    // L9 (2026-06) — Si el articuloPedido no tiene composicion (era "NA" o vacía),
    // buscamos en el catálogo de Telas por nombre como fallback.
    if (tela && !comp && Array.isArray(telas) && telas.length > 0) {
      const t = telas.find(
        (x) => (x?.nombre || "").trim().toLowerCase() === tela.trim().toLowerCase()
      );
      comp = s(t?.composicion);
    }
    if (tela && comp) return `${tela} - ${comp}`;
    return tela || comp;
  };
  const getObservacionesArticulo = (a) => s(a?.observacionesArticulo);

  const chunk = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  };

  const collatorES = new Intl.Collator("es", {
    sensitivity: "base",
    numeric: true,
  });

  const isSinVar = (name) => {
    const t = s(name).trim().toLowerCase();
    return !t || t === "sin variante" || t === "na";
  };

  try {
    const { data: allArticulosPedido } = await axios.get(
      `${URL_ARTICULOS_PEDIDO}/pedidos/${idPDFOC}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const doc = new jsPDF({ orientation: "landscape" });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 15;
    const marginTop = 15;
    const marginBottom = 15;

    let currentY = 68;

    const ensureRoom = (needed) => {
      if (currentY + needed > pageHeight - marginBottom) {
        doc.addPage();
        currentY = marginTop;
      }
    };

    // === L29 (2026-06) — Paleta y helpers de diseño ===
    // L114 (2026-06) — morado si la empresa es UNIFORMES INNOVACIÓN (logo Donnatela)
    const brandColor = /Donnatela/i.test(logoInstSrc(empresa))
      ? [120, 88, 168]
      : [42, 90, 138]; // azul corporativo
    const lightBg = [245, 247, 250];       // gris muy claro (cards)
    const borderColor = [210, 216, 224];
    const labelColor = [110, 120, 135];
    const stripeBg = [251, 252, 253];

    const drawLabel = (label, value, lblX, valX, y) => {
      doc.setFont(undefined, "bold");
      doc.setTextColor(...labelColor);
      doc.setFontSize(8.5);
      doc.text(label, lblX, y);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9.5);
      const txt = s(value).trim();
      doc.text(txt || "—", valX, y);
    };

    const drawBand = (text, y, h = 7) => {
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, y, pageWidth - marginLeft * 2, h, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      doc.text(text, marginLeft + 3, y + h - 2.2);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
    };

    // ============ LOGO ============
    const img2 = new Image();
    img2.src = logoInstSrc(empresa); // L104
    await new Promise((resolve) => {
      img2.onload = () => {
        const maxH = /Donnatela/i.test(img2.src) ? 22 : 18; // L115 logo Donnatela más grande
        const scale = maxH / img2.height;
        const w = img2.width * scale;
        const h = img2.height * scale;
        doc.addImage(img2, "png", marginLeft, 8, w, h);
        resolve();
      };
      img2.onerror = () => resolve();
    });

    // ============ ENCABEZADO — L29/L32 redesign ============
    // Título "PEDIDO #N" grande a la derecha del logo
    doc.setFont(undefined, "bold");
    doc.setFontSize(16);
    doc.setTextColor(...brandColor);
    doc.text(`PEDIDO # ${s(numero)}`, pageWidth - marginLeft, 14, { align: "right" });
    doc.setTextColor(0);

    // L32 (2026-06) — Datos fiscales de la empresa propia, debajo del Pedido #
    if (empresa) {
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.setTextColor(60, 60, 60);
      doc.text(
        s(empresa.razonSocial) || s(empresa.name) || "",
        pageWidth - marginLeft,
        19,
        { align: "right" }
      );
      doc.setFont(undefined, "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(...labelColor);
      // RFC + Régimen Fiscal
      const fiscalLine = [
        empresa.rfc ? `RFC: ${s(empresa.rfc)}` : "",
        empresa.regimenFiscal ? `Rég. Fiscal: ${s(empresa.regimenFiscal)}` : "",
      ]
        .filter((x) => x)
        .join("   ·   ");
      if (fiscalLine) {
        doc.text(fiscalLine, pageWidth - marginLeft, 23, { align: "right" });
      }
      // Dirección + CP en líneas que se envuelven si no caben
      const direccionStr = [
        s(empresa.direccionFiscal),
        empresa.cp ? `C.P. ${s(empresa.cp)}` : "",
      ]
        .filter((x) => x)
        .join(", ");
      if (direccionStr) {
        const dirAvailW = pageWidth - marginLeft - (marginLeft + 60); // deja espacio para logo
        const dirLines = doc.splitTextToSize(direccionStr, dirAvailW);
        dirLines.forEach((line, i) => {
          doc.text(line, pageWidth - marginLeft, 27 + i * 3.8, { align: "right" });
        });
      }
      doc.setTextColor(0);
    }

    // Línea divisoria (corro abajo si hay empresa para no encimar)
    const headerLineY = empresa ? 36 : 28;
    doc.setDrawColor(...brandColor);
    doc.setLineWidth(0.6);
    doc.line(marginLeft, headerLineY, pageWidth - marginLeft, headerLineY);
    doc.setLineWidth(0.2);
    doc.setDrawColor(0);

    // Card 2 columnas con datos
    // L30/L32 (2026-06) — altura dinámica + posición que respeta el header con datos empresa
    const cardY = headerLineY + 3;
    const cardW = pageWidth - marginLeft * 2;
    const colRightX = pageWidth / 2 + 5;
    const lblX_R = colRightX;
    const valX_R = colRightX + 24;
    const obsText = s(observaciones).trim();

    // L31 (2026-06) — Observaciones sin tope: tantos renglones como necesite
    doc.setFontSize(9.5);
    // (2026-07) Monarch ahora va debajo de Marca (columna IZQUIERDA), así que el
    // texto se envuelve al ancho de esa columna (no la derecha).
    const obsAvailW = colRightX - (marginLeft + 28) - 3;
    let obsLinesHeader = [];
    if (obsText) {
      // Reemplazar tabs y returns para que splitTextToSize envuelva bien
      const clean = obsText.replace(/\t/g, "  ").replace(/\r/g, "");
      obsLinesHeader = doc.splitTextToSize(clean, obsAvailW);
    }
    const obsLineH = 4.5;
    const obsExtraLines = Math.max(0, obsLinesHeader.length - 1);
    // Dirección del cliente debajo del nombre — solo si viene informada.
    // Envuelve hasta 2 renglones sin encimar la columna derecha.
    const dirAvailW = colRightX - (marginLeft + 28) - 3;
    const dirLinesCli = direccionCliente
      ? doc.splitTextToSize(direccionCliente, dirAvailW).slice(0, 2)
      : [];
    const dirOffset = dirLinesCli.length * 5;
    // Min 36mm: ahora el Monarch va bajo Marca (col. izq.), un renglón más abajo.
    const cardH = Math.max(36, 33 + obsLinesHeader.length * obsLineH) + dirOffset;

    doc.setDrawColor(...borderColor);
    doc.setFillColor(...lightBg);
    doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
    doc.setDrawColor(0);

    // Columna izquierda
    const lblX_L = marginLeft + 3;
    const valX_L = marginLeft + 28;
    const baseY = cardY + 6;
    drawLabel("Fecha:", fecha, lblX_L, valX_L, baseY);
    drawLabel("Cliente:", clientes, lblX_L, valX_L, baseY + 5);
    if (dirLinesCli.length) {
      drawLabel("Dirección:", dirLinesCli[0], lblX_L, valX_L, baseY + 10);
      if (dirLinesCli[1]) doc.text(dirLinesCli[1], valX_L, baseY + 14.5);
    }
    drawLabel("Comprador:", nombreComprador, lblX_L, valX_L, baseY + 10 + dirOffset);
    drawLabel("Puesto:", puestoComprador, lblX_L, valX_L, baseY + 15 + dirOffset);
    drawLabel("Marca:", marcas, lblX_L, valX_L, baseY + 20 + dirOffset);
    // (2026-07) Monarch (Observaciones Monarch) en un renglón DEBAJO de Marca
    if (obsLinesHeader.length) {
      const monarchY = baseY + 25 + dirOffset;
      doc.setFont(undefined, "bold");
      doc.setTextColor(...labelColor);
      doc.setFontSize(8.5);
      doc.text("Monarch:", lblX_L, monarchY);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9.5);
      obsLinesHeader.forEach((line, i) => {
        doc.text(line, valX_L, monarchY + i * obsLineH);
      });
    }

    // Columna derecha
    drawLabel("Pedido:", numero, lblX_R, valX_R, baseY);
    drawLabel("Vendedor:", nombreFirma, lblX_R, valX_R, baseY + 5);
    drawLabel("Puesto:", puestoFirma, lblX_R, valX_R, baseY + 10);
    // L87 (2026-06) — Fecha Entrega: debajo del Puesto (derecha)
    drawLabel("Entrega:", fecha_cancelacion, lblX_R, valX_R, baseY + 15);

    currentY = cardY + cardH + 6;

    let totalPiezasGlobal = 0;
    let totalDineroGlobal = 0;

    // ============ AGRUPAR: ÁREA → (MODELO+TELA) — L30 (2026-06) ============
    const porArea = {};
    const ordenAreas = [];
    // (2026-07) info de cada grupo (área + departamento). El grupo de primer nivel
    // ahora es ÁREA + DEPARTAMENTO, para NO juntar en la misma banda artículos con
    // departamento distinto (DAMA/CABALLERO).
    const grupoInfo = {};

    // L41 (2026-06) — Recolectar bordados por sucursal/área/articulo
    const bordadosMap = {};
    const getBordadosPDFOCPorArea = (a) => {
      if (!Array.isArray(a?.bordados)) return [];
      return a.bordados
        .map((b) => ({
          observacion: s(b?.observacion || b?.observaciones || b?.name || b?.descripcion || ""),
          public_id: s(b?.public_id || b?.secure_url || b?.url || ""),
          version: s(b?.version || ""),
        }))
        .filter((b) => b.public_id || b.observacion);
    };

    // (2026-07) Orden de impresión capturado (campo `orden`): orden>0 primero,
    // los demás al final (sort estable).
    allArticulosPedido.sort(
      (a, b) =>
        (Number(a?.orden) > 0 ? Number(a.orden) : Infinity) -
        (Number(b?.orden) > 0 ? Number(b.orden) : Infinity)
    );
    allArticulosPedido.forEach((a) => {
      const areaSan =
        getFirstName(a.areasClientes) || getFirstId(a.areasClientes) || "Sin Área";
      const articuloSan =
        `${getArticuloCodigo(a)} ${getArticuloDepto(a)}`.trim() || "Artículo sin nombre";
      const tela = getTela(a) || "Sin Tela";

      // (2026-07) El grupo de primer nivel es ÁREA + DEPARTAMENTO (DAMA/CABALLERO):
      // si el departamento difiere, NO se juntan en la misma banda.
      const deptoSan =
        s(a?.articulos?.[0]?.departamentos?.[0]?.name) || "Sin Departamento";
      const grupoKey = `${areaSan}||${deptoSan}`;
      if (!porArea[grupoKey]) {
        porArea[grupoKey] = {};
        ordenAreas.push(grupoKey);
        grupoInfo[grupoKey] = { area: areaSan, depto: deptoSan };
      }
      // (2026-09) El precio entra en la clave: un mismo artículo con dos
      // precios (p. ej. tallas extra grandes) sale como dos bloques, cada uno
      // con el suyo, en vez de tomar el del primer renglón para todo.
      const precioSan = sn(a?.precio, 0);
      const subKey = `${articuloSan}||${tela}||${precioSan}`;
      if (!porArea[grupoKey][subKey]) porArea[grupoKey][subKey] = [];
      porArea[grupoKey][subKey].push(a);

      // L41 — colectar bordados (clave: area + articulo)
      const bordadosArt = getBordadosPDFOCPorArea(a);
      if (bordadosArt.length > 0) {
        const bordadoKey = `${areaSan}||${articuloSan}`;
        if (!bordadosMap[bordadoKey]) {
          bordadosMap[bordadoKey] = { area: areaSan, articulo: articuloSan, bordados: [] };
        }
        bordadosArt.forEach((b) => {
          const existe = bordadosMap[bordadoKey].bordados.some(
            (x) =>
              x.public_id === b.public_id &&
              x.observacion === b.observacion &&
              x.version === b.version
          );
          if (!existe) bordadosMap[bordadoKey].bordados.push(b);
        });
      }
    });

    // (2026-08) Los bordados suelen quedar en renglones con cantidad 0 y el
    // endpoint del pedido solo devuelve cantidad > 0: se traen aparte para que
    // la hoja de bordados no salga vacía.
    if (incluirBordados) {
      try {
        const { data: extrasBordados } = await axios.get(
          `${URL_ARTICULOS_PEDIDO}/bordadosPedido/${idPDFOC}`,
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        (extrasBordados || []).forEach((a) => {
          const bordadosArt = getBordadosPDFOCPorArea(a);
          if (!bordadosArt.length) return;
          const areaX = s(a?.areasClientes?.[0]?.name) || "Sin Área";
          // (2026-09) El nombre se arma igual que arriba (código + línea con un
          // espacio). Antes se unía con " - " y el mismo artículo quedaba en dos
          // claves distintas ("3677 SACO M/L" y "3677 - SACO M/L"), así que su
          // bordado salía repetido en la ficha.
          const artX =
            `${getArticuloCodigo(a)} ${getArticuloDepto(a)}`.trim() ||
            "Artículo sin nombre";
          const key = `${areaX}||${artX}`;
          if (!bordadosMap[key]) {
            bordadosMap[key] = { area: areaX, articulo: artX, bordados: [] };
          }
          bordadosArt.forEach((b) => {
            const existe = bordadosMap[key].bordados.some(
              (x) =>
                x.public_id === b.public_id &&
                x.observacion === b.observacion &&
                x.version === b.version
            );
            if (!existe) bordadosMap[key].bordados.push(b);
          });
        });
      } catch (e) {
        console.warn("No se pudieron cargar bordados extra:", e);
      }
    }

    // (2026-07) Mantener las áreas en su orden original, pero separar cada
    // departamento en su propia banda (ordenado por departamento dentro del área).
    const areaOrden = [];
    ordenAreas.forEach((k) => {
      const ar = grupoInfo[k]?.area;
      if (ar && !areaOrden.includes(ar)) areaOrden.push(ar);
    });
    ordenAreas.sort((k1, k2) => {
      const g1 = grupoInfo[k1] || {};
      const g2 = grupoInfo[k2] || {};
      const ai = areaOrden.indexOf(g1.area) - areaOrden.indexOf(g2.area);
      if (ai !== 0) return ai;
      return String(g1.depto || "").localeCompare(String(g2.depto || ""), "es", {
        sensitivity: "base",
      });
    });

    // ============ RECORRER POR ÁREA + DEPARTAMENTO ============
    for (const grupoKey of ordenAreas) {
      const { area: areaNombre, depto: deptoArea } = grupoInfo[grupoKey] || {};
      // === BANDA ÁREA (banda azul gruesa, una por área + departamento) ===
      // Fix — reservar la banda de ÁREA + el arranque de su primer artículo (banda +
      // obs + encabezado de tabla + ~2 filas) para que la banda de área no quede sola.
      ensureRoom(55);
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, 9, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(12);
      const bandTxtArea =
        deptoArea && deptoArea !== "Sin Departamento"
          ? `ÁREA: ${s(areaNombre) || "Sin Área"}   ·   DEPTO: ${deptoArea}`
          : `ÁREA: ${s(areaNombre) || "Sin Área"}`;
      doc.text(bandTxtArea, marginLeft + 3, currentY + 6.3);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      currentY += 12;

      // === Recorrer cada modelo+tela dentro del área+departamento ===
      const subgrupos = porArea[grupoKey];
      for (const subKey in subgrupos) {
        const grupo = subgrupos[subKey];
        const [articuloNombre, telaNombre] = subKey.split("||");

        const precioUnitario = sn(grupo[0]?.precio, 0);

        const observacionesArticuloGrupo = [
          ...new Set(
            grupo
              .map((a) => getObservacionesArticulo(a).trim())
              .filter((x) => x)
          ),
        ].join(" / ");

        // === Sub-banda Modelo · Tela + PRECIO derecha ===
        // Fix — mantener el TÍTULO del artículo con el ARRANQUE de su tabla (banda +
        // obs + encabezado + ~2 filas). Así la tabla llena lo que quepa en la hoja y
        // el resto se brinca solo (autoTable pagina el resto de las filas).
        const obsEstim = observacionesArticuloGrupo
          ? (Math.ceil(observacionesArticuloGrupo.length / 90) + 1) * 4.2
          : 1;
        ensureRoom(10 + obsEstim + 9 + 14);
        const bandH = 7;
        doc.setFillColor(225, 232, 240); // azul muy claro
        doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, bandH, "F");
        doc.setDrawColor(...brandColor);
        doc.setLineWidth(0.3);
        doc.line(marginLeft, currentY + bandH, pageWidth - marginLeft, currentY + bandH);
        doc.setLineWidth(0.2);
        doc.setDrawColor(0);
        doc.setTextColor(0);
        doc.setFont(undefined, "bold");
        doc.setFontSize(10);
        const bandTitle = `${s(articuloNombre) || "Artículo sin nombre"}   ·   Tela: ${s(telaNombre) || "Sin Tela"}`;
        doc.text(bandTitle, marginLeft + 3, currentY + bandH - 2);
        const precioStr = `PRECIO ${new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(precioUnitario)}`;
        doc.text(precioStr, pageWidth - marginLeft - 3, currentY + bandH - 2, { align: "right" });
        doc.setTextColor(0);
        doc.setFont(undefined, "normal");
        currentY += bandH + 3;

      // ===== OBSERVACIONES DEL ARTÍCULO (italic gris claro) =====
      if (observacionesArticuloGrupo) {
        doc.setFont(undefined, "italic");
        doc.setTextColor(...labelColor);
        doc.setFontSize(9);
        const maxWidthObsArticulo = pageWidth - marginLeft * 2;
        const obsArticuloLines = doc.splitTextToSize(
          `Observaciones del artículo: ${observacionesArticuloGrupo}`,
          maxWidthObsArticulo
        );
        const obsArticuloHeight = obsArticuloLines.length * 4.2;
        ensureRoom(obsArticuloHeight + 2);
        doc.text(obsArticuloLines, marginLeft + 2, currentY);
        currentY += obsArticuloHeight + 3;
        doc.setFont(undefined, "normal");
        doc.setTextColor(0);
      } else {
        currentY += 1;
      }

      doc.setFont(undefined, "normal");
      doc.setFontSize(9);

      // ============ AGRUPAR POR COLOR -> VARIANTE -> TALLA ============
      const data = {};
      const totalVariante = {};
      const tallasMap = new Map();

      grupo.forEach((a) => {
        const color = getFirstName(a.colores) || "Sin color";
        const tallaName = s(a?.tallas?.[0]?.name?.trim()) || "Sin talla";
        const varianteNameRaw = s(a?.tallas?.[0]?.variantesTallas?.[0]?.name?.trim());
        const varianteName = varianteNameRaw ? varianteNameRaw : "Sin variante";
        const cantidad = sn(a?.cantidad, 0);

        if (!data[color]) data[color] = {};
        if (!data[color][varianteName]) data[color][varianteName] = {};
        if (!data[color][varianteName][tallaName]) data[color][varianteName][tallaName] = 0;
        data[color][varianteName][tallaName] += cantidad;

        if (!totalVariante[color]) totalVariante[color] = {};
        if (!totalVariante[color][varianteName]) totalVariante[color][varianteName] = 0;
        totalVariante[color][varianteName] += cantidad;

        tallasMap.set(tallaName, true);
      });

      Object.keys(data).forEach((color) => {
        Object.keys(data[color] || {}).forEach((variante) => {
          const tot = sn(totalVariante?.[color]?.[variante], 0);
          if (tot <= 0) {
            delete data[color][variante];
            if (totalVariante[color]) delete totalVariante[color][variante];
          }
        });
        if (!Object.keys(data[color] || {}).length) {
          delete data[color];
          delete totalVariante[color];
        }
      });

      const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];

      const tallasOrdenadas = Array.from(tallasMap.keys()).sort((a, b) => {
        const indexA = ordenTallas.indexOf(a);
        const indexB = ordenTallas.indexOf(b);
        return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
      });

      let totalPiezasGrupo = 0;
      Object.keys(totalVariante || {}).forEach((color) => {
        Object.keys(totalVariante[color] || {}).forEach((variante) => {
          totalPiezasGrupo += sn(totalVariante[color][variante], 0);
        });
      });

      totalPiezasGlobal += totalPiezasGrupo;
      totalDineroGlobal = sn(total_general, 0);

      const usableWidth = pageWidth - marginLeft * 2;
      const colorW = 30;
      const totalW = 12;
      const minTallaW = 5.8;

      const maxTallasPerRow = Math.max(
        1,
        Math.floor((usableWidth - colorW - totalW) / minTallaW)
      );

      const chunkSize = Math.max(1, Math.min(maxTallasPerRow, tallasOrdenadas.length));
      const tallasChunks = chunk(tallasOrdenadas, chunkSize);
      const colores = Object.keys(data);

      for (let ci = 0; ci < tallasChunks.length; ci++) {
        const chunkTallas = tallasChunks[ci];
        const nTallas = chunkTallas.length;
        const tallaW = (usableWidth - colorW - totalW) / Math.max(1, nTallas);

        const colStyles = {
          0: { cellWidth: colorW },
          [1 + nTallas]: { cellWidth: totalW },
        };

        for (let i = 0; i < nTallas; i++) {
          colStyles[1 + i] = { cellWidth: tallaW };
        }

        const headChunk = [["Color", ...chunkTallas, "Total"]];
        const bodyChunk = [];

        for (const color of colores) {
          const variantesRaw = Object.keys(data[color] || {});
          const variantes = variantesRaw.sort((a, b) => {
            const aSin = isSinVar(a);
            const bSin = isSinVar(b);

            if (aSin && !bSin) return -1;
            if (!aSin && bSin) return 1;

            const cleanA = s(a).trim();
            const cleanB = s(b).trim();

            const baseA = cleanA.split(/[+-]/)[0].trim();
            const baseB = cleanB.split(/[+-]/)[0].trim();

            const baseCompare = collatorES.compare(baseA, baseB);
            if (baseCompare !== 0) return baseCompare;

            const aHasPlus = cleanA.includes("+");
            const bHasPlus = cleanB.includes("+");
            const aHasMinus = cleanA.includes("-");
            const bHasMinus = cleanB.includes("-");

            if (aHasPlus && !bHasPlus) return -1;
            if (!aHasPlus && bHasPlus) return 1;

            if (aHasMinus && !bHasMinus) return -1;
            if (!aHasMinus && bHasMinus) return 1;

            const numA = parseInt(cleanA.match(/[+-]\s*(\d+)/)?.[1] || 0, 10);
            const numB = parseInt(cleanB.match(/[+-]\s*(\d+)/)?.[1] || 0, 10);

            return numA - numB;
          });

          let firstVar = true;

          for (const variante of variantes) {
            const totVar = sn(totalVariante?.[color]?.[variante], 0);
            if (totVar <= 0) continue;

            const row = new Array(1 + nTallas + 1).fill("");

            const tituloVar = isSinVar(variante) ? "" : s(variante);
            const colorTxt = firstVar ? s(color) : "";

            row[0] = tituloVar
              ? (colorTxt ? `${colorTxt}\n${tituloVar}` : tituloVar)
              : (colorTxt ? colorTxt : "");

            chunkTallas.forEach((talla, idx) => {
              const val = sn(data?.[color]?.[variante]?.[talla], 0);
              row[1 + idx] = val > 0 ? String(val) : "";
            });

            row[row.length - 1] = String(totVar);

            const tieneAlgoEnChunk =
              row.slice(1, 1 + nTallas).some((x) => String(x || "").trim() !== "") ||
              String(row[0] || "").trim() !== "";

            if (tieneAlgoEnChunk) bodyChunk.push(row);

            firstVar = false;
          }
        }

        ensureRoom(22);

        doc.autoTable({
          head: headChunk,
          body: bodyChunk,
          startY: currentY,
          margin: { left: marginLeft, right: marginLeft },
          tableWidth: usableWidth,
          // L29 (2026-06) — tabla profesional con zebra + color corporativo
          theme: "grid",
          styles: {
            fontSize: 10,
            cellPadding: 1.2,
            valign: "middle",
            halign: "center",
            overflow: "linebreak",
            lineColor: [210, 216, 224],
            lineWidth: 0.15,
          },
          headStyles: {
            fillColor: brandColor, // TF3 sigue brandColor (morado Donnatela)
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 10,
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: [251, 252, 253],
          },
          columnStyles: colStyles,
          didParseCell: (hookData) => {
            if (hookData.section === "body") {
              if (hookData.column.index === 0) {
                hookData.cell.styles.halign = "left";
                hookData.cell.styles.fontStyle = "bold";
              }
              if (hookData.column.index === hookData.row.cells.length - 1) {
                hookData.cell.styles.fontStyle = "bold";
                hookData.cell.styles.textColor = brandColor; // TF3
              }
            }
          },
        });

        currentY = doc.autoTable.previous.finalY + 4;

        if (tallasChunks.length > 1) {
          doc.setFontSize(8);
          doc.setFont(undefined, "italic");
          doc.text(
            `Tallas ${ci + 1}/${tallasChunks.length}`,
            pageWidth - marginLeft,
            currentY,
            { align: "right" }
          );
          doc.setFont(undefined, "normal");
          currentY += 5;
        }
      }

      // L29 (2026-06) — Total Artículo como chip
      ensureRoom(10);
      const chipText = `TOTAL ARTÍCULO: ${totalPiezasGrupo}`;
      doc.setFontSize(9.5);
      doc.setFont(undefined, "bold");
      const chipPad = 3;
      const chipW = doc.getTextWidth(chipText) + chipPad * 2;
      const chipH = 6;
      const chipX = pageWidth - marginLeft - chipW;
      doc.setFillColor(245, 247, 250);
      doc.setDrawColor(...brandColor);
      doc.setLineWidth(0.3);
      doc.roundedRect(chipX, currentY, chipW, chipH, 1.5, 1.5, "FD");
      doc.setLineWidth(0.2);
      doc.setTextColor(...brandColor);
      doc.text(chipText, chipX + chipPad, currentY + chipH - 1.7);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      doc.setDrawColor(0);
      currentY += chipH + 3;

      ensureRoom(4);
      doc.setDrawColor(210, 216, 224);
      doc.line(marginLeft, currentY, pageWidth - marginLeft, currentY);
      doc.setDrawColor(0);
      currentY += 5;
      } // ← cierre del for (const subKey in subgrupos)
      currentY += 3;
    } // ← cierre del for (const areaNombre of ordenAreas) — L30

    // ============ RESUMEN GENERAL — L29 mini-tabla bordada ============
    ensureRoom(45);

    const impuestosSi = String(impuestos || "").trim().toUpperCase() !== "NO";
    const subtotal = sn(totalDineroGlobal, 0);
    const iva = impuestosSi ? subtotal * 0.16 : 0;
    const totalConIVA = subtotal + iva;
    const fmtMoney = (n) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(n);

    doc.setFont(undefined, "bold");
    doc.setFontSize(11);
    doc.setTextColor(...brandColor);
    doc.text("RESUMEN GENERAL", pageWidth - marginLeft, currentY, { align: "right" });
    doc.setTextColor(0);
    currentY += 3;

    const resumenRows = [
      ["Piezas totales", `${totalPiezasGlobal}`],
      ["Subtotal", fmtMoney(subtotal)],
    ];
    if (impuestosSi) {
      resumenRows.push(["IVA (16%)", fmtMoney(iva)]);
      resumenRows.push(["Total", fmtMoney(totalConIVA)]);
    } else {
      resumenRows.push(["Total", fmtMoney(subtotal)]);
    }

    const resumenW = 95;
    const resumenLabelW = 45;
    const resumenX = pageWidth - marginLeft - resumenW;

    doc.autoTable({
      startY: currentY,
      margin: { left: resumenX, right: marginLeft },
      tableWidth: resumenW,
      body: resumenRows,
      theme: "grid",
      styles: {
        fontSize: 10,
        cellPadding: 1.5,
        lineColor: [210, 216, 224],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: {
          cellWidth: resumenLabelW,
          fillColor: [245, 247, 250],
          textColor: [110, 120, 135],
          fontStyle: "bold",
        },
        1: {
          cellWidth: resumenW - resumenLabelW,
          halign: "right",
        },
      },
      didParseCell: (h) => {
        if (h.row.index === resumenRows.length - 1) {
          h.cell.styles.fillColor = brandColor;
          h.cell.styles.textColor = [255, 255, 255];
          h.cell.styles.fontStyle = "bold";
          h.cell.styles.fontSize = 11;
        }
      },
    });

    currentY = doc.autoTable.previous.finalY + 8;

    // ============ CONDICIONES + FIRMAS — se mantienen JUNTAS; si no caben en lo que
    // queda de la hoja se REDUCEN (escala) para caber igual, en vez de saltar a una
    // hoja aparte casi vacía solo con las firmas. ============
    const condiciones = s(condicionesPedido).trim().replace(/\t/g, "  ").replace(/\r/g, "");

    // Medir el contenido de condiciones (a tamaño normal) para el alto total del bloque
    doc.setFont(undefined, "normal");
    doc.setFontSize(9);
    const condMaxWidth = pageWidth - marginLeft * 2;
    const condLines = condiciones
      ? doc.splitTextToSize(condiciones, condMaxWidth - 12)
      : [];
    const condBlockH = condLines.length * 4.2;
    const condTotalH = condiciones ? 6 + condBlockH + 5 + 9 : 0; // banda + caja + gap
    const firmaH = 8 + 5 + 5 + 4 + 4; // gap + línea + etiquetas + nombre + puesto
    const tailNeeded = condTotalH + firmaH;

    // ¿Cabe en lo que queda de la hoja? Si no, reducir la impresión (escala) para que
    // quepa; si ni reducido cabe, entonces sí una hoja nueva (con TODO junto).
    const restante = pageHeight - marginBottom - currentY;
    let esc = 1;
    if (tailNeeded > 0 && restante < tailNeeded) {
      if (restante >= tailNeeded * 0.6) {
        esc = restante / tailNeeded;
      } else {
        doc.addPage();
        currentY = marginTop;
      }
    }

    // --- CONDICIONES (banda + caja) ---
    if (condiciones) {
      const bh = 6 * esc;
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, bh, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10 * esc);
      doc.text(
        "CONDICIONES DE LA COTIZACIÓN",
        marginLeft + 3,
        currentY + bh - 1.8 * esc
      );
      doc.setTextColor(0);
      currentY += bh;

      doc.setFont(undefined, "normal");
      doc.setFontSize(9 * esc);
      const boxH = condBlockH * esc + 5 * esc;
      doc.setFillColor(245, 247, 250);
      doc.setDrawColor(210, 216, 224);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, boxH, "FD");
      doc.setDrawColor(0);
      doc.text(condLines, marginLeft + 3, currentY + 4 * esc);
      currentY += boxH + 9 * esc;
    }

    // --- FIRMAS — Cliente y Vendedor centradas ---
    const lineWidth = 70;
    currentY += 8 * esc;
    const leftCenterX = pageWidth / 4;
    const rightCenterX = (pageWidth * 3) / 4;
    const leftStartX = leftCenterX - lineWidth / 2;
    const rightStartX = rightCenterX - lineWidth / 2;
    doc.setDrawColor(0);
    doc.line(leftStartX, currentY, leftStartX + lineWidth, currentY);
    doc.line(rightStartX, currentY, rightStartX + lineWidth, currentY);
    currentY += 5 * esc;
    doc.setFont(undefined, "bold");
    doc.setFontSize(11 * esc);
    doc.text("FIRMA CLIENTE", leftCenterX, currentY, { align: "center" });
    doc.text("FIRMA VENDEDOR", rightCenterX, currentY, { align: "center" });
    currentY += 5 * esc;
    doc.setFont(undefined, "normal");
    doc.setFontSize(9 * esc);
    const nombreCli = s(nombreComprador).trim();
    const puestoCli = s(puestoComprador).trim();
    const nombreVen = s(nombreFirma).trim();
    const puestoVen = s(puestoFirma).trim();
    if (nombreCli) doc.text(nombreCli, leftCenterX, currentY, { align: "center" });
    if (nombreVen) doc.text(nombreVen, rightCenterX, currentY, { align: "center" });
    currentY += 4 * esc;
    if (puestoCli) doc.text(puestoCli, leftCenterX, currentY, { align: "center" });
    if (puestoVen) doc.text(puestoVen, rightCenterX, currentY, { align: "center" });

    // ============ BORDADOS — L41 (2026-06) ============
    // Misma página dedicada y mismo imgSize que PDFOCResumen
    const bordadosFinal = Object.values(bordadosMap);
    if (incluirBordados && bordadosFinal.length > 0) {
      const getCloudinaryUrl = (publicId) => {
        const p = s(publicId).trim();
        if (!p) return "";
        if (p.startsWith("http")) return p;
        const base = String(process.env.REACT_APP_URL_FOTO_CLOUDINARY || "")
          .replace(/\/$/, "")
          .replace(/\/image\/upload$/, "");
        return base
          ? `${base}/image/upload/${p}`
          : `https://res.cloudinary.com/lynqro/image/upload/${p}`;
      };
      const loadImagePDF = (src) =>
        new Promise((resolve) => {
          if (!src) return resolve(null);
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = () => {
            try {
              const canvas = document.createElement("canvas");
              canvas.width = img.width;
              canvas.height = img.height;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0);
              resolve(canvas.toDataURL("image/png"));
            } catch (e) {
              resolve(null);
            }
          };
          img.onerror = () => resolve(null);
          img.src = src;
        });

      // ===== FICHA TÉCNICA DE BORDADOS (estilo Word: rejilla con bordes) =====
      await dibujarFichaBordados(
        doc,
        bordadosFinal,
        {
          getCloudinaryUrl,
          loadImagePDF,
          ensureRoom,
          pageWidth,
          marginLeft,
          marginTop,
          brandColor,
          lightBg,
          borderColor,
          labelColor,
          s,
        }
      );
    }

    // ============ FOOTER L29 — Pedido + cliente + paginación en cada página ============
    const pageCount = doc.internal.getNumberOfPages();
    for (let p = 1; p <= pageCount; p++) {
      doc.setPage(p);
      doc.setFontSize(8);
      doc.setTextColor(...labelColor);
      doc.text(
        `Pedido #${s(numero)}  ·  ${s(clientes)}  ·  Página ${p} de ${pageCount}`,
        pageWidth / 2,
        pageHeight - 5,
        { align: "center" }
      );
      doc.setTextColor(0);
    }

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDFOC:", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
}


async function PDFOCResumen(
  fecha,
  colaboradores,
  fecha_cancelacion,
  fecha_confirmacion,
  idClientes,
  clientes,
  pedidoCliente,
  total_kilos,
  total_metros,
  total_general,
  observaciones,
  numero,
  idPDFOC,
  condicionesPedido,
  nombreFirma,
  puestoFirma,
  nombreComprador,
  puestoComprador,
  impuestos,
  marcas,
  incluirBordados = true,
  // L95 (2026-06) — datos fiscales de la empresa propia (igual que el PDF azul)
  empresa = null,
  direccionCliente = ""
) {
  // === Helpers para sanear ===
  const s = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return "";
    return typeof v === "string" ? v : String(v);
  };

  const sn = (v, def = 0) => {
    if (v === null || v === undefined) return def;
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return def;
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  const money = (n) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(sn(n, 0));

  const getFirstName = (arr) => s(arr?.[0]?.name);
  const getFirstAlias = (arr) => s(arr?.[0]?.alias);
  const getFirstId = (arr) => s(arr?.[0]?._id);

  const getArticuloCodigo = (a) => s(a?.articulos?.[0]?.codigo);

  const getArticuloNombre = (a) =>
    s(a?.articulos?.[0]?.subDepartamentos?.[0]?.name || "");

  const getColor = (a) => getFirstName(a?.colores) || "Sin color";

  const getDepartamento = (a) =>
    s(a?.articulos?.[0]?.departamentos?.[0]?.name) || "Sin Departamento";

  const getSucursal = (a) =>
    getFirstAlias(a?.sucursales) ||
    getFirstName(a?.sucursales) ||
    getFirstId(a?.sucursales) ||
    "Sin Sucursal";

  const getArticuloResumen = (a) => {
    const codigo = getArticuloCodigo(a);
    const nombre = getArticuloNombre(a);

    if (codigo && nombre) return `${codigo} - ${nombre}`;
    if (codigo) return codigo;
    if (nombre) return nombre;

    return "Artículo sin nombre";
  };

  const getCloudinaryUrl = (publicId) => {
    const p = s(publicId).trim();
    if (!p) return "";
    if (p.startsWith("http")) return p;

    const base = String(process.env.REACT_APP_URL_FOTO_CLOUDINARY || "")
      .replace(/\/$/, "")
      .replace(/\/image\/upload$/, "");

    return `${base}/image/upload/${p}`;
  };

  const loadImagePDF = (src) =>
    new Promise((resolve) => {
      if (!src) return resolve(null);

      const img = new Image();
      img.crossOrigin = "anonymous";

      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          const dataUrl = canvas.toDataURL("image/png");
          resolve(dataUrl);
        } catch (e) {
          resolve(null);
        }
      };

      img.onerror = () => resolve(null);
      img.src = src;
    });

  const getBordados = (a) => {
    if (!Array.isArray(a?.bordados)) return [];

    return a.bordados
      .map((b) => ({
        observacion: s(
          b?.observacion ||
            b?.observaciones ||
            b?.name ||
            b?.descripcion ||
            ""
        ),
        public_id: s(b?.public_id || b?.secure_url || b?.url || ""),
        version: s(b?.version || ""),
      }))
      .filter((b) => b.public_id || b.observacion);
  };

  try {
    const { data: allArticulosPedido } = await axios.get(
      `${URL_ARTICULOS_PEDIDO}/pedidos/${idPDFOC}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const doc = new jsPDF();

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 12;
    const marginTop = 15;
    const marginBottom = 15;

    // === L41 (2026-06) — Paleta y helpers de diseño (mismo estilo PDFOCPorArea) ===
    // L114 (2026-06) — morado si la empresa es UNIFORMES INNOVACIÓN (logo Donnatela)
    const brandColor = /Donnatela/i.test(logoInstSrc(empresa))
      ? [120, 88, 168]
      : [42, 90, 138];
    const lightBg = [245, 247, 250];
    const borderColor = [210, 216, 224];
    const labelColor = [110, 120, 135];
    const stripeBg = [251, 252, 253];

    const drawLabel = (label, value, lblX, valX, y) => {
      doc.setFont(undefined, "bold");
      doc.setTextColor(...labelColor);
      doc.setFontSize(8);
      doc.text(label, lblX, y);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9);
      const txt = s(value).trim();
      doc.text(txt || "—", valX, y);
    };

    let currentY = 68;

    const ensureRoom = (needed) => {
      if (currentY + needed > pageHeight - marginBottom) {
        doc.addPage();
        currentY = marginTop;
      }
    };

    // ============ LOGO IZQUIERDA + TÍTULO PEDIDO ============
    const img2 = new Image();
    img2.src = logoInstSrc(empresa); // L104
    await new Promise((resolve) => {
      img2.onload = () => {
        const maxH = /Donnatela/i.test(img2.src) ? 22 : 14; // L115 logo Donnatela más grande
        const scale = maxH / img2.height;
        const w = img2.width * scale;
        const h = img2.height * scale;
        doc.addImage(img2, "png", marginLeft, 8, w, h);
        resolve();
      };
      img2.onerror = () => resolve();
    });

    doc.setFont(undefined, "bold");
    doc.setFontSize(14);
    doc.setTextColor(...brandColor);
    doc.text(`PEDIDO # ${s(numero)}`, pageWidth - marginLeft, 16, { align: "right" });
    doc.setTextColor(0);

    // L95 (2026-06) — Datos fiscales de la empresa propia (igual que el PDF azul)
    if (empresa) {
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.setTextColor(60, 60, 60);
      doc.text(
        s(empresa.razonSocial) || s(empresa.name) || "",
        pageWidth - marginLeft,
        21,
        { align: "right" }
      );
      doc.setFont(undefined, "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(...labelColor);
      const fiscalLine = [
        empresa.rfc ? `RFC: ${s(empresa.rfc)}` : "",
        empresa.regimenFiscal ? `Rég. Fiscal: ${s(empresa.regimenFiscal)}` : "",
      ]
        .filter((x) => x)
        .join("   ·   ");
      if (fiscalLine) {
        doc.text(fiscalLine, pageWidth - marginLeft, 25, { align: "right" });
      }
      const direccionStr = [
        s(empresa.direccionFiscal),
        empresa.cp ? `C.P. ${s(empresa.cp)}` : "",
      ]
        .filter((x) => x)
        .join(", ");
      if (direccionStr) {
        const dirAvailW = pageWidth - marginLeft - (marginLeft + 60);
        const dirLines = doc.splitTextToSize(direccionStr, dirAvailW);
        dirLines.forEach((line, i) => {
          doc.text(line, pageWidth - marginLeft, 29 + i * 3.8, { align: "right" });
        });
      }
      doc.setTextColor(0);
    }

    // Línea divisoria azul (corre abajo si hay empresa para no encimar)
    const headerLineY = empresa ? 38 : 25;
    doc.setDrawColor(...brandColor);
    doc.setLineWidth(0.5);
    doc.line(marginLeft, headerLineY, pageWidth - marginLeft, headerLineY);
    doc.setLineWidth(0.2);
    doc.setDrawColor(0);

    // ============ CARD 2 COLUMNAS CON DATOS ============
    // L41 (2026-06) — Monarch ocupa cuantos renglones necesite
    doc.setFontSize(9);
    // (2026-07) Monarch va debajo de Marca (columna IZQUIERDA) → ancho de esa columna
    const obsAvailW = pageWidth / 2 + 5 - (marginLeft + 24) - 3;
    const obsText = s(observaciones).trim().replace(/\t/g, "  ").replace(/\r/g, "");
    let obsLinesHeader = [];
    if (obsText) {
      obsLinesHeader = doc.splitTextToSize(obsText, obsAvailW);
    }
    const obsLineH = 4.2;
    const extraObsLines = Math.max(0, obsLinesHeader.length - 1);

    // L95 (2026-06) — card baja si el header tiene datos de empresa
    const cardY = empresa ? 41 : 28;
    const cardW = pageWidth - marginLeft * 2;
    // Dirección del cliente debajo del nombre — solo si viene informada.
    // Envuelve hasta 2 renglones sin encimar la columna derecha.
    const dirAvailW = pageWidth / 2 + 5 - (marginLeft + 24) - 3;
    const dirLinesCli = direccionCliente
      ? doc.splitTextToSize(direccionCliente, dirAvailW).slice(0, 2)
      : [];
    const dirOffset = dirLinesCli.length * 4.5;
    // (2026-07) + espacio para el renglón Monarch bajo Marca (col. izquierda)
    const cardH = Math.max(33, 28 + obsLinesHeader.length * obsLineH) + dirOffset;
    doc.setDrawColor(...borderColor);
    doc.setFillColor(...lightBg);
    doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
    doc.setDrawColor(0);

    // Columna izquierda
    const lblX_L = marginLeft + 2;
    const valX_L = marginLeft + 24;
    const baseY = cardY + 5;
    drawLabel("Fecha:", fecha, lblX_L, valX_L, baseY);
    drawLabel("Cliente:", clientes, lblX_L, valX_L, baseY + 4.5);
    if (dirLinesCli.length) {
      drawLabel("Dirección:", dirLinesCli[0], lblX_L, valX_L, baseY + 9);
      if (dirLinesCli[1]) doc.text(dirLinesCli[1], valX_L, baseY + 13);
    }
    drawLabel("Comprador:", nombreComprador, lblX_L, valX_L, baseY + 9 + dirOffset);
    drawLabel("Puesto:", puestoComprador, lblX_L, valX_L, baseY + 13.5 + dirOffset);
    drawLabel("Marca:", marcas, lblX_L, valX_L, baseY + 18 + dirOffset);
    // (2026-07) Monarch (Observaciones Monarch) en un renglón DEBAJO de Marca
    if (obsLinesHeader.length) {
      const monarchY = baseY + 22.5 + dirOffset;
      doc.setFont(undefined, "bold");
      doc.setTextColor(...labelColor);
      doc.setFontSize(8);
      doc.text("Monarch:", lblX_L, monarchY);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9);
      obsLinesHeader.forEach((line, i) => {
        doc.text(line, valX_L, monarchY + i * obsLineH);
      });
    }

    // Columna derecha
    const colRightX = pageWidth / 2 + 5;
    const lblX_R = colRightX;
    const valX_R = colRightX + 22;
    drawLabel("Pedido:", numero, lblX_R, valX_R, baseY);
    drawLabel("Vendedor:", nombreFirma, lblX_R, valX_R, baseY + 4.5);
    drawLabel("Puesto:", puestoFirma, lblX_R, valX_R, baseY + 9);
    drawLabel("Entrega:", fecha_cancelacion, lblX_R, valX_R, baseY + 13.5);

    currentY = cardY + cardH + 5;

    // =========================================================
    // AGRUPAR POR AREA + DEPARTAMENTO
    // y resumir por ARTICULO + COLOR + PRECIO
    // =========================================================
    const grupos = {};
    const bordadosMap = {};

    // (2026-07) Orden de impresión capturado (campo `orden`): orden>0 primero,
    // los demás al final (sort estable).
    (allArticulosPedido || []).sort(
      (a, b) =>
        (Number(a?.orden) > 0 ? Number(a.orden) : Infinity) -
        (Number(b?.orden) > 0 ? Number(b.orden) : Infinity)
    );
    (allArticulosPedido || []).forEach((a) => {
      const area =
        getFirstName(a?.areasClientes) ||
        getFirstId(a?.areasClientes) ||
        "Sin Área";

      const sucursal = getSucursal(a);
      const departamento = getDepartamento(a);
      const articulo = getArticuloResumen(a);
      const color = getColor(a);
      const precio = sn(a?.precio, 0);
      const cantidad = sn(a?.cantidad, 0);
      const total = cantidad * precio;

      const bordadosArticulo = getBordados(a);

      if (bordadosArticulo.length > 0) {
        const bordadoKey = `${sucursal}||${area}||${articulo}`;

        if (!bordadosMap[bordadoKey]) {
          bordadosMap[bordadoKey] = {
            sucursal,
            area,
            articulo,
            bordados: [],
          };
        }

        bordadosArticulo.forEach((b) => {
          const existe = bordadosMap[bordadoKey].bordados.some(
            (x) =>
              x.public_id === b.public_id &&
              x.observacion === b.observacion &&
              x.version === b.version
          );

          if (!existe) {
            bordadosMap[bordadoKey].bordados.push(b);
          }
        });
      }

      const grupoKey = `${area}||${departamento}`;
      const rowKey = `${articulo}||${color}||${precio}`;

      if (!grupos[grupoKey]) {
        grupos[grupoKey] = {
          area,
          departamento,
          rows: {},
        };
      }

      if (!grupos[grupoKey].rows[rowKey]) {
        grupos[grupoKey].rows[rowKey] = {
          articulo,
          color,
          cantidad: 0,
          precio,
          total: 0,
        };
      }

      grupos[grupoKey].rows[rowKey].cantidad += cantidad;
      grupos[grupoKey].rows[rowKey].total += total;
    });

    // (2026-08) Los bordados suelen quedar en renglones con cantidad 0 y el
    // endpoint del pedido solo devuelve cantidad > 0: se traen aparte para que
    // la hoja de bordados no salga vacía.
    if (incluirBordados) {
      try {
        const { data: extrasBordados } = await axios.get(
          `${URL_ARTICULOS_PEDIDO}/bordadosPedido/${idPDFOC}`,
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        (extrasBordados || []).forEach((a) => {
          const bordadosArt = getBordados(a);
          if (!bordadosArt.length) return;
          const sucursalX = getSucursal(a);
          const areaX = getFirstName(a?.areasClientes) || "Sin Área";
          const articuloX = getArticuloResumen(a);
          const key = `${sucursalX}||${areaX}||${articuloX}`;
          if (!bordadosMap[key]) {
            bordadosMap[key] = {
              sucursal: sucursalX,
              area: areaX,
              articulo: articuloX,
              bordados: [],
            };
          }
          bordadosArt.forEach((b) => {
            const existe = bordadosMap[key].bordados.some(
              (x) =>
                x.public_id === b.public_id &&
                x.observacion === b.observacion &&
                x.version === b.version
            );
            if (!existe) bordadosMap[key].bordados.push(b);
          });
        });
      } catch (e) {
        console.warn("No se pudieron cargar bordados extra:", e);
      }
    }


    const gruposOrdenados = Object.values(grupos).sort((a, b) => {
      if (a.area !== b.area) {
        return a.area.localeCompare(b.area, "es", { sensitivity: "base" });
      }

      return a.departamento.localeCompare(b.departamento, "es", {
        sensitivity: "base",
      });
    });

    let totalPiezasGlobal = 0;
    let subtotalGlobal = 0;

    // ============ RECORRER GRUPOS ============
    for (const grupo of gruposOrdenados) {
      const rows = Object.values(grupo.rows).sort((a, b) => {
        if (a.articulo !== b.articulo) {
          return a.articulo.localeCompare(b.articulo, "es", {
            sensitivity: "base",
          });
        }

        return a.color.localeCompare(b.color, "es", { sensitivity: "base" });
      });

      const totalGrupoPiezas = rows.reduce(
        (acc, r) => acc + sn(r.cantidad, 0),
        0
      );

      const totalGrupoImporte = rows.reduce(
        (acc, r) => acc + sn(r.total, 0),
        0
      );

      totalPiezasGlobal += totalGrupoPiezas;
      subtotalGlobal += totalGrupoImporte;

      // L41 (2026-06) — Banda azul como header del grupo
      ensureRoom(22);
      const bandH = 7;
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, bandH, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      const bandTitle = `ÁREA: ${s(grupo.area) || "Sin Área"}   ·   DEPTO: ${s(grupo.departamento) || "Sin Departamento"}`;
      doc.text(bandTitle, marginLeft + 3, currentY + bandH - 2);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      currentY += bandH + 2;

      doc.setFont(undefined, "normal");
      doc.setFontSize(8);

      doc.autoTable({
        startY: currentY,
        margin: { left: marginLeft, right: marginLeft },
        theme: "grid",
        head: [["Artículo", "Color", "Cantidad", "Precio Unitario", "Total"]],
        body: rows.map((r) => [
          s(r.articulo),
          s(r.color),
          sn(r.cantidad, 0),
          money(r.precio),
          money(r.total),
        ]),
        foot: [
          [
            { content: "", styles: { halign: "left" } },
            { content: "Totales", styles: { halign: "right" } },
            { content: totalGrupoPiezas, styles: { halign: "center" } },
            { content: "", styles: { halign: "right" } },
            { content: money(totalGrupoImporte), styles: { halign: "right" } },
          ],
        ],
        // L41 (2026-06) — estilo profesional consistente con PDFOCPorArea
        styles: {
          fontSize: 8.5,
          cellPadding: 1.2,
          valign: "middle",
          overflow: "linebreak",
          lineColor: borderColor,
          lineWidth: 0.15,
          textColor: [0, 0, 0],
        },
        headStyles: {
          fillColor: brandColor,
          textColor: [255, 255, 255],
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          fontSize: 9,
        },
        alternateRowStyles: {
          fillColor: stripeBg,
        },
        footStyles: {
          fillColor: brandColor,
          textColor: [255, 255, 255],
          fontStyle: "bold",
        },
        columnStyles: {
          0: { cellWidth: 78, halign: "left" },
          1: { cellWidth: 32, halign: "center" },
          2: { cellWidth: 22, halign: "center" },
          3: { cellWidth: 24, halign: "right" },
          4: { cellWidth: 28, halign: "right" },
        },
      });

      currentY = doc.autoTable.previous.finalY + 6;

      // L41 — divisor sutil entre grupos
      doc.setDrawColor(...borderColor);
      doc.line(marginLeft, currentY - 2, pageWidth - marginLeft, currentY - 2);
      doc.setDrawColor(0);
      currentY += 2;
    }

    // ============ RESUMEN GENERAL — L41 mini-tabla bordada ============
    ensureRoom(40);

    const impuestosSi = String(impuestos || "").trim().toUpperCase() !== "NO";
    const subtotal = sn(subtotalGlobal, 0);
    const iva = impuestosSi ? subtotal * 0.16 : 0;
    const totalConIVA = subtotal + iva;

    doc.setFont(undefined, "bold");
    doc.setFontSize(10);
    doc.setTextColor(...brandColor);
    doc.text("RESUMEN GENERAL", pageWidth - marginLeft, currentY, { align: "right" });
    doc.setTextColor(0);
    currentY += 3;

    const resumenRows = [
      ["Piezas totales", `${totalPiezasGlobal}`],
      ["Subtotal", money(subtotal)],
    ];
    if (impuestosSi) {
      resumenRows.push(["IVA (16%)", money(iva)]);
      resumenRows.push(["Total", money(totalConIVA)]);
    } else {
      resumenRows.push(["Total", money(subtotal)]);
    }

    const resumenW = 85;
    const resumenLabelW = 38;
    const resumenX = pageWidth - marginLeft - resumenW;

    doc.autoTable({
      startY: currentY,
      margin: { left: resumenX, right: marginLeft },
      tableWidth: resumenW,
      body: resumenRows,
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 1.4,
        lineColor: borderColor,
        lineWidth: 0.2,
      },
      columnStyles: {
        0: {
          cellWidth: resumenLabelW,
          fillColor: lightBg,
          textColor: labelColor,
          fontStyle: "bold",
        },
        1: {
          cellWidth: resumenW - resumenLabelW,
          halign: "right",
        },
      },
      didParseCell: (h) => {
        if (h.row.index === resumenRows.length - 1) {
          h.cell.styles.fillColor = brandColor;
          h.cell.styles.textColor = [255, 255, 255];
          h.cell.styles.fontStyle = "bold";
          h.cell.styles.fontSize = 10;
        }
      },
    });

    currentY = doc.autoTable.previous.finalY + 8;

    // ============ CONDICIONES + FIRMAS — se mantienen JUNTAS; si no caben en lo que
    // queda de la hoja se REDUCEN (escala) para caber igual, en vez de saltar a una
    // hoja aparte casi vacía solo con las firmas. ============
    const condiciones = s(condicionesPedido).trim().replace(/\t/g, "  ").replace(/\r/g, "");

    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    const condMaxWidth = pageWidth - marginLeft * 2;
    const condLines = condiciones
      ? doc.splitTextToSize(condiciones, condMaxWidth - 10)
      : [];
    const condBlockH = condLines.length * 4;
    const condTotalH = condiciones ? 5.5 + condBlockH + 4 + 7 : 0;
    const firmaH = 6 + 5 + 5 + 4 + 4;
    const tailNeeded = condTotalH + firmaH;

    const restante = pageHeight - marginBottom - currentY;
    let esc = 1;
    if (tailNeeded > 0 && restante < tailNeeded) {
      if (restante >= tailNeeded * 0.6) {
        esc = restante / tailNeeded;
      } else {
        doc.addPage();
        currentY = marginTop;
      }
    }

    if (condiciones) {
      const bh = 5.5 * esc;
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, bh, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(9 * esc);
      doc.text(
        "CONDICIONES DE LA COTIZACIÓN",
        marginLeft + 3,
        currentY + bh - 1.7 * esc
      );
      doc.setTextColor(0);
      currentY += bh;

      doc.setFont(undefined, "normal");
      doc.setFontSize(8 * esc);
      const boxH = condBlockH * esc + 4 * esc;
      doc.setFillColor(...lightBg);
      doc.setDrawColor(...borderColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, boxH, "FD");
      doc.setDrawColor(0);
      doc.text(condLines, marginLeft + 3, currentY + 3 * esc);
      currentY += boxH + 7 * esc;
    }

    const lineWidth = 70;
    currentY += 6 * esc;
    const leftCenterX = pageWidth / 4;
    const rightCenterX = (pageWidth * 3) / 4;
    const leftStartX = leftCenterX - lineWidth / 2;
    const rightStartX = rightCenterX - lineWidth / 2;
    doc.setDrawColor(0);
    doc.line(leftStartX, currentY, leftStartX + lineWidth, currentY);
    doc.line(rightStartX, currentY, rightStartX + lineWidth, currentY);
    currentY += 5 * esc;
    doc.setFont(undefined, "bold");
    doc.setFontSize(11 * esc);
    doc.text("FIRMA CLIENTE", leftCenterX, currentY, { align: "center" });
    doc.text("FIRMA VENDEDOR", rightCenterX, currentY, { align: "center" });
    currentY += 5 * esc;
    doc.setFont(undefined, "normal");
    doc.setFontSize(9 * esc);
    const nombreCli = s(nombreComprador).trim();
    const puestoCli = s(puestoComprador).trim();
    const nombreVen = s(nombreFirma).trim();
    const puestoVen = s(puestoFirma).trim();
    if (nombreCli) doc.text(nombreCli, leftCenterX, currentY, { align: "center" });
    if (nombreVen) doc.text(nombreVen, rightCenterX, currentY, { align: "center" });
    currentY += 4 * esc;
    if (puestoCli) doc.text(puestoCli, leftCenterX, currentY, { align: "center" });
    if (puestoVen) doc.text(puestoVen, rightCenterX, currentY, { align: "center" });

    // =========================================================
    // SEGUNDA HOJA: BORDADOS
    // =========================================================
    const bordadosFinal = Object.values(bordadosMap);

  if (incluirBordados && bordadosFinal.length > 0) {
      // FICHA TÉCNICA DE BORDADOS (estilo Word: rejilla con bordes)
      await dibujarFichaBordados(doc, bordadosFinal, {
        getCloudinaryUrl,
        loadImagePDF,
        pageWidth,
        marginLeft,
        marginTop,
        brandColor,
        lightBg,
        borderColor,
        labelColor,
        s,
      });
    }

    // ============ FOOTER L41 — pie con paginación en cada página ============
    try {
      const pageCount = doc.internal.getNumberOfPages();
      for (let p = 1; p <= pageCount; p++) {
        doc.setPage(p);
        doc.setFontSize(8);
        doc.setTextColor(...labelColor);
        doc.text(
          `Pedido #${s(numero)}  ·  ${s(clientes)}  ·  Página ${p} de ${pageCount}`,
          pageWidth / 2,
          pageHeight - 5,
          { align: "center" }
        );
        doc.setTextColor(0);
      }
    } catch (errFooter) {
      console.warn("No se pudo dibujar footer:", errFooter);
    }

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDFOCResumen:", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
}

async function PDFOCSurtido(
  fecha,
  colaboradores,
  fecha_cancelacion,
  fecha_confirmacion,
  idClientes,
  clientes,
  pedidoCliente,
  total_kilos,
  total_metros,
  total_general,
  observaciones,
  numero,
  idSurtido,
  condicionesPedido,
  nombreFirma,
  puestoFirma,
  nombreComprador,
  puestoComprador,
  impuestos,
  direccionCliente = ""
) {
  // === Helpers para sanear ===
  const s = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return "";
    return typeof v === "string" ? v : String(v);
  };

  const sn = (v, def = 0) => {
    if (v === null || v === undefined) return def;
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return def;
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  const money = (n) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(sn(n, 0));

  const getFirstName = (arr) => s(arr?.[0]?.name);
  const getFirstId = (arr) => s(arr?.[0]?._id);

  const getArticuloCodigo = (a) => s(a?.articulos?.[0]?.codigo);

  const getArticuloNombre = (a) =>
    s(a?.articulos?.[0]?.name) ||
    s(a?.articulos?.[0]?.nombre) ||
    s(a?.articulos?.[0]?.descripcion);

  const getColor = (a) =>
    getFirstName(a?.colores) ||
    s(a?.colorFactura) ||
    "Sin color";

  // si en articulos surtidos viene "areas", usamos eso
const getArea = (a) =>
  s(a?.articulosPedido?.[0]?.areasClientes?.[0]?.name) || "Sin Área";

  // Departamento real: Dama / Caballero
  const getDepartamento = (a) =>
    s(a?.articulos?.[0]?.departamentos?.[0]?.name) || "Sin Departamento";

  const getArticuloResumen = (a) => {
    const codigo = getArticuloCodigo(a);
    const nombre = getArticuloNombre(a);

    if (codigo && nombre) return `${codigo} - ${nombre}`;
    if (codigo) return codigo;
    if (nombre) return nombre;

    return "Artículo sin nombre";
  };

  try {
    // =========================================================
    // TRAER ARTICULOS SURTIDOS DEL SURTIDO
    // =========================================================
    const { data: allArticulosSurtido } = await axios.get(
      `${URL_ARTICULOS_SURTIDOS}/pedido/${idSurtido}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const doc = new jsPDF();

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 12;
    const marginTop = 15;
    const marginBottom = 15;

    let currentY = 50;

    const ensureRoom = (needed) => {
      if (currentY + needed > pageHeight - marginBottom) {
        doc.addPage();
        currentY = marginTop;
      }
    };

    // ============ LOGO ============
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "/logoInstitucion.png";

    await new Promise((resolve) => {
      img2.onload = () => {
        const maxH = 16;
        const scale = maxH / img2.height;
        const w = img2.width * scale;
        const h = img2.height * scale;
        doc.addImage(img2, "png", (pageWidth - w) / 2, 8, w, h);
        resolve();
      };
      img2.onerror = () => resolve();
    });

    // ============ ENCABEZADO ============
    doc.setFontSize(9);

    doc.text(`Fecha: ${s(fecha)}`, marginLeft, 30);
    doc.text(`Cliente: ${s(clientes)}`, marginLeft, 35);
    // Dirección del cliente (debajo del nombre), solo si viene informada.
    let _yColIzq = 40;
    if (direccionCliente) {
      const _dirLines = doc.splitTextToSize(
        `Dirección: ${direccionCliente}`,
        110
      ).slice(0, 2);
      doc.text(_dirLines, marginLeft, _yColIzq);
      _yColIzq += _dirLines.length * 4.5 + 0.5;
    }
    doc.text(`Comprador: ${s(nombreComprador)}`, marginLeft, _yColIzq);
    doc.text(`Puesto: ${s(puestoComprador)}`, marginLeft, _yColIzq + 5);

    const rightX = pageWidth - marginLeft - 55;
    doc.text(`Pedido: ${s(numero)}`, rightX, 35);
    doc.text(`Vendedor: ${s(nombreFirma)}`, rightX, 40);
    doc.text(`Puesto: ${s(puestoFirma)}`, rightX, 45);
    // L87 (2026-06) — Fecha Entrega
    doc.text(`Entrega: ${s(fecha_cancelacion)}`, rightX, 50);

    // =========================================================
    // AGRUPAR POR AREA + DEPARTAMENTO
    // y resumir por ARTICULO + COLOR + PRECIO
    // =========================================================
    const grupos = {};

    (allArticulosSurtido || []).forEach((a) => {
      const area = getArea(a);
      const departamento = getDepartamento(a);
      const articulo = getArticuloResumen(a);
      const color = getColor(a);
      const precio = sn(a?.precio, 0);
      const cantidad = sn(a?.cantidad, 0);
      const total = sn(a?.total, cantidad * precio);

      const grupoKey = `${area}||${departamento}`;
      const rowKey = `${area}||${departamento}||${articulo}||${color}`;

      if (!grupos[grupoKey]) {
        grupos[grupoKey] = {
          area,
          departamento,
          rows: {},
        };
      }

      if (!grupos[grupoKey].rows[rowKey]) {
        grupos[grupoKey].rows[rowKey] = {
          articulo,
          color,
          cantidad: 0,
          precio,
          total: 0,
        };
      }

      grupos[grupoKey].rows[rowKey].cantidad += cantidad;
      grupos[grupoKey].rows[rowKey].total += total;
    });

    const gruposOrdenados = Object.values(grupos).sort((a, b) => {
      if (a.area !== b.area) {
        return a.area.localeCompare(b.area, "es", { sensitivity: "base" });
      }
      return a.departamento.localeCompare(b.departamento, "es", {
        sensitivity: "base",
      });
    });

    let totalPiezasGlobal = 0;
    let subtotalGlobal = 0;

    // ============ RECORRER GRUPOS ============
    for (const grupo of gruposOrdenados) {
      const rows = Object.values(grupo.rows).sort((a, b) => {
        if (a.articulo !== b.articulo) {
          return a.articulo.localeCompare(b.articulo, "es", {
            sensitivity: "base",
          });
        }
        return a.color.localeCompare(b.color, "es", { sensitivity: "base" });
      });

      const totalGrupoPiezas = rows.reduce(
        (acc, r) => acc + sn(r.cantidad, 0),
        0
      );

      const totalGrupoImporte = rows.reduce(
        (acc, r) => acc + sn(r.total, 0),
        0
      );

      totalPiezasGlobal += totalGrupoPiezas;
      subtotalGlobal += totalGrupoImporte;

      ensureRoom(18);

      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.text(`${s(grupo.area)} ${s(grupo.departamento)}`, marginLeft, currentY);
      currentY += 5;

      doc.setFont(undefined, "normal");
      doc.setFontSize(8);

      doc.autoTable({
        startY: currentY,
        margin: { left: marginLeft, right: marginLeft },
        theme: "grid",
        head: [["Artículo", "Color", "Cantidad", "Precio", "Total"]],
        body: rows.map((r) => [
          s(r.articulo),
          s(r.color),
          sn(r.cantidad, 0),
          money(r.precio),
          money(r.total),
        ]),
        foot: [[
          { content: "", styles: { halign: "left" } },
          { content: "Totales", styles: { halign: "right" } },
          { content: totalGrupoPiezas, styles: { halign: "center" } },
          { content: "", styles: { halign: "right" } },
          { content: money(totalGrupoImporte), styles: { halign: "right" } }
        ]],
        styles: {
          fontSize: 7.5,
          cellPadding: 1.2,
          valign: "middle",
          overflow: "linebreak",
          lineColor: [0, 0, 0],
          lineWidth: 0.2,
          textColor: [0, 0, 0],
        },
        headStyles: {
          fillColor: [41, 128, 186],
          textColor: [255, 255, 255],
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          lineColor: [0, 0, 0],
          lineWidth: 0.2,
        },
        bodyStyles: {
          lineColor: [0, 0, 0],
          lineWidth: 0.2,
        },
        footStyles: {
          fillColor: [230, 230, 230],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          lineColor: [0, 0, 0],
          lineWidth: 0.2,
        },
        columnStyles: {
          0: { cellWidth: 78, halign: "left" },
          1: { cellWidth: 32, halign: "center" },
          2: { cellWidth: 22, halign: "center" },
          3: { cellWidth: 24, halign: "right" },
          4: { cellWidth: 28, halign: "right" },
        },
      });

      currentY = doc.autoTable.previous.finalY + 8;

      ensureRoom(4);
      doc.setDrawColor(220);
      doc.line(marginLeft, currentY - 3, pageWidth - marginLeft, currentY - 3);
      doc.setDrawColor(0);
    }

    // ============ RESUMEN GENERAL ============
    ensureRoom(35);

    const impuestosSi = String(impuestos || "").trim().toUpperCase() !== "NO";
    const subtotal = sn(subtotalGlobal, 0);
    const iva = impuestosSi ? subtotal * 0.16 : 0;
    const totalConIVA = subtotal + iva;

    doc.setFont(undefined, "bold");
    doc.setFontSize(11);
    doc.text("RESUMEN GENERAL", marginLeft, currentY);
    currentY += 7;

    doc.setFont(undefined, "normal");
    doc.setFontSize(9);
    doc.text(`Piezas: ${totalPiezasGlobal}`, marginLeft, currentY);
    currentY += 5;

    doc.text(`Subtotal: ${money(subtotal)}`, marginLeft, currentY);
    currentY += 5;

    if (impuestosSi) {
      doc.text(`IVA (16%): ${money(iva)}`, marginLeft, currentY);
      currentY += 5;

      doc.text(`Total: ${money(totalConIVA)}`, marginLeft, currentY);
      currentY += 5;
    } else {
      doc.text(`Total: ${money(subtotal)}`, marginLeft, currentY);
      currentY += 5;
    }

    // ============ CONDICIONES ============
    const condiciones = s(condicionesPedido).trim();
    if (condiciones) {
      ensureRoom(10);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      doc.text("Condiciones de la Cotización:", marginLeft, currentY);
      currentY += 5;

      doc.setFont(undefined, "normal");
      doc.setFontSize(8);

      const maxWidth = pageWidth - marginLeft * 2;
      const lines = doc.splitTextToSize(condiciones, maxWidth);

      const lineHeight = 4;
      const blockHeight = lines.length * lineHeight;

      ensureRoom(blockHeight + 4);
      doc.text(lines, marginLeft, currentY, { maxWidth });
      currentY += blockHeight + 6;
    }

    // ============ OBSERVACIONES ============
    const observacionesTexto = s(observaciones).trim();
    if (observacionesTexto) {
      ensureRoom(10);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      doc.text("Observaciones:", marginLeft, currentY);
      currentY += 5;

      doc.setFont(undefined, "normal");
      doc.setFontSize(8);

      const maxWidthObs = pageWidth - marginLeft * 2;
      const obsLines = doc.splitTextToSize(observacionesTexto, maxWidthObs);

      const lineHeightObs = 4;
      const blockHeightObs = obsLines.length * lineHeightObs;

      ensureRoom(blockHeightObs + 4);
      doc.text(obsLines, marginLeft, currentY, { maxWidth: maxWidthObs });
      currentY += blockHeightObs + 8;
    }

    // ============ FIRMA ============
    const signatureGap = 10;
    const lineWidth = 90;

    ensureRoom(signatureGap + 12);

    currentY += signatureGap;
    doc.setFont(undefined, "bold");
    doc.setFontSize(10);
    doc.text("FIRMA CLIENTE", pageWidth / 2, currentY, { align: "center" });
    currentY += 8;

    const lineStartX = (pageWidth - lineWidth) / 2;
    const lineEndX = lineStartX + lineWidth;
    doc.setDrawColor(0);
    doc.line(lineStartX, currentY, lineEndX, currentY);

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDFOCSurtido:", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
}

async function PDFOCComparativo(
  fecha,
  colaboradores,
  fecha_cancelacion,
  fecha_confirmacion,
  idClientes,
  clientes,
  pedidoCliente,
  total_kilos,
  total_metros,
  total_general,
  observaciones,
  numero,
  idPedido,
  condicionesPedido,
  nombreFirma,
  puestoFirma,
  nombreComprador,
  puestoComprador,
  impuestos,
  direccionCliente = ""
) {
  // =========================
  // Helpers
  // =========================
  const s = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return "";
    return typeof v === "string" ? v : String(v);
  };

  const sn = (v, def = 0) => {
    if (v === null || v === undefined) return def;
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return def;
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  const money = (n) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(sn(n, 0));

  const getFirstName = (arr) => s(arr?.[0]?.name);
  const getFirstId = (arr) => s(arr?.[0]?._id);

  // ===== Pedido =====
  const getPedidoArea = (a) =>
    getFirstName(a?.areasClientes) ||
    getFirstId(a?.areasClientes) ||
    "Sin Área";

  const getPedidoArticuloCodigo = (a) => s(a?.articulos?.[0]?.codigo);

  const getPedidoArticuloNombre = (a) =>
    s(a?.articulos?.[0]?.name) ||
    s(a?.articulos?.[0]?.nombre) ||
    s(a?.articulos?.[0]?.descripcion);

  const getPedidoColor = (a) => getFirstName(a?.colores) || "Sin color";

  const getPedidoDepartamento = (a) =>
    s(a?.articulos?.[0]?.departamentos?.[0]?.name) || "Sin Departamento";

  const getPedidoArticuloResumen = (a) => {
    const codigo = getPedidoArticuloCodigo(a);
    const nombre = getPedidoArticuloNombre(a);

    if (codigo && nombre) return `${codigo} - ${nombre}`;
    if (codigo) return codigo;
    if (nombre) return nombre;
    return "Artículo sin nombre";
  };

  // ===== Surtido =====
  const getSurtidoArea = (a) =>
    s(a?.articulosPedido?.[0]?.areasClientes?.[0]?.name) ||
    s(a?.areas?.[0]?.name) ||
    "Sin Área";

  const getSurtidoArticuloCodigo = (a) => s(a?.articulos?.[0]?.codigo);

  const getSurtidoArticuloNombre = (a) =>
    s(a?.articulos?.[0]?.name) ||
    s(a?.articulos?.[0]?.nombre) ||
    s(a?.articulos?.[0]?.descripcion);

  const getSurtidoColor = (a) =>
    getFirstName(a?.colores) || s(a?.colorFactura) || "Sin color";

  const getSurtidoDepartamento = (a) =>
    s(a?.articulos?.[0]?.departamentos?.[0]?.name) || "Sin Departamento";

  const getSurtidoArticuloResumen = (a) => {
    const codigo = getSurtidoArticuloCodigo(a);
    const nombre = getSurtidoArticuloNombre(a);

    if (codigo && nombre) return `${codigo} - ${nombre}`;
    if (codigo) return codigo;
    if (nombre) return nombre;
    return "Artículo sin nombre";
  };

  try {
    // =========================
    // Traer pedido y surtido
    // =========================
    const [pedidoResp, surtidoResp] = await Promise.all([
      axios.get(`${URL_ARTICULOS_PEDIDO}/pedidos/${idPedido}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }),
      axios.get(`${URL_ARTICULOS_SURTIDOS}/pedido/${idPedido}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }),
    ]);

    const allArticulosPedido = pedidoResp.data || [];
    const allArticulosSurtido = surtidoResp.data || [];

    // =========================
    // TF6 — movimientos de producción del pedido (totales)
    //   (A) en procesos no recibida = Σ faltantes (cantidadSalida − cantidadEntrada)
    //   (B) entrada al almacén      = Σ total_cantidad de las EntradasAlmacen del pedido
    // =========================
    let totalEnProcesosNoRecibido = 0;
    let totalEntradaAlmacen = 0;
    try {
      const [salidaResp, entradaAlmResp] = await Promise.all([
        axios.get(`${URL_ARTICULOS_PROCESOS_SALIDA}/pedido/${idPedido}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }),
        axios.get(`${URL_ENTRADAS_ALMACEN}/pedido/${idPedido}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }),
      ]);
      (salidaResp.data || []).forEach((s) => {
        const falt =
          s && s.faltantes != null
            ? sn(s.faltantes, 0)
            : sn(s?.cantidadSalida, 0) - sn(s?.cantidadEntrada, 0);
        if (falt > 0) totalEnProcesosNoRecibido += falt;
      });
      (entradaAlmResp.data || []).forEach((e) => {
        totalEntradaAlmacen += sn(e?.total_cantidad, 0);
      });
    } catch (err) {
      console.warn(
        "TF6 — no se pudieron cargar movimientos de producción:",
        err
      );
    }

    // =========================
    // Unificar comparativo
    // =========================
    const grupos = {};

    // ---- pedido
    allArticulosPedido.forEach((a) => {
      const area = getPedidoArea(a);
      const departamento = getPedidoDepartamento(a);
      const articulo = getPedidoArticuloResumen(a);
      const color = getPedidoColor(a);
      const precio = sn(a?.precio, 0);
      const cantidadPedida = sn(a?.cantidad, 0);

      const grupoKey = `${area}||${departamento}`;
      const rowKey = `${articulo}||${color}||${precio}`;

      if (!grupos[grupoKey]) {
        grupos[grupoKey] = {
          area,
          departamento,
          rows: {},
        };
      }

      if (!grupos[grupoKey].rows[rowKey]) {
        grupos[grupoKey].rows[rowKey] = {
          articulo,
          color,
          precio,
          pedidas: 0,
          surtidas: 0,
        };
      }

      grupos[grupoKey].rows[rowKey].pedidas += cantidadPedida;
    });

    // ---- surtido
    allArticulosSurtido.forEach((a) => {
      const area = getSurtidoArea(a);
      const departamento = getSurtidoDepartamento(a);
      const articulo = getSurtidoArticuloResumen(a);
      const color = getSurtidoColor(a);
      const precio = sn(a?.precio, 0);
      const cantidadSurtida = sn(a?.cantidad, 0);

      const grupoKey = `${area}||${departamento}`;
      const rowKey = `${articulo}||${color}||${precio}`;

      if (!grupos[grupoKey]) {
        grupos[grupoKey] = {
          area,
          departamento,
          rows: {},
        };
      }

      if (!grupos[grupoKey].rows[rowKey]) {
        grupos[grupoKey].rows[rowKey] = {
          articulo,
          color,
          precio,
          pedidas: 0,
          surtidas: 0,
        };
      }

      grupos[grupoKey].rows[rowKey].surtidas += cantidadSurtida;
    });

    const gruposOrdenados = Object.values(grupos).sort((a, b) => {
      if (a.area !== b.area) {
        return a.area.localeCompare(b.area, "es", { sensitivity: "base" });
      }
      return a.departamento.localeCompare(b.departamento, "es", {
        sensitivity: "base",
      });
    });

    // =========================
    // PDF
    // =========================
    const doc = new jsPDF();

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 12;
    const marginTop = 15;
    const marginBottom = 15;

    let currentY = 50;

    const ensureRoom = (needed) => {
      if (currentY + needed > pageHeight - marginBottom) {
        doc.addPage();
        currentY = marginTop;
      }
    };

    // ============ LOGO ============
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "/logoInstitucion.png";

    await new Promise((resolve) => {
      img2.onload = () => {
        const maxH = 16;
        const scale = maxH / img2.height;
        const w = img2.width * scale;
        const h = img2.height * scale;
        doc.addImage(img2, "png", (pageWidth - w) / 2, 8, w, h);
        resolve();
      };
      img2.onerror = () => resolve();
    });

    // ============ ENCABEZADO ============
    doc.setFontSize(9);

    doc.text(`Fecha: ${s(fecha)}`, marginLeft, 30);
    doc.text(`Cliente: ${s(clientes)}`, marginLeft, 35);
    // Dirección del cliente (debajo del nombre), solo si viene informada.
    let _yColIzq = 40;
    if (direccionCliente) {
      const _dirLines = doc.splitTextToSize(
        `Dirección: ${direccionCliente}`,
        110
      ).slice(0, 2);
      doc.text(_dirLines, marginLeft, _yColIzq);
      _yColIzq += _dirLines.length * 4.5 + 0.5;
    }
    doc.text(`Comprador: ${s(nombreComprador)}`, marginLeft, _yColIzq);
    doc.text(`Puesto: ${s(puestoComprador)}`, marginLeft, _yColIzq + 5);

    const rightX = pageWidth - marginLeft - 55;
    doc.text(`Pedido: ${s(numero)}`, rightX, 35);
    doc.text(`Vendedor: ${s(nombreFirma)}`, rightX, 40);
    doc.text(`Puesto: ${s(puestoFirma)}`, rightX, 45);
    // L87 (2026-06) — Fecha Entrega
    doc.text(`Entrega: ${s(fecha_cancelacion)}`, rightX, 50);

    // título
    doc.setFont(undefined, "bold");
    doc.setFontSize(11);
    doc.text("COMPARATIVO PEDIDO VS SURTIDO", pageWidth / 2, 52, {
      align: "center",
    });

    currentY = 58;

    let totalPedidasGlobal = 0;
    let totalSurtidasGlobal = 0;
    let totalPendientesGlobal = 0;
    let subtotalPedidoGlobal = 0;
    let subtotalSurtidoGlobal = 0;

    // =========================
    // RECORRER GRUPOS
    // =========================
    for (const grupo of gruposOrdenados) {
      const rows = Object.values(grupo.rows)
        .map((r) => {
          const pendientes = sn(r.pedidas, 0) - sn(r.surtidas, 0);
          const totalPedido = sn(r.pedidas, 0) * sn(r.precio, 0);
          const totalSurtido = sn(r.surtidas, 0) * sn(r.precio, 0);

          return {
            ...r,
            pendientes,
            totalPedido,
            totalSurtido,
          };
        })
        .sort((a, b) => {
          if (a.articulo !== b.articulo) {
            return a.articulo.localeCompare(b.articulo, "es", {
              sensitivity: "base",
            });
          }
          return a.color.localeCompare(b.color, "es", {
            sensitivity: "base",
          });
        });

      const totalGrupoPedidas = rows.reduce((acc, r) => acc + sn(r.pedidas, 0), 0);
      const totalGrupoSurtidas = rows.reduce((acc, r) => acc + sn(r.surtidas, 0), 0);
      const totalGrupoPendientes = rows.reduce((acc, r) => acc + sn(r.pendientes, 0), 0);
      const totalGrupoPedidoImporte = rows.reduce((acc, r) => acc + sn(r.totalPedido, 0), 0);
      const totalGrupoSurtidoImporte = rows.reduce((acc, r) => acc + sn(r.totalSurtido, 0), 0);

      totalPedidasGlobal += totalGrupoPedidas;
      totalSurtidasGlobal += totalGrupoSurtidas;
      totalPendientesGlobal += totalGrupoPendientes;
      subtotalPedidoGlobal += totalGrupoPedidoImporte;
      subtotalSurtidoGlobal += totalGrupoSurtidoImporte;

      ensureRoom(18);

      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.text(`${s(grupo.area)} ${s(grupo.departamento)}`, marginLeft, currentY);
      currentY += 5;

      doc.setFont(undefined, "normal");
      doc.setFontSize(8);

      doc.autoTable({
        startY: currentY,
        margin: { left: marginLeft, right: marginLeft },
        theme: "grid",
        head: [[
          "Artículo",
          "Color",
          "Pedidas",
          "Surtidas",
          "Pend.",
          "Precio",
          "Total Pedido",
          "Total Surtido",
        ]],
        body: rows.map((r) => [
          s(r.articulo),
          s(r.color),
          sn(r.pedidas, 0),
          sn(r.surtidas, 0),
          sn(r.pendientes, 0),
          money(r.precio),
          money(r.totalPedido),
          money(r.totalSurtido),
        ]),
        foot: [[
          { content: "", styles: { halign: "left" } },
          { content: "Totales", styles: { halign: "right" } },
          { content: totalGrupoPedidas, styles: { halign: "center" } },
          { content: totalGrupoSurtidas, styles: { halign: "center" } },
          { content: totalGrupoPendientes, styles: { halign: "center" } },
          { content: "", styles: { halign: "right" } },
          { content: money(totalGrupoPedidoImporte), styles: { halign: "right" } },
          { content: money(totalGrupoSurtidoImporte), styles: { halign: "right" } },
        ]],
        styles: {
          fontSize: 7,
          cellPadding: 1.1,
          valign: "middle",
          overflow: "linebreak",
          lineColor: [0, 0, 0],
          lineWidth: 0.2,
          textColor: [0, 0, 0],
        },
        headStyles: {
          fillColor: [41, 128, 186],
          textColor: [255, 255, 255],
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          lineColor: [0, 0, 0],
          lineWidth: 0.2,
        },
        bodyStyles: {
          lineColor: [0, 0, 0],
          lineWidth: 0.2,
        },
        footStyles: {
          fillColor: [230, 230, 230],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          lineColor: [0, 0, 0],
          lineWidth: 0.2,
        },
        columnStyles: {
          0: { cellWidth: 48, halign: "left" },
          1: { cellWidth: 23, halign: "center" },
          2: { cellWidth: 15, halign: "center" },
          3: { cellWidth: 15, halign: "center" },
          4: { cellWidth: 15, halign: "center" },
          5: { cellWidth: 20, halign: "right" },
          6: { cellWidth: 26, halign: "right" },
          7: { cellWidth: 26, halign: "right" },
        },
      });

      currentY = doc.autoTable.previous.finalY + 8;

      ensureRoom(4);
      doc.setDrawColor(220);
      doc.line(marginLeft, currentY - 3, pageWidth - marginLeft, currentY - 3);
      doc.setDrawColor(0);
    }

    // =========================
    // RESUMEN GENERAL
    // =========================
    ensureRoom(40);

    const impuestosSi = String(impuestos || "").trim().toUpperCase() !== "NO";

    const ivaPedido = impuestosSi ? subtotalPedidoGlobal * 0.16 : 0;
    const totalPedidoConIVA = subtotalPedidoGlobal + ivaPedido;

    const ivaSurtido = impuestosSi ? subtotalSurtidoGlobal * 0.16 : 0;
    const totalSurtidoConIVA = subtotalSurtidoGlobal + ivaSurtido;

    doc.setFont(undefined, "bold");
    doc.setFontSize(11);
    doc.text("RESUMEN GENERAL", marginLeft, currentY);
    currentY += 7;

    doc.setFont(undefined, "normal");
    doc.setFontSize(9);

    doc.text(`Piezas pedidas: ${totalPedidasGlobal}`, marginLeft, currentY);
    currentY += 5;

    doc.text(`Piezas surtidas: ${totalSurtidasGlobal}`, marginLeft, currentY);
    currentY += 5;

    doc.text(`Piezas pendientes: ${totalPendientesGlobal}`, marginLeft, currentY);
    currentY += 7;

    doc.text(`Subtotal pedido: ${money(subtotalPedidoGlobal)}`, marginLeft, currentY);
    currentY += 5;

    doc.text(`Subtotal surtido: ${money(subtotalSurtidoGlobal)}`, marginLeft, currentY);
    currentY += 5;

    if (impuestosSi) {
      doc.text(`IVA pedido (16%): ${money(ivaPedido)}`, marginLeft, currentY);
      currentY += 5;

      doc.text(`Total pedido: ${money(totalPedidoConIVA)}`, marginLeft, currentY);
      currentY += 5;

      doc.text(`IVA surtido (16%): ${money(ivaSurtido)}`, marginLeft, currentY);
      currentY += 5;

      doc.text(`Total surtido: ${money(totalSurtidoConIVA)}`, marginLeft, currentY);
      currentY += 5;
    } else {
      doc.text(`Total pedido: ${money(subtotalPedidoGlobal)}`, marginLeft, currentY);
      currentY += 5;

      doc.text(`Total surtido: ${money(subtotalSurtidoGlobal)}`, marginLeft, currentY);
      currentY += 5;
    }

    // TF6 — movimientos de producción (totales del pedido)
    ensureRoom(16);
    currentY += 2;
    doc.setFont(undefined, "bold");
    doc.text(
      `En procesos (no recibido): ${totalEnProcesosNoRecibido}`,
      marginLeft,
      currentY
    );
    currentY += 5;
    doc.text(
      `Entrada a almacén: ${totalEntradaAlmacen}`,
      marginLeft,
      currentY
    );
    currentY += 5;
    doc.setFont(undefined, "normal");

    // =========================
    // CONDICIONES
    // =========================
    const condiciones = s(condicionesPedido).trim();
    if (condiciones) {
      ensureRoom(10);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      doc.text("Condiciones de la Cotización:", marginLeft, currentY);
      currentY += 5;

      doc.setFont(undefined, "normal");
      doc.setFontSize(8);

      const maxWidth = pageWidth - marginLeft * 2;
      const lines = doc.splitTextToSize(condiciones, maxWidth);
      const lineHeight = 4;
      const blockHeight = lines.length * lineHeight;

      ensureRoom(blockHeight + 4);
      doc.text(lines, marginLeft, currentY, { maxWidth });
      currentY += blockHeight + 6;
    }

    // =========================
    // OBSERVACIONES
    // =========================
    const observacionesTexto = s(observaciones).trim();
    if (observacionesTexto) {
      ensureRoom(10);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      doc.text("Observaciones:", marginLeft, currentY);
      currentY += 5;

      doc.setFont(undefined, "normal");
      doc.setFontSize(8);

      const maxWidthObs = pageWidth - marginLeft * 2;
      const obsLines = doc.splitTextToSize(observacionesTexto, maxWidthObs);
      const lineHeightObs = 4;
      const blockHeightObs = obsLines.length * lineHeightObs;

      ensureRoom(blockHeightObs + 4);
      doc.text(obsLines, marginLeft, currentY, { maxWidth: maxWidthObs });
      currentY += blockHeightObs + 8;
    }

    // =========================
    // FIRMA
    // =========================
    const signatureGap = 10;
    const lineWidth = 90;

    ensureRoom(signatureGap + 12);

    currentY += signatureGap;
    doc.setFont(undefined, "bold");
    doc.setFontSize(10);
    doc.text("FIRMA CLIENTE", pageWidth / 2, currentY, { align: "center" });
    currentY += 8;

    const lineStartX = (pageWidth - lineWidth) / 2;
    const lineEndX = lineStartX + lineWidth;
    doc.setDrawColor(0);
    doc.line(lineStartX, currentY, lineEndX, currentY);

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDFOCComparativo:", err);
    Swal.fire("Error", "No se pudo generar el PDF comparativo", "error");
  }
}

  function editPedidos(event) {
    event.preventDefault();
    const URL_PEDIDOS_EDIT = `${process.env.REACT_APP_URL_PEDIDOS}/${idEdit}`;
    if (file == null) {
      axios
        .patch(
          URL_PEDIDOS_EDIT,
          {
            fecha,
            colaboradores: selectedColaboradorEdit,
            marcas: selectedMarcaEdit,
            fecha_cancelacion,
            fecha_confirmacion,
            clientes: selectedClienteEdit,
            empresas: selectedEmpresaEdit,
            tipo: selectedTipoEdit || "Por definir",
            // compradores: selectedCompradorEdit,
            // total_general,
            observaciones,
            observacionesMarca,
            pedidoCliente,
            subCliente: String(subClienteEdit || "").trim() || "NA",

            nombreFirma: nombreFirmaEdit,
            puestoFirma: puestoFirmaEdit,
            nombreComprador: nombreCompradorEdit,
            puestoComprador: puestoCompradorEdit,
            condiciones: condicionesEdit,
            impuestos: impuestosEdit,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        // .then(() => {
        //   axios
        //     .patch(
        //       `${URL_ARTICULOS}/${idArticuloEdit}`,
        //       {
        //         patronista: selectedPatronistaEdit,
        //         muestrista: selectedMuestristaEdit,
        //         ploter: selectedPloterEdit,
        //       },
        //       {
        //         headers: {
        //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        //         },
        //       }
        //     )

            .then(() => {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Editar Pedido",
                  detalle: `${numero_pedido} ${fecha}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );

              // (2026-10) Sin recargar la página: se cierra el modal y se
              // vuelve a traer el listado con los filtros actuales.
              setModalEdit(false);
              Swal.fire("Good job!", "Actualizado con exito", "success");
              cargarPedidos();
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        // })
        // .catch((error) => {
        //   Swal.fire({
        //     icon: "error",
        //     title: "Oops...",
        //     text: "Something went wrong!",
        //     footer: `${error.response.data}`,
        //   });
        //   console.log(error);
        // });
    } else {
      axios
        .patch(
          URL_PEDIDOS_EDIT,
          {
            fecha,
            colaboradores: selectedColaboradorEdit,
            marcas: selectedMarcaEdit,
            fecha_cancelacion,
            fecha_confirmacion,
            clientes: selectedClienteEdit,
            empresas: selectedEmpresaEdit,
            tipo: selectedTipoEdit || "Por definir",
            // compradores: selectedCompradorEdit,
            // total_general,
            observaciones,
            observacionesMarca,
            pedidoCliente,
            subCliente: String(subClienteEdit || "").trim() || "NA",

            nombreFirma: nombreFirmaEdit,
            puestoFirma: puestoFirmaEdit,
            nombreComprador: nombreCompradorEdit,
            puestoComprador: puestoCompradorEdit,
            condiciones: condicionesEdit,
            impuestos: impuestosEdit,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("articulo", idArticuloEdit);

          axios
            .post(URL_FILEPOST, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            // .then(() => {
            //   axios
            //     .patch(
            //       `${URL_ARTICULOS}/${idArticuloEdit}`,
            //       {
            //         patronista: selectedPatronistaEdit,
            //         muestrista: selectedMuestristaEdit,
            //         ploter: selectedPloterEdit,
            //         fotoArticulo: "Si",
            //       },
            //       {
            //         headers: {
            //           Authorization: `Bearer: ${localStorage.getItem(
            //             "app_token"
            //           )}`,
            //         },
            //       }
            //     )

                .then(() => {
                  axios.post(
                    URL_LOGS,
                    {
                      tipo: "Editar Pedido",
                      detalle: `${numero_pedido} ${fecha}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  );

                  // (2026-10) Sin recargar la página: se cierra el modal, se
                  // suelta la foto ya subida (si no, la siguiente edición la
                  // volvería a subir) y se vuelve a traer el listado.
                  setModalEdit(false);
                  setFile(undefined);
                  Swal.fire("Good job!", "Actualizado con exito", "success");
                  cargarPedidos();
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            // })
            // .catch((error) => {
            //   Swal.fire({
            //     icon: "error",
            //     title: "Oops...",
            //     text: "Something went wrong!",
            //     footer: `${error.response.data}`,
            //   });
            //   console.log(error);
            // });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log(error);
        });
    }
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "Marca", field: "marcas", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Empresa", field: "empresas", sortable: true },
    // { name: "Comprador", field: "compradores", sortable: true },
    { name: "Vendedor", field: "colaboradores", sortable: false },
    { name: "Fecha Entrega", field: "fecha_cancelacion", sortable: true },
    // { name: "Fecha Confirmacion", field: "fecha_confirmacion", sortable: true },
    // { name: "Pend Fecha Conf", field: "pendFechaConf", sortable: false },
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Surtido", field: "surtido", sortable: true },
    // { name: "Pendiente", field: "pendiente_surtir", sortable: true },
      ...(user.pedidos_create ? [
    { name: "Total", field: "total_general", sortable: true }
      ] : []),
    { name: "Info", field: "info", sortable: false },
    { name: "Editar", field: "editar", sortable: false },
    { name: "Aut. Ventas", field: "Autorizar", sortable: false },
    // L96 (2026-06)
    { name: "Aut. Dirección", field: "AutorizarDireccion", sortable: false },
    { name: "Surtido", field: "Surtido", sortable: false },
    { name: "Cerrar", field: "cerrar", sortable: false },
  ];

  // (2026-09) Lista filtrada y ordenada SIN paginar: la usan la tabla (que
  // luego pagina) y el PDF / Excel / mail, para que salgan igual que la pantalla.
  const pedidosFiltrados = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          // comment.activo.toLowerCase().includes(search.toLowerCase()) ||
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.resurtido.toLowerCase().includes(search.toLowerCase()) ||
          comment.pedidoCliente.toLowerCase().includes(search.toLowerCase()) ||
          String(comment.subCliente || "").toLowerCase().includes(search.toLowerCase()) ||
          comment.empresas.toLowerCase().includes(search.toLowerCase()) ||
          // comment.compradores.toLowerCase().includes(search.toLowerCase()) ||
          // comment.marcas.toLowerCase().includes(search.toLowerCase()) ||
          comment.colaboradores.toLowerCase().includes(search.toLowerCase()) ||
          comment.marcas.toLowerCase().includes(search.toLowerCase()) ||
          // comment.articulos.toLowerCase().includes(search.toLowerCase()) ||
          comment.fecha.toLowerCase().includes(search.toLowerCase()) ||
          comment.fecha_cancelacion
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.fecha_confirmacion
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.pendFechaConf.toLowerCase().includes(search.toLowerCase()) ||
          comment.cantidad.toString().includes(search) ||
          comment.surtido.toString().includes(search) ||
          // comment.pendiente_surtir.toString().includes(search) ||
          comment.precioPrenda.toString().includes(search) ||
          comment.total_general.toString().includes(search) ||
          comment.numero.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedEmpresa) {
      computedComments = computedComments.filter((e) =>
        e.idEmpresas.includes(selectedEmpresa)
      );
    }
    // if (selectedComprador) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idCompradores.includes(selectedComprador)
    //   );
    // }
    // if (selectedMarca) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idMarcas.includes(selectedMarca)
    //   );
    // }
    if (selectedColaborador) {
      computedComments = computedComments.filter((e) =>
        e.idColaboradores.includes(selectedColaborador)
      );
    }
    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        e.idMarcas.includes(selectedMarca)
      );
    }

    if (selectedArticulo) {
      computedComments = computedComments.filter((e) =>
        e.idArticulo.includes(selectedArticulo)
      );
    }
    if (selectedStatus) {
      computedComments = computedComments.filter((e) =>
        e.status.includes(selectedStatus)
      );
    }
    if (selectedPendFechaConf) {
      computedComments = computedComments.filter((e) =>
        e.pendFechaConf.includes(selectedPendFechaConf)
      );
    }
    // (2026-07) filtro por is_active (Si/No). "" = Todos
    if (activo) {
      computedComments = computedComments.filter(
        (e) => String(e.activo) === activo
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidad" &&
      sorting.field != "surtido" &&
      sorting.field != "pendiente_surtir" &&
      sorting.field != "precioPrenda" &&
      sorting.field != "total_general" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "surtido" ||
        sorting.field == "pendiente_surtir" ||
        sorting.field == "precioPrenda" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "surtido" ||
        sorting.field == "pendiente_surtir" ||
        sorting.field == "precioPrenda" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    return computedComments;
  }, [
    comments,
    search,
    sorting,
    selectedCliente,
    selectedEmpresa,
    // selectedComprador,
    // selectedMarca,
    selectedColaborador,
    selectedMarca,
    selectedArticulo,
    activo,
    selectedFechaInicio,
    selectedFechaFin,
    selectedStatus,
    selectedPendFechaConf,
  ]);

  const commentsData = useMemo(
    () =>
      pedidosFiltrados.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
      ),
    [pedidosFiltrados, currentPage]
  );

const getCloudinaryImageUrl = (b) => {
  if (!b) return "";

  if (b.secure_url) return b.secure_url;
  if (b.url) return b.url;

  const publicId = String(b.public_id || "").trim();
  if (!publicId) return "";

  if (publicId.startsWith("http")) return publicId;

  const base = String(process.env.REACT_APP_URL_FOTO_CLOUDINARY || "")
    .replace(/\/$/, "")
    .replace(/\/image\/upload$/, "");

  return `${base}/image/upload/${publicId}`;
};

async function EditArticulos(idOC, numero_pedido, idCliente) {
  setInputFields({});
  setResumenEditPedido([]);
  setDetalleEditPedido([]);
  setGrupoSeleccionadoEdit(null);
  setTotalCantidadEdit(0);
  setTotalGeneralEdit(0);
  // (2026-08) pendientes de cerrar de otro pedido no se arrastran a este
  setIdsPorCerrar([]);

  setIdEdit(idOC);
  setClientePedidoEdit(idCliente || "");
  setNumeroPedido(numero_pedido);

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const toNumber = (val) => {
    const n = Number(val);
    return Number.isFinite(n) ? n : 0;
  };

  const getId = (arr) => arr?.[0]?._id || arr?.[0] || "";
  const getName = (arr, campo = "name") => arr?.[0]?.[campo] || "";

  try {
    Swal.fire({
      title: "Cargando resumen...",
      text: "Espera un momento",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading(),
    });

    const clienteObj = clientes.find((c) => String(c._id) === String(idCliente));
    // cargarSucursalesAreasClienteEdit ya trae sucursales/áreas desde la API;
    // solo usar clienteObj como fallback si aquello vino vacío (no sobrescribir).
    await cargarSucursalesAreasClienteEdit(idCliente);
    setSucursalesClienteEdit((prev) =>
      prev && prev.length ? prev : clienteObj?.sucursales || []
    );
    setAreasClienteEdit((prev) =>
      prev && prev.length ? prev : clienteObj?.areasClientes || []
    );

    const resDetalle = await axios.get(
      `${URL_ARTICULOS_PEDIDO}/pedidos/${idOC}`,
      { headers }
    );

    const data = Array.isArray(resDetalle.data) ? resDetalle.data : [];

    const agrupado = {};

    data.forEach((a) => {
      const cantidad = toNumber(a.cantidad);
      const surtido = toNumber(a.surtido);
      const precio = toNumber(a.precio);
      const total = Number((cantidad * precio).toFixed(2));

      const sucursalId = getId(a.sucursales);
      const sucursalNombre =
        getName(a.sucursales, "alias") ||
        getName(a.sucursales, "name") ||
        "Sin Sucursal";

      const areaId = getId(a.areasClientes);
      const areaNombre = getName(a.areasClientes) || "Sin Área";

      const articuloId = getId(a.articulos);
      const codigo = a.articulos?.[0]?.codigo || "";
      const linea =
        a.articulos?.[0]?.subDepartamentos?.[0]?.name ||
        a.articulos?.[0]?.subDepartamentos?.[0]?.nombre ||
        "";
      const nombreArticulo = [codigo, linea]
        .filter((x) => x && String(x).trim())
        .join(" - ") || "Sin Artículo";

      const key = `${sucursalId}||${areaId}||${articuloId}`;

      if (!agrupado[key]) {
agrupado[key] = {
  key,
  sucursalId,
  sucursal: sucursalNombre,
  areaId,
  area: areaNombre,
  articuloId,
  articulo: nombreArticulo,
  tela: a.tela || "NA",
  proveedorTela: a.proveedorTela || "NA",
  composicion: a.composicion || "NA",
  // L10 (2026-06) — observaciones por artículo, para que el textarea las precargue al abrir el editor
  observacionesArticulo: a.observacionesArticulo && a.observacionesArticulo !== "NA"
    ? a.observacionesArticulo
    : "",
  cantidad: 0,
  surtido: 0,
  total: 0,
  // (2026-07) Orden de impresión del artículo + ids de sus renglones (para guardarlo)
  orden: 0,
  rowIds: [],
};
      }

      agrupado[key].cantidad += cantidad;
      agrupado[key].surtido += surtido;
      agrupado[key].total += total;
      agrupado[key].rowIds.push(a._id);
      if (Number(a.orden) > 0) agrupado[key].orden = Number(a.orden);
    });

    const resumen = Object.values(agrupado)
      .map((x) => ({
        ...x,
        total: Number(x.total.toFixed(2)),
      }))
      .sort((a, b) => {
        const s = String(a.sucursal || "").localeCompare(
          String(b.sucursal || ""),
          "es",
          { sensitivity: "base" }
        );
        if (s !== 0) return s;

        const ar = String(a.area || "").localeCompare(
          String(b.area || ""),
          "es",
          { sensitivity: "base" }
        );
        if (ar !== 0) return ar;

        return String(a.articulo || "").localeCompare(
          String(b.articulo || ""),
          "es",
          { sensitivity: "base" }
        );
      });

    const totalCantidad = resumen.reduce(
      (sum, x) => sum + toNumber(x.cantidad),
      0
    );

    const totalGeneral = resumen.reduce(
      (sum, x) => sum + toNumber(x.total),
      0
    );

    setResumenEditPedido(resumen);
    setTotalCantidadEdit(totalCantidad);
    setTotalGeneralEdit(Number(totalGeneral.toFixed(2)));

    Swal.close();
    toggleEditArticulos();
  } catch (err) {
    console.log(err);
    Swal.close();
    Swal.fire("Error", "No se pudo cargar el resumen del pedido", "error");
  }
}

// (2026-07) Guarda el orden de impresión del artículo (grupo) en todos sus renglones,
// para que los PDFs impriman los artículos en ese orden (como en Cotizaciones).
// (2026-08) Un solo botón guarda el orden de todos los artículos del resumen.
async function guardarOrdenTodos() {
  const grupos = (resumenEditPedido || []).filter(
    (g) => Array.isArray(g.rowIds) && g.rowIds.length
  );
  if (!grupos.length) {
    return Swal.fire(
      "Sin renglones",
      "No hay artículos para ordenar",
      "info"
    );
  }

  const pendientes = grupos.flatMap((g) =>
    g.rowIds.map((id) => ({ id, orden: parseInt(g.orden) || 0 }))
  );

  try {
    setGuardandoOrden(true);
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    // en bloques, para no soltar cientos de peticiones de golpe
    for (let i = 0; i < pendientes.length; i += 20) {
      await Promise.all(
        pendientes
          .slice(i, i + 20)
          .map(({ id, orden }) =>
            axios.patch(`${URL_ARTICULOS_PEDIDO}/${id}`, { orden }, { headers })
          )
      );
    }
    Swal.fire(
      "Listo",
      `Orden de impresión guardado en ${grupos.length} artículo(s)`,
      "success"
    );
  } catch (err) {
    console.log(err);
    Swal.fire("Error", "No se pudo guardar el orden", "error");
  } finally {
    setGuardandoOrden(false);
  }
}

async function cargarDetalleGrupoPedido(grupo) {
  setGrupoSeleccionadoEdit(grupo);
  setDetalleEditPedido([]);
  setCargandoDetalleEdit(true);

  try {
    const sucursalNombre = grupo.sucursal || "Sin Sucursal";
    const clave = `${grupo.area}||${grupo.articulo}`;

    const detalleLocal = inputFields?.[sucursalNombre]?.[clave];

    if (Array.isArray(detalleLocal) && detalleLocal.length > 0) {
      setDetalleEditPedido(detalleLocal);
      setCargandoDetalleEdit(false);
      return;
    }

    const res = await axios.get(`${URL_ARTICULOS_PEDIDO}/pedidos/${idEdit}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    });

    const data = Array.isArray(res.data) ? res.data : [];

    const detalle = data
      .filter((a) => {
        const sucursalId = a.sucursales?.[0]?._id || a.sucursales?.[0] || "";
        const areaId = a.areasClientes?.[0]?._id || a.areasClientes?.[0] || "";
        const articuloId = a.articulos?.[0]?._id || a.articulos?.[0] || "";

        return (
          String(sucursalId) === String(grupo.sucursalId) &&
          String(areaId) === String(grupo.areaId) &&
          String(articuloId) === String(grupo.articuloId)
        );
      })
      .map((a) => {
        const cantidad = Number(a.cantidad || 0);
        const precio = Number(a.precio || 0);

        return {
          id: a._id,

          colores: a.colores?.[0]?._id || a.colores?.[0] || "",
          nombreColor: a.colores?.[0]?.name || "Sin Color",

          tallas: a.tallas?.[0]?._id || a.tallas?.[0] || "",
          nombreTalla: a.tallas?.[0]
            ? `${a.tallas[0].name || ""}${
                a.tallas[0].variantesTallas?.[0]?.name
                  ? " " + a.tallas[0].variantesTallas[0].name
                  : ""
              }`
            : "Sin Talla",

          cantidad,
          precio,
          total: Number(a.total || cantidad * precio),

          codigoBarras: a.codigoBarras || "",
          tela: a.tela || "",
          proveedorTela: a.proveedorTela || "",
          composicion: a.composicion || "",

          areasClientes: grupo.areaId,
          articuloId: grupo.articuloId,
          articuloNombre: grupo.articulo,

          clienteId: clientePedidoEdit || "",
          sucursalId: grupo.sucursalId,
          sucursalNombre: grupo.sucursal,
          areaId: grupo.areaId,
          areaNombre: grupo.area,

          claveIds: `${grupo.areaId}||${grupo.articuloId}||${grupo.sucursalId}`,

          sociedades:
            a.sociedades?.[0]?._id ||
            a.sociedades?.[0] ||
            selectedEmpresaEdit ||
            "6775c905d688145c579d8393",

          surtido: Number(a.surtido || 0),
          descuento: Number(a.descuento || 0),
          pendiente_surtir: Number(a.pendiente_surtir || cantidad),
          pendienteCortar: Number(a.pendienteCortar || cantidad),
          cortado: Number(a.cortado || 0),
          precioEtiqueta: Number(a.precioEtiqueta || 0),
          codigoCliente: a.codigoCliente || "NA",
          observacionesArticulo: a.observacionesArticulo || "NA",
          procesos: Array.isArray(a.procesos) ? a.procesos : [],
          cantidad_procesos: Number(a.cantidad_procesos || cantidad),
          bordados: Array.isArray(a.bordados) ? a.bordados : [],
        };
      });

    detalle.sort((a, b) => {
      const colorCompare = String(a.nombreColor || "").localeCompare(
        String(b.nombreColor || ""),
        "es",
        { sensitivity: "base" }
      );

      if (colorCompare !== 0) return colorCompare;

      return String(a.nombreTalla || "").localeCompare(
        String(b.nombreTalla || ""),
        "es",
        { sensitivity: "base", numeric: true }
      );
    });

    setDetalleEditPedido(detalle);
  } catch (err) {
    console.log(err);
    Swal.fire("Error", "No se pudo cargar el detalle", "error");
  } finally {
    setCargandoDetalleEdit(false);
  }
}

// (2026-08) Rearma resumen + inputFields + detalle desde el detalle recién
// traído del back, para no tener que recargar toda la página al guardar.
// Devuelve los totales del pedido ya recalculados.
function refrescarEdicionDesdeDetalle(data = []) {
  const filas = Array.isArray(data) ? data : [];
  const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);
  const getId = (arr) => arr?.[0]?._id || arr?.[0] || "";
  const getName = (arr, campo = "name") => arr?.[0]?.[campo] || "";

  const agrupado = {};   // resumen por sucursal||area||articulo
  const grupos = {};     // inputFields: sucursalNombre -> "area||articulo" -> items

  filas.forEach((a) => {
    const cantidad = num(a.cantidad);
    const precio = num(a.precio);
    const total = Number((cantidad * precio).toFixed(2));

    const sucursalId = getId(a.sucursales);
    const sucursal =
      getName(a.sucursales, "alias") || getName(a.sucursales, "name") || "Sin Sucursal";
    const areaId = getId(a.areasClientes);
    const area = getName(a.areasClientes) || "Sin Área";
    const articuloId = getId(a.articulos);
    const codigo = a.articulos?.[0]?.codigo || "";
    const linea =
      a.articulos?.[0]?.subDepartamentos?.[0]?.name ||
      a.articulos?.[0]?.subDepartamentos?.[0]?.nombre ||
      "";
    const articulo =
      [codigo, linea].filter((x) => x && String(x).trim()).join(" - ") ||
      "Sin Artículo";

    const key = `${sucursalId}||${areaId}||${articuloId}`;

    if (!agrupado[key]) {
      agrupado[key] = {
        key, sucursalId, sucursal, areaId, area, articuloId, articulo,
        tela: a.tela || "NA",
        proveedorTela: a.proveedorTela || "NA",
        composicion: a.composicion || "NA",
        observacionesArticulo:
          a.observacionesArticulo && a.observacionesArticulo !== "NA"
            ? a.observacionesArticulo
            : "",
        cantidad: 0, surtido: 0, total: 0, orden: 0, rowIds: [],
      };
    }
    agrupado[key].cantidad += cantidad;
    agrupado[key].surtido += num(a.surtido);
    agrupado[key].total += total;
    agrupado[key].rowIds.push(a._id);
    if (num(a.orden) > 0) agrupado[key].orden = num(a.orden);

    const clave = `${area}||${articulo}`;
    if (!grupos[sucursal]) grupos[sucursal] = {};
    if (!grupos[sucursal][clave]) grupos[sucursal][clave] = [];

    grupos[sucursal][clave].push({
      id: a._id,
      colores: a.colores?.[0]?._id || a.colores?.[0] || "",
      nombreColor: a.colores?.[0]?.name || "Sin Color",
      tallas: a.tallas?.[0]?._id || a.tallas?.[0] || "",
      nombreTalla: a.tallas?.[0]
        ? `${a.tallas[0].name || ""}${
            a.tallas[0].variantesTallas?.[0]?.name
              ? " " + a.tallas[0].variantesTallas[0].name
              : ""
          }`
        : "Sin Talla",
      cantidad,
      precio,
      total: num(a.total) || total,
      codigoBarras: a.codigoBarras || "",
      tela: a.tela || "",
      proveedorTela: a.proveedorTela || "",
      composicion: a.composicion || "",
      areasClientes: areaId,
      articuloId,
      articuloNombre: articulo,
      claveIds: `${areaId}||${articuloId}||${sucursalId}`,
      clienteId: clientePedidoEdit || "",
      sucursalId,
      sucursalNombre: sucursal,
      areaId,
      areaNombre: area,
      departamentoId:
        a.articulos?.[0]?.departamentos?.[0]?._id ||
        a.articulos?.[0]?.departamentos?.[0] || "",
      subDepartamentoId:
        a.articulos?.[0]?.subDepartamentos?.[0]?._id ||
        a.articulos?.[0]?.subDepartamentos?.[0] || "",
      sociedades:
        a.sociedades?.[0]?._id || a.sociedades?.[0] ||
        selectedEmpresaEdit || "6775c905d688145c579d8393",
      surtido: num(a.surtido),
      descuento: num(a.descuento),
      pendiente_surtir: num(a.pendiente_surtir) || cantidad,
      pendienteCortar: num(a.pendienteCortar) || cantidad,
      cortado: num(a.cortado),
      precioEtiqueta: num(a.precioEtiqueta),
      codigoCliente: a.codigoCliente || "NA",
      observacionesArticulo: a.observacionesArticulo || "NA",
      procesos: Array.isArray(a.procesos) ? a.procesos : [],
      cantidad_procesos: num(a.cantidad_procesos) || cantidad,
      bordados: Array.isArray(a.bordados) ? a.bordados : [],
    });
  });

  const ordenaCombos = (arr) =>
    (arr || []).sort((x, y) => {
      const col = String(x.nombreColor || "").localeCompare(
        String(y.nombreColor || ""), "es", { sensitivity: "base" }
      );
      if (col !== 0) return col;
      return String(x.nombreTalla || "").localeCompare(
        String(y.nombreTalla || ""), "es", { sensitivity: "base", numeric: true }
      );
    });

  Object.keys(grupos).forEach((suc) =>
    Object.keys(grupos[suc]).forEach((cl) => ordenaCombos(grupos[suc][cl]))
  );

  const resumen = Object.values(agrupado)
    .map((x) => ({ ...x, total: Number(x.total.toFixed(2)) }))
    .sort((a, b) => {
      const s = String(a.sucursal || "").localeCompare(String(b.sucursal || ""), "es", { sensitivity: "base" });
      if (s !== 0) return s;
      const ar = String(a.area || "").localeCompare(String(b.area || ""), "es", { sensitivity: "base" });
      if (ar !== 0) return ar;
      return String(a.articulo || "").localeCompare(String(b.articulo || ""), "es", { sensitivity: "base" });
    });

  const totalCantidad = resumen.reduce((s, x) => s + num(x.cantidad), 0);
  const totalGeneral = Number(
    resumen.reduce((s, x) => s + num(x.total), 0).toFixed(2)
  );

  setInputFields(grupos);
  setResumenEditPedido(resumen);
  setTotalCantidadEdit(totalCantidad);
  setTotalGeneralEdit(totalGeneral);

  // Si hay un grupo abierto, refrescar su detalle (y su encabezado del resumen)
  if (grupoSeleccionadoEdit?.key) {
    const g = resumen.find((x) => x.key === grupoSeleccionadoEdit.key);
    if (g) {
      setGrupoSeleccionadoEdit(g);
      setDetalleEditPedido(grupos[g.sucursal]?.[`${g.area}||${g.articulo}`] || []);
    } else {
      setGrupoSeleccionadoEdit(null);
      setDetalleEditPedido([]);
    }
  }

  return { totalCantidad, totalGeneral };
}

const actualizarDetalleEdit = (idx, campo, valor) => {
  setDetalleEditPedido((prev) => {
    const nuevoDetalle = (prev || []).map((item, i) => {
      if (i !== idx) return item;

      const actualizado = {
        ...item,
        [campo]: valor,
      };

      if (campo === "cantidad" || campo === "precio") {
        const cantidad = Number(
          campo === "cantidad" ? valor : actualizado.cantidad || 0
        );
        const precio = Number(
          campo === "precio" ? valor : actualizado.precio || 0
        );

        actualizado.total = Number((cantidad * precio).toFixed(2));
        actualizado.pendiente_surtir = cantidad;
        actualizado.pendienteCortar = cantidad;
        actualizado.cantidad_procesos = cantidad;
      }

      return actualizado;
    });

    sincronizarDetalleConInputFields(nuevoDetalle);
    return nuevoDetalle;
  });
};
function sincronizarDetalleConInputFields(detalle = []) {
  if (!Array.isArray(detalle) || detalle.length === 0) return;

  const sucursalNombre =
    detalle[0]?.sucursalNombre ||
    grupoSeleccionadoEdit?.sucursal ||
    "Sin Sucursal";

  const areaNombre =
    detalle[0]?.areaNombre ||
    grupoSeleccionadoEdit?.area ||
    "Sin Área";

  const articuloNombre =
    detalle[0]?.articuloNombre ||
    grupoSeleccionadoEdit?.articulo ||
    "Sin Artículo";

  const clave = `${areaNombre}||${articuloNombre}`;

  setInputFields((prev) => {
    const nuevo = { ...(prev || {}) };

    if (!nuevo[sucursalNombre]) nuevo[sucursalNombre] = {};

    nuevo[sucursalNombre][clave] = detalle.map((item) => ({
      ...item,
      tela: item.tela || "NA",
      sucursalNombre,
      areaNombre,
      articuloNombre,
      sucursalId: item.sucursalId || grupoSeleccionadoEdit?.sucursalId || "",
      areaId: item.areaId || grupoSeleccionadoEdit?.areaId || "",
      articuloId: item.articuloId || grupoSeleccionadoEdit?.articuloId || "",
    }));

    return nuevo;
  });
}

// (2026-09) Celdas color × talla del modal "Agregar artículo al pedido". Una
// talla con variantes se abre en una columna por variante ("26 LP +4"), igual
// que en PedidosCreate. Conserva las cantidades ya capturadas al cambiar la
// selección de colores o tallas.
const armaCeldasNuevoArticulo = (coloresSel = [], tallasSel = [], previas = []) => {
  const asId = (v) => String(v?._id || v || "");
  const prevMap = new Map(
    (previas || []).map((c) => [
      `${asId(c.colores)}|${asId(c.tallas)}|${c.tallaNombre}`,
      Number(c.cantidad) || 0,
    ])
  );

  const celdas = [];
  (coloresSel || []).forEach((col) => {
    (tallasSel || []).forEach((t) => {
      const base = String(t?.name || t?.nombre || "").trim();
      const variantes = (Array.isArray(t?.variantesTallas) ? t.variantesTallas : [])
        .map((v) => (v && typeof v === "object" ? String(v.name || v.nombre || "") : ""))
        .map((v) => v.trim())
        .filter(Boolean);
      const nombres = variantes.length ? variantes.map((v) => `${base} ${v}`) : [base];

      nombres.forEach((tallaNombre) => {
        const key = `${asId(col)}|${asId(t)}|${tallaNombre}`;
        celdas.push({
          colores: asId(col),
          colorNombre: col?.name || col?.nombre || "",
          tallas: asId(t),
          tallaNombre,
          cantidad: prevMap.get(key) ?? 0,
        });
      });
    });
  });
  return celdas;
};

const etiquetaArticulo = (a) => {
  const codigo = String(a?.codigo || "").trim();
  const linea = String(
    a?.subDepartamentos?.[0]?.name || a?.subDepartamentos?.[0]?.nombre || ""
  ).trim();
  return [codigo, linea].filter(Boolean).join(" - ") || String(a?.descripcion || "");
};

const ordenaTallasCatalogo = (lista = []) =>
  [...lista].sort((a, b) => {
    const nombre = (t) => String(t?.name || t?.nombre || "").trim().toUpperCase();
    const pos = (t) => {
      const i = ordenTallas.findIndex((x) => String(x).toUpperCase() === nombre(t));
      return i === -1 ? Infinity : i;
    };
    return pos(a) - pos(b) || nombre(a).localeCompare(nombre(b), "es", { numeric: true });
  });

// (2026-09) El modal captura una tabla color × talla: se agrega un renglón
// por cada celda con cantidad, todos con la misma tela y el mismo precio.
// (2026-10) Al agregar se guarda de una vez en el pedido; ya no hay que
// entrar a Editar y darle Guardar.
async function agregarArticuloAlPedidoEdit() {
  const celdas = (nuevoArticuloEdit?.celdas || []).filter(
    (c) => Number(c.cantidad || 0) > 0
  );

  if (
    !nuevoArticuloEdit?.sucursalId ||
    !nuevoArticuloEdit?.areaId ||
    !nuevoArticuloEdit?.articuloId
  ) {
    Swal.fire("Error", "Selecciona sucursal, área y artículo", "error");
    return;
  }
  if (!celdas.length) {
    Swal.fire("Error", "Captura la cantidad de al menos una talla", "error");
    return;
  }

  const precio = Number(nuevoArticuloEdit.precio || 0);
  const tela = String(nuevoArticuloEdit.tela || "").trim() || "NA";

  const sucursalNombre = nuevoArticuloEdit.sucursalNombre || "Sin Sucursal";
  const areaNombre = nuevoArticuloEdit.areaNombre || "Sin Área";
  // misma etiqueta (código - línea) que usan los renglones ya cargados, para
  // que caigan en el mismo grupo del resumen
  const articuloNombre = nuevoArticuloEdit.articuloNombre || "Sin Artículo";

  const clave = `${areaNombre}||${articuloNombre}`;

  const itemsNuevos = celdas.map((c) => {
    const cantidad = Number(c.cantidad || 0);
    return {
      id: null,
      tempKey: `nuevo-${Date.now()}-${Math.random()}`,

      colores: c.colores,
      nombreColor: c.colorNombre,

      tallas: c.tallas,
      nombreTalla: c.tallaNombre,

      cantidad,
      precio,
      total: cantidad * precio,

      codigoBarras: 0,
      tela,

      areasClientes: nuevoArticuloEdit.areaId,
      articuloId: nuevoArticuloEdit.articuloId,
      articuloNombre,

      claveIds: `${nuevoArticuloEdit.areaId}||${nuevoArticuloEdit.articuloId}||${nuevoArticuloEdit.sucursalId}`,

      clienteId: clientePedidoEdit || "",
      sucursalId: nuevoArticuloEdit.sucursalId,
      sucursalNombre,

      areaId: nuevoArticuloEdit.areaId,
      areaNombre,

      departamentoId: nuevoArticuloEdit.departamentoId || "",
      subDepartamentoId: nuevoArticuloEdit.subDepartamentoId || "",

      sociedades: selectedEmpresaEdit || "6775c905d688145c579d8393",
      resurtido: "Si",
      surtido: 0,
      descuento: 0,
      pendiente_surtir: cantidad,
      pendienteCortar: cantidad,
      cortado: 0,
      precioEtiqueta: 0,
      codigoCliente: nuevoArticuloEdit.codigoCliente || "NA",
      observacionesArticulo: nuevoArticuloEdit.observacionesArticulo || "NA",
      procesos: [],
      cantidad_procesos: cantidad,
      bordados: [],
      esNuevo: true,
    };
  });

  const cantidad = itemsNuevos.reduce((s, i) => s + i.cantidad, 0);
  const total = itemsNuevos.reduce((s, i) => s + i.total, 0);

  const nuevoAgrupado = { ...(inputFields || {}) };

  if (!nuevoAgrupado[sucursalNombre]) {
    nuevoAgrupado[sucursalNombre] = {};
  }

  if (!nuevoAgrupado[sucursalNombre][clave]) {
    nuevoAgrupado[sucursalNombre][clave] = [];
  }

  nuevoAgrupado[sucursalNombre][clave].push(...itemsNuevos);

  setInputFields(nuevoAgrupado);

  const keyResumen = `${nuevoArticuloEdit.sucursalId}||${nuevoArticuloEdit.areaId}||${nuevoArticuloEdit.articuloId}`;

const nuevoGrupo = {
  key: keyResumen,
  sucursalId: nuevoArticuloEdit.sucursalId,
  sucursal: sucursalNombre,
  areaId: nuevoArticuloEdit.areaId,
  area: areaNombre,
  articuloId: nuevoArticuloEdit.articuloId,
  articulo: articuloNombre,
  tela,
  cantidad,
  total,
};

  const resumenActualizado = (() => {
    const existe = (resumenEditPedido || []).some(
      (x) => x.key === keyResumen
    );

    if (existe) {
      return (resumenEditPedido || []).map((x) =>
        x.key === keyResumen
          ? {
              ...x,
              cantidad: Number(x.cantidad || 0) + cantidad,
              total: Number(x.total || 0) + total,
            }
          : x
      );
    }

    return [...(resumenEditPedido || []), nuevoGrupo];
  })();

  setResumenEditPedido(resumenActualizado);
  recalcularTotalesDesdeResumen(resumenActualizado);

  const grupoFinal =
    resumenActualizado.find((x) => x.key === keyResumen) || nuevoGrupo;

  setGrupoSeleccionadoEdit(grupoFinal);
  setDetalleEditPedido(nuevoAgrupado[sucursalNombre][clave] || []);

  toggleAddArticuloEdit();

  await savePedido(null, nuevoAgrupado);
}

async function cargarSucursalesAreasClienteEdit(idCliente) {
  if (!idCliente) {
    setSucursalesClienteEdit([]);
    setAreasClienteEdit([]);
    return;
  }

  try {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    const [resSucursales, resAreas] = await Promise.all([
      axios.get(`${URL_SUCURSALES}/clientes/${idCliente}`, { headers }),
      axios.get(`${URL_AREAS_CLIENTES}/cliente/${idCliente}`, { headers }),
    ]);

    setSucursalesClienteEdit(resSucursales.data || []);
    setAreasClienteEdit(resAreas.data || []);

    console.log("SUCURSALES CLIENTE EDIT", resSucursales.data);
    console.log("AREAS CLIENTE EDIT", resAreas.data);
  } catch (err) {
    console.log(err);
    setSucursalesClienteEdit([]);
    setAreasClienteEdit([]);
  }
}

function recalcularTotalesEditDesdeAgrupado(agrupado) {
  let totalCantidad = 0;
  let totalGeneral = 0;

  Object.values(agrupado || {}).forEach((grupos) => {
    Object.values(grupos || {}).forEach((items) => {
      (items || []).forEach((item) => {
        const cantidad = Number(item.cantidad || 0);
        const precio = Number(item.precio || 0);
        const total = Number(item.total || cantidad * precio);

        totalCantidad += cantidad;
        totalGeneral += total;
      });
    });
  });

  setTotalCantidadEdit(totalCantidad);
  setTotalGeneralEdit(totalGeneral);
}
function recalcularTotalesDesdeResumen(resumen = resumenEditPedido) {
  const totalCantidad = (resumen || []).reduce(
    (sum, x) => sum + Number(x.cantidad || 0),
    0
  );

  const totalGeneral = (resumen || []).reduce(
    (sum, x) => sum + Number(x.total || 0),
    0
  );

  setTotalCantidadEdit(totalCantidad);
  setTotalGeneralEdit(totalGeneral);
}

function recalcularTotalesAgrupados(agrupado) {
  let totalCantidad = 0;
  let totalGeneral = 0;

  Object.values(agrupado).forEach((grupos) => {
    Object.values(grupos).forEach((items) => {
      items.forEach((item) => {
        totalCantidad += parseFloat(item.cantidad || 0);
        totalGeneral += parseFloat(item.total || 0);
      });
    });
  });

  setTotalCantidadEdit(totalCantidad);
  setTotalGeneralEdit(totalGeneral);
}
// Ya funciono pero dejaba las tallas anteriores
// async function actualizarCantidadesPorColaboradoresTallas() {
//   if (!clientePedidoEdit) {
//     Swal.fire("Error", "No se encontró el cliente del pedido", "error");
//     return;
//   }

//   const normalizaId = (valor) => String(valor || "").trim();

//   const makeMatchKey = ({ areaId, departamentoId, subDepartamentoId }) =>
//     [
//       normalizaId(areaId),
//       normalizaId(departamentoId),
//       normalizaId(subDepartamentoId),
//     ].join("||");

//   const makeComboKey = ({ areaId, departamentoId, lineaId, colorId }) =>
//     [
//       normalizaId(areaId),
//       normalizaId(departamentoId),
//       normalizaId(lineaId),
//       normalizaId(colorId),
//     ].join("||");

//   const makeItemKey = (item) =>
//     [
//       normalizaId(item.articuloId),
//       normalizaId(item.colores),
//       normalizaId(item.tallas),
//       normalizaId(item.areaId || item.areasClientes),
//       normalizaId(item.departamentoId),
//       normalizaId(item.subDepartamentoId),
//       normalizaId(item.sucursalId),
//     ].join("||");

//   const buildTempKey = ({
//     articuloId,
//     colorId,
//     tallaId,
//     areaId,
//     departamentoId,
//     subDepartamentoId,
//     sucursalId,
//   }) =>
//     [
//       "tmp",
//       normalizaId(articuloId),
//       normalizaId(colorId),
//       normalizaId(tallaId),
//       normalizaId(areaId),
//       normalizaId(departamentoId),
//       normalizaId(subDepartamentoId),
//       normalizaId(sucursalId),
//     ].join("-");

//   const getLineaDesdeSubDepartamento = (item) => {
//     const subDeptId = normalizaId(item?.subDepartamentoId);

//     const subDeptObj = (subDepartamentos || []).find(
//       (sd) => String(sd?._id || "") === String(subDeptId)
//     );

//     return {
//       lineaId: subDeptId,
//       lineaNombre: subDeptObj?.name || "Línea sin nombre",
//     };
//   };

//   const getDepartamentoDesdeCatalogo = (item) => {
//     const deptId = normalizaId(item?.departamentoId);

//     const deptObj = (departamentos || []).find(
//       (d) => String(d?._id || "") === String(deptId)
//     );

//     return {
//       departamentoId: deptId,
//       departamentoNombre: deptObj?.name || "Departamento sin nombre",
//     };
//   };

//   if (!inputFields || typeof inputFields !== "object") {
//     Swal.fire("Error", "No se encontraron artículos en el pedido", "error");
//     return;
//   }

//   const combosMap = {};

//   Object.entries(inputFields || {}).forEach(([sucursalNombre, grupos]) => {
//     Object.entries(grupos || {}).forEach(([clave, items]) => {
//       const itemsArr = Array.isArray(items) ? items : [];
//       if (!itemsArr.length) return;

//       const itemBase = itemsArr.find((x) => x.id) || itemsArr[0];

//       const areaId = normalizaId(itemBase.areaId || itemBase.areasClientes);
//       const areaNombre =
//         String(clave || "").split("||")[0]?.trim() ||
//         itemBase.areaNombre ||
//         "Área sin nombre";

//       const { departamentoId, departamentoNombre } =
//         getDepartamentoDesdeCatalogo(itemBase);

//       const { lineaId, lineaNombre } = getLineaDesdeSubDepartamento(itemBase);

//       const coloresUnicos = {};
//       itemsArr.forEach((it) => {
//         const colorId = normalizaId(it.colores);
//         if (!colorId) return;

//         if (!coloresUnicos[colorId]) {
//           coloresUnicos[colorId] = {
//             colorId,
//             colorNombre:
//               it.nombreColor || it.colorNombre || it.color || "Sin Color",
//           };
//         }
//       });

//       Object.values(coloresUnicos).forEach((colorObj) => {
//         const comboKey = makeComboKey({
//           areaId,
//           departamentoId,
//           lineaId,
//           colorId: colorObj.colorId,
//         });

//         if (!combosMap[comboKey]) {
//           combosMap[comboKey] = {
//             comboKey,
//             areaId,
//             areaNombre,
//             departamentoId,
//             departamentoNombre,
//             lineaId,
//             lineaNombre,
//             colorId: colorObj.colorId,
//             colorNombre: colorObj.colorNombre,
//             sucursalNombre,
//           };
//         }
//       });
//     });
//   });

//   const combos = Object.values(combosMap);

//   if (!combos.length) {
//     Swal.fire(
//       "Error",
//       "No se encontraron combinaciones de área, departamento, línea y color",
//       "error"
//     );
//     return;
//   }

//   const htmlInputs = combos
//     .map(
//       (c, index) => `
//         <div style="margin-bottom:14px; text-align:left; border:1px solid #eee; border-radius:8px; padding:10px;">
//           <div style="font-weight:700; margin-bottom:4px;">${c.areaNombre}</div>
//           <div style="font-size:13px; color:#555; margin-bottom:2px;">
//             <b>Departamento:</b> ${c.departamentoNombre}
//           </div>
//           <div style="font-size:13px; color:#555; margin-bottom:2px;">
//             <b>Línea:</b> ${c.lineaNombre}
//           </div>
//           <div style="font-size:13px; color:#555; margin-bottom:8px;">
//             <b>Color:</b> ${c.colorNombre}
//           </div>

//           <input
//             id="combo_prendas_${index}"
//             class="swal2-input"
//             type="number"
//             min="0"
//             step="1"
//             value="1"
//             style="margin:0; width:100%;"
//           />
//         </div>
//       `
//     )
//     .join("");

//   const { value: prendasPorCombo, isConfirmed } = await Swal.fire({
//     title: "Prendas por colaborador",
//     html: htmlInputs,
//     width: 750,
//     showCancelButton: true,
//     confirmButtonText: "Continuar",
//     cancelButtonText: "Cancelar",
//     focusConfirm: false,
//     preConfirm: () => {
//       const resultado = {};

//       for (let i = 0; i < combos.length; i++) {
//         const combo = combos[i];
//         const input = document.getElementById(`combo_prendas_${i}`);
//         const value = Number(input?.value || 0);

//         if (value < 0) {
//           Swal.showValidationMessage(
//             `Ingresa un número válido (puede ser 0) para ${combo.areaNombre} / ${combo.departamentoNombre} / ${combo.lineaNombre} / ${combo.colorNombre}`
//           );
//           return false;
//         }

//         resultado[combo.comboKey] = value;
//       }

//       return resultado;
//     },
//   });

//   if (!isConfirmed || !prendasPorCombo) return;

//   try {
//     setActualizandoPorTallas(true);

//     const headers = {
//       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
//     };

//     const getNombreTallaConVariante = (t) => {
//       if (!t) return "Sin Talla";
//       const base = String(t.name || t.nombre || "").trim();
//       const variante = String(t?.variantesTallas?.[0]?.name || "").trim();
//       return `${base}${variante ? " " + variante : ""}`.trim();
//     };

//     const [resTallas, resColaboradores] = await Promise.all([
//       axios.get(`${URL_COLABORADORES_TALLAS}/cliente/${clientePedidoEdit}`, {
//         headers,
//       }),
//       axios.get(`${URL_COLABORADORES_CLIENTES}/cliente/${clientePedidoEdit}`, {
//         headers,
//       }),
//     ]);

//     const tallasAsignadas = (resTallas.data || []).filter(
//       (x) => x.is_active === "Si"
//     );

//     const colaboradores = (resColaboradores.data || []).filter(
//       (x) => x.is_active === "Si"
//     );

//     const mapColaborador = {};
//     const mapSucursalNombre = {};

//     colaboradores.forEach((col) => {
//       const sucursalObj = col.sucursales?.[0] || "";
//       const sucursalId = normalizaId(sucursalObj?._id || sucursalObj);

//       mapColaborador[String(col._id)] = {
//         _id: String(col._id),
//         sucursalId,
//         areaId: normalizaId(
//           col.areasClientes?.[0]?._id || col.areasClientes?.[0]
//         ),
//         departamentoId: normalizaId(
//           col.departamentos?.[0]?._id || col.departamentos?.[0]
//         ),
//         subDepartamentoId: normalizaId(
//           col.subDepartamentos?.[0]?._id || col.subDepartamentos?.[0]
//         ),
//       };

//       if (sucursalId && !mapSucursalNombre[sucursalId]) {
//         mapSucursalNombre[sucursalId] =
//           sucursalObj?.alias ||
//           sucursalObj?.nombre_comercial ||
//           sucursalObj?.nombre ||
//           sucursalObj?.name ||
//           sucursalObj?.razon_social ||
//           sucursalId;
//       }
//     });

//     const getSucursalNombreDesdeItems = (
//       items = [],
//       sucursalId,
//       fallback = ""
//     ) => {
//       if (mapSucursalNombre[sucursalId]) {
//         return mapSucursalNombre[sucursalId];
//       }

//       const encontrada = (items || []).find(
//         (x) => String(x.sucursalId || "") === String(sucursalId || "")
//       );

//       return (
//         encontrada?.sucursalNombre ||
//         encontrada?.nombreSucursal ||
//         encontrada?.sucursal ||
//         fallback ||
//         sucursalId ||
//         "Sucursal sin nombre"
//       );
//     };

//     const tallasInfo = {};
//     const countsPorMatch = {};

//     tallasAsignadas.forEach((ct) => {
//       const colaboradorId = String(
//         ct.colaboradoresClientes?.[0]?._id ||
//           ct.colaboradoresClientes?.[0] ||
//           ""
//       );

//       const tallaObj = ct.tallas?.[0] || "";
//       const tallaId = String(tallaObj?._id || tallaObj || "");

//       const departamentoIdTalla = normalizaId(
//         ct.departamentos?.[0]?._id || ct.departamentos?.[0]
//       );

//       const subDepartamentoIdTalla = normalizaId(
//         ct.subDepartamentos?.[0]?._id || ct.subDepartamentos?.[0]
//       );

//       const colaborador = mapColaborador[colaboradorId];
//       if (!colaborador || !tallaId) return;

//       const tallaCatalogo = (tallas || []).find(
//         (t) => String(t._id) === String(tallaId)
//       );

//       const nombreTalla = tallaObj?._id
//         ? getNombreTallaConVariante(tallaObj)
//         : getNombreTallaConVariante(tallaCatalogo);

//       tallasInfo[tallaId] = nombreTalla;

//       const areaIdFinal = normalizaId(colaborador.areaId);
//       const sucursalIdFinal = normalizaId(colaborador.sucursalId);
//       const departamentoIdFinal = normalizaId(
//         departamentoIdTalla || colaborador.departamentoId
//       );
//       const subDepartamentoIdFinal = normalizaId(
//         subDepartamentoIdTalla || colaborador.subDepartamentoId
//       );

//       if (!areaIdFinal || !sucursalIdFinal) return;

//       const matchKey = makeMatchKey({
//         areaId: areaIdFinal,
//         departamentoId: departamentoIdFinal,
//         subDepartamentoId: subDepartamentoIdFinal,
//       });

//       if (!countsPorMatch[matchKey]) countsPorMatch[matchKey] = {};
//       if (!countsPorMatch[matchKey][sucursalIdFinal]) {
//         countsPorMatch[matchKey][sucursalIdFinal] = {};
//       }
//       if (!countsPorMatch[matchKey][sucursalIdFinal][tallaId]) {
//         countsPorMatch[matchKey][sucursalIdFinal][tallaId] = 0;
//       }

//       countsPorMatch[matchKey][sucursalIdFinal][tallaId] += 1;
//     });

//     const auditoria = {
//       combosSwal: {},
//       colaboradoresPorCombo: {},
//       esperadoPorCombo: {},
//       finalPorCombo: {},
//     };

//     const sumarEnObjeto = (obj, key, cantidad) => {
//       if (!obj[key]) obj[key] = 0;
//       obj[key] += Number(cantidad || 0);
//     };

//     Object.entries(prendasPorCombo || {}).forEach(([key, value]) => {
//       auditoria.combosSwal[key] = Number(value || 0);
//     });

//     Object.entries(inputFields || {}).forEach(([sucursalOrigen, grupos]) => {
//       Object.entries(grupos || {}).forEach(([clave, itemsOriginales]) => {
//         const items = Array.isArray(itemsOriginales) ? itemsOriginales : [];
//         if (!items.length) return;

//         const itemBaseGrupo = items.find((x) => x.id) || items[0];

//         const areaId = normalizaId(
//           itemBaseGrupo.areaId || itemBaseGrupo.areasClientes
//         );
//         const departamentoId = normalizaId(itemBaseGrupo.departamentoId);
//         const subDepartamentoId = normalizaId(itemBaseGrupo.subDepartamentoId);

//         const { lineaId, lineaNombre } =
//           getLineaDesdeSubDepartamento(itemBaseGrupo);
//         const { departamentoNombre } =
//           getDepartamentoDesdeCatalogo(itemBaseGrupo);

//         const matchKeyExacto = makeMatchKey({
//           areaId,
//           departamentoId,
//           subDepartamentoId,
//         });

//         const sucursalesDestino = Object.keys(countsPorMatch[matchKeyExacto] || {});
//         if (!sucursalesDestino.length) {
//           console.log("SIN SUCURSALES DESTINO", {
//             clave,
//             areaId,
//             departamentoId,
//             subDepartamentoId,
//             lineaId,
//             itemBaseGrupo,
//           });
//           return;
//         }

//         const coloresMap = {};
//         items.forEach((item) => {
//           const colorKey = normalizaId(item.colores || "sin_color");
//           if (!coloresMap[colorKey]) coloresMap[colorKey] = [];
//           coloresMap[colorKey].push(item);
//         });

//         sucursalesDestino.forEach((sucursalDestino) => {
//           const countsGrupoSucursal =
//             countsPorMatch[matchKeyExacto]?.[sucursalDestino] || {};

//           Object.entries(coloresMap).forEach(([colorKey, itemsColor]) => {
//             const baseColor = itemsColor.find((x) => x.id) || itemsColor[0];
//             const colorNombre = baseColor.nombreColor || "Sin Color";

//             const comboKey = makeComboKey({
//               areaId,
//               departamentoId,
//               lineaId,
//               colorId: colorKey,
//             });

//             const totalColaboradoresCombo = Object.values(
//               countsGrupoSucursal || {}
//             ).reduce((acc, n) => acc + Number(n || 0), 0);

//             sumarEnObjeto(
//               auditoria.colaboradoresPorCombo,
//               comboKey,
//               totalColaboradoresCombo
//             );

//             const multiplicador = Number(prendasPorCombo?.[comboKey] || 0);
//             sumarEnObjeto(
//               auditoria.esperadoPorCombo,
//               comboKey,
//               totalColaboradoresCombo * multiplicador
//             );

//             console.log("AUDIT COMBO BASE", {
//               comboKey,
//               areaId,
//               departamentoId,
//               departamentoNombre,
//               lineaId,
//               lineaNombre,
//               colorKey,
//               colorNombre,
//               sucursalDestino,
//               totalColaboradoresCombo,
//               multiplicador,
//               esperado: totalColaboradoresCombo * multiplicador,
//             });
//           });
//         });
//       });
//     });

//     const nuevoAgrupado = {};

//     const ensureBucket = (sucursalKey, clave) => {
//       if (!nuevoAgrupado[sucursalKey]) nuevoAgrupado[sucursalKey] = {};
//       if (!nuevoAgrupado[sucursalKey][clave])
//         nuevoAgrupado[sucursalKey][clave] = [];
//     };

//     const upsertItem = (sucursalKey, clave, itemNuevo) => {
//       ensureBucket(sucursalKey, clave);

//       const idx = nuevoAgrupado[sucursalKey][clave].findIndex(
//         (x) => makeItemKey(x) === makeItemKey(itemNuevo)
//       );

//       if (idx >= 0) {
//         const actual = nuevoAgrupado[sucursalKey][clave][idx];

//         console.log("ITEM DUPLICADO / SUMANDO", {
//           sucursalKey,
//           clave,
//           key: makeItemKey(itemNuevo),
//           existente: actual,
//           nuevo: itemNuevo,
//         });

//         nuevoAgrupado[sucursalKey][clave][idx] = {
//           ...actual,
//           ...itemNuevo,
//           cantidad: Number(actual.cantidad || 0) + Number(itemNuevo.cantidad || 0),
//           total: Number(actual.total || 0) + Number(itemNuevo.total || 0),
//           pendiente_surtir:
//             Number(actual.pendiente_surtir || 0) +
//             Number(itemNuevo.pendiente_surtir || 0),
//           pendienteCortar:
//             Number(actual.pendienteCortar || 0) +
//             Number(itemNuevo.pendienteCortar || 0),
//           cantidad_procesos:
//             Number(actual.cantidad_procesos || 0) +
//             Number(itemNuevo.cantidad_procesos || 0),
//         };
//       } else {
//         nuevoAgrupado[sucursalKey][clave].push(itemNuevo);
//       }
//     };

//     Object.entries(inputFields || {}).forEach(([sucursalKeyOriginal, grupos]) => {
//       if (!nuevoAgrupado[sucursalKeyOriginal]) {
//         nuevoAgrupado[sucursalKeyOriginal] = {};
//       }

//       Object.entries(grupos || {}).forEach(([clave, items]) => {
//         nuevoAgrupado[sucursalKeyOriginal][clave] = (items || []).map((item) => ({
//           ...item,
//           tempKey:
//             item.tempKey ||
//             buildTempKey({
//               articuloId: item.articuloId,
//               colorId: item.colores,
//               tallaId: item.tallas,
//               areaId: item.areaId || item.areasClientes,
//               departamentoId: item.departamentoId,
//               subDepartamentoId: item.subDepartamentoId,
//               sucursalId: item.sucursalId,
//             }),
//           cantidad: 0,
//           total: 0,
//           pendiente_surtir: 0,
//           pendienteCortar: 0,
//           cantidad_procesos: 0,
//         }));
//       });
//     });

//     Object.entries(inputFields || {}).forEach(([sucursalOrigen, grupos]) => {
//       Object.entries(grupos || {}).forEach(([clave, itemsOriginales]) => {
//         const items = Array.isArray(itemsOriginales) ? itemsOriginales : [];
//         if (!items.length) return;

//         const itemBaseGrupo = items.find((x) => x.id) || items[0];

//         const areaId = normalizaId(
//           itemBaseGrupo.areaId || itemBaseGrupo.areasClientes
//         );
//         const departamentoId = normalizaId(itemBaseGrupo.departamentoId);
//         const subDepartamentoId = normalizaId(itemBaseGrupo.subDepartamentoId);

//         const { lineaId } = getLineaDesdeSubDepartamento(itemBaseGrupo);

//         const matchKeyExacto = makeMatchKey({
//           areaId,
//           departamentoId,
//           subDepartamentoId,
//         });

//         const sucursalesDestino = Object.keys(countsPorMatch[matchKeyExacto] || {});
//         if (!sucursalesDestino.length) return;

//         const coloresMap = {};
//         items.forEach((item) => {
//           const colorKey = normalizaId(item.colores || "sin_color");
//           if (!coloresMap[colorKey]) coloresMap[colorKey] = [];
//           coloresMap[colorKey].push(item);
//         });

//         sucursalesDestino.forEach((sucursalDestino) => {
//           const countsGrupoSucursal =
//             countsPorMatch[matchKeyExacto]?.[sucursalDestino] || {};

//           const tallasRequeridas = Object.keys(countsGrupoSucursal || {}).filter(
//             (tallaId) => Number(countsGrupoSucursal?.[tallaId] || 0) > 0
//           );

//           if (!tallasRequeridas.length) return;

//           const sucursalTitulo = getSucursalNombreDesdeItems(
//             items,
//             sucursalDestino,
//             sucursalDestino
//           );

//           Object.entries(coloresMap).forEach(([colorKey, itemsColor]) => {
//             const baseColor = itemsColor.find((x) => x.id) || itemsColor[0];

//             const comboKey = makeComboKey({
//               areaId,
//               departamentoId,
//               lineaId,
//               colorId: colorKey,
//             });

//             const multiplicadorCombo = Number(prendasPorCombo?.[comboKey] || 0);

//             console.log("AUDIT RECONSTRUCCION", {
//               comboKey,
//               areaId,
//               departamentoId,
//               lineaId,
//               colorId: colorKey,
//               multiplicadorCombo,
//               sucursalDestino,
//               tallasRequeridas,
//               countsGrupoSucursal,
//             });

//             // Si es 0, no genera registros y se elimina del resultado final
//             if (multiplicadorCombo <= 0) return;

//             tallasRequeridas.forEach((tallaId) => {
//               const totalColaboradores = Number(
//                 countsGrupoSucursal?.[tallaId] || 0
//               );

//               const nuevaCantidad = totalColaboradores * multiplicadorCombo;
//               const precio = parseFloat(baseColor.precio || 0);

//               console.log("AUDIT TALLA", {
//                 comboKey,
//                 tallaId,
//                 totalColaboradores,
//                 multiplicadorCombo,
//                 nuevaCantidad,
//               });

//               const existenteMismaColorYTalla = itemsColor.find(
//                 (x) => String(x.tallas || "") === String(tallaId)
//               );

//               const itemFinal = {
//                 ...(existenteMismaColorYTalla || baseColor),
//                 id: existenteMismaColorYTalla?.id || null,
//                 tempKey:
//                   existenteMismaColorYTalla?.tempKey ||
//                   buildTempKey({
//                     articuloId: baseColor.articuloId,
//                     colorId: baseColor.colores,
//                     tallaId,
//                     areaId: itemBaseGrupo.areaId || itemBaseGrupo.areasClientes,
//                     departamentoId: itemBaseGrupo.departamentoId,
//                     subDepartamentoId: itemBaseGrupo.subDepartamentoId,
//                     sucursalId: sucursalDestino,
//                   }),
//                 colores: baseColor.colores || "",
//                 nombreColor: baseColor.nombreColor || "Sin Color",
//                 tallas: tallaId,
//                 nombreTalla:
//                   tallasInfo[tallaId] ||
//                   existenteMismaColorYTalla?.nombreTalla ||
//                   "Sin Talla",

//                 cantidad: nuevaCantidad,
//                 total: nuevaCantidad * precio,
//                 precio,
//                 codigoBarras: parseFloat(baseColor.codigoBarras || 0),

//                 areasClientes: itemBaseGrupo.areasClientes || "",
//                 articuloId: baseColor.articuloId || "",
//                 articuloNombre: baseColor.articuloNombre || "",
//                 claveIds: baseColor.claveIds || "",

//                 clienteId: baseColor.clienteId || clientePedidoEdit || "",
//                 sucursalId: sucursalDestino,
//                 sucursalNombre: sucursalTitulo,
//                 areaId: itemBaseGrupo.areaId || "",
//                 departamentoId: itemBaseGrupo.departamentoId || "",
//                 subDepartamentoId: itemBaseGrupo.subDepartamentoId || "",

//                 tela: baseColor.tela || "",
//                 sociedades:
//                   baseColor.sociedades || "6775c905d688145c579d8393",
//                 surtido: parseFloat(baseColor.surtido || 0),
//                 descuento: parseFloat(baseColor.descuento || 0),
//                 pendiente_surtir: nuevaCantidad,
//                 pendienteCortar: nuevaCantidad,
//                 cortado: parseFloat(baseColor.cortado || 0),
//                 precioEtiqueta: parseFloat(baseColor.precioEtiqueta || 0),
//                 codigoCliente: baseColor.codigoCliente || "NA",
//                 observacionesArticulo:
//                   baseColor.observacionesArticulo || "NA",
//                 procesos: Array.isArray(baseColor.procesos)
//                   ? baseColor.procesos
//                   : [],
//                 cantidad_procesos: nuevaCantidad,
//                 bordados: Array.isArray(baseColor.bordados)
//                   ? baseColor.bordados
//                   : [],
//                 esNuevo: !existenteMismaColorYTalla,
//               };

//               upsertItem(sucursalTitulo, clave, itemFinal);
//             });
//           });
//         });
//       });
//     });

//     Object.entries(nuevoAgrupado || {}).forEach(([sucursal, grupos]) => {
//       Object.entries(grupos || {}).forEach(([clave, items]) => {
//         (items || []).forEach((item) => {
//           const areaId = normalizaId(item.areaId || item.areasClientes);
//           const departamentoId = normalizaId(item.departamentoId);
//           const { lineaId } = getLineaDesdeSubDepartamento(item);

//           const comboKey = makeComboKey({
//             areaId,
//             departamentoId,
//             lineaId,
//             colorId: normalizaId(item.colores),
//           });

//           sumarEnObjeto(auditoria.finalPorCombo, comboKey, item.cantidad);
//         });
//       });
//     });

//     const diferencias = [];

//     Object.keys({
//       ...auditoria.esperadoPorCombo,
//       ...auditoria.finalPorCombo,
//     }).forEach((comboKey) => {
//       const esperado = Number(auditoria.esperadoPorCombo[comboKey] || 0);
//       const final = Number(auditoria.finalPorCombo[comboKey] || 0);
//       const diferencia = esperado - final;

//       if (diferencia !== 0) {
//         diferencias.push({
//           comboKey,
//           esperado,
//           final,
//           diferencia,
//           multiplicador: auditoria.combosSwal[comboKey] || 0,
//           colaboradores: auditoria.colaboradoresPorCombo[comboKey] || 0,
//         });
//       }
//     });

//     const totalEsperado = Object.values(auditoria.esperadoPorCombo).reduce(
//       (acc, n) => acc + Number(n || 0),
//       0
//     );

//     const totalFinalAntesFiltro = Object.values(auditoria.finalPorCombo).reduce(
//       (acc, n) => acc + Number(n || 0),
//       0
//     );

//     const totalColaboradoresContados = Object.values(countsPorMatch).reduce(
//       (acc1, sucursales) =>
//         acc1 +
//         Object.values(sucursales || {}).reduce(
//           (acc2, tallasObj) =>
//             acc2 +
//             Object.values(tallasObj || {}).reduce(
//               (acc3, n) => acc3 + Number(n || 0),
//               0
//             ),
//           0
//         ),
//       0
//     );

//     console.log("=== AUDITORIA COMPLETA ===");
//     console.log("TOTAL COLABORADORES CONTADOS", totalColaboradoresContados);
//     console.log("prendasPorCombo", prendasPorCombo);
//     console.log("auditoria", auditoria);
//     console.log("TOTAL ESPERADO", totalEsperado);
//     console.log("TOTAL FINAL ANTES FILTRO", totalFinalAntesFiltro);
//     console.log("FALTANTE ANTES FILTRO", totalEsperado - totalFinalAntesFiltro);
//     console.log("DIFERENCIAS", diferencias);

//     Object.keys(nuevoAgrupado).forEach((sucursal) => {
//       Object.keys(nuevoAgrupado[sucursal] || {}).forEach((clave) => {
//         nuevoAgrupado[sucursal][clave] = (nuevoAgrupado[sucursal][clave] || [])
//           .filter((item) => Number(item.cantidad || 0) > 0)
//           .sort((a, b) => {
//             const colorCompare = String(a.nombreColor || "").localeCompare(
//               String(b.nombreColor || "")
//             );
//             if (colorCompare !== 0) return colorCompare;

//             return String(a.nombreTalla || "").localeCompare(
//               String(b.nombreTalla || "")
//             );
//           });

//         if (!nuevoAgrupado[sucursal][clave].length) {
//           delete nuevoAgrupado[sucursal][clave];
//         }
//       });

//       if (!Object.keys(nuevoAgrupado[sucursal] || {}).length) {
//         delete nuevoAgrupado[sucursal];
//       }
//     });

//     let totalFinalDespuesFiltro = 0;
//     Object.values(nuevoAgrupado || {}).forEach((grupos) => {
//       Object.values(grupos || {}).forEach((items) => {
//         (items || []).forEach((item) => {
//           totalFinalDespuesFiltro += Number(item.cantidad || 0);
//         });
//       });
//     });

//     console.log("TOTAL FINAL DESPUES FILTRO", totalFinalDespuesFiltro);
//     console.log("FALTANTE FINAL", totalEsperado - totalFinalDespuesFiltro);

//     setInputFields(nuevoAgrupado);
//     recalcularTotalesAgrupados(nuevoAgrupado);

//     const resumenCombos = combos
//       .map(
//         (c) =>
//           `${c.areaNombre} / ${c.departamentoNombre} / ${c.lineaNombre} / ${c.colorNombre}: ${
//             prendasPorCombo[c.comboKey]
//           }`
//       )
//       .join("\n");

//     Swal.fire(
//       "Actualizado",
//       `Se recalcularon las cantidades por Área / Departamento / Línea / Color.\n\nTotal esperado: ${totalEsperado}\nTotal final: ${totalFinalDespuesFiltro}\nDiferencia: ${
//         totalEsperado - totalFinalDespuesFiltro
//       }\n\n${resumenCombos}`,
//       "success"
//     );
//   } catch (err) {
//     console.log(err);
//     Swal.fire(
//       "Error",
//       "No se pudieron actualizar las tallas del pedido",
//       "error"
//     );
//   } finally {
//     setActualizandoPorTallas(false);
//   }
// }

async function actualizarCantidadesPorColaboradoresTallas() {
  if (!clientePedidoEdit) {
    Swal.fire("Error", "No se encontró el cliente del pedido", "error");
    return;
  }

  if (!idEdit) {
    Swal.fire("Error", "No se encontró el pedido", "error");
    return;
  }

  const normalizaId = (valor) => String(valor || "").trim();

  const construirInputFieldsDesdeData = (data = []) => {
    const agrupado = {};

    data.forEach((a) => {
      const sucursal = a.sucursales?.[0]?.alias || "Sin Sucursal";
      const area = a.areasClientes?.[0]?.name || "Sin Área";

      // (2026-07) Los artículos NO traen nombre/descripcion útil (vienen "NA");
      // su identidad es CÓDIGO + LÍNEA (subDepartamento), igual que en el modal de
      // edición (nombreArticulo = codigo - linea). Antes se usaba nombre||descripcion
      // = "NA", así que TODOS los artículos caían en la misma clave "area||NA" y se
      // fusionaban → el prompt solo mostraba uno (el primero, el saco).
      const codigoArt = a.articulos?.[0]?.codigo || "";
      const lineaArt =
        a.articulos?.[0]?.subDepartamentos?.[0]?.name ||
        a.articulos?.[0]?.subDepartamentos?.[0]?.nombre ||
        "";
      const articulo =
        [codigoArt, lineaArt].filter((x) => x && String(x).trim()).join(" - ") ||
        a.articulos?.[0]?.nombre ||
        a.articulos?.[0]?.descripcion ||
        "Sin Artículo";

      const clave = `${area}||${articulo}`;

      const areaId = a.areasClientes?.[0]?._id || a.areasClientes?.[0] || "";
      const articuloId = a.articulos?.[0]?._id || a.articulos?.[0] || "";
      const sucursalId = a.sucursales?.[0]?._id || a.sucursales?.[0] || "";

      const departamentoId =
        a.articulos?.[0]?.departamentos?.[0]?._id ||
        a.articulos?.[0]?.departamentos?.[0] ||
        "";

      const subDepartamentoId =
        a.articulos?.[0]?.subDepartamentos?.[0]?._id ||
        a.articulos?.[0]?.subDepartamentos?.[0] ||
        "";

      const cantidad = Number(a.cantidad || 0);
      const precio = Number(a.precio || 0);
      const total = Number(a.total || cantidad * precio);

      if (!agrupado[sucursal]) agrupado[sucursal] = {};
      if (!agrupado[sucursal][clave]) agrupado[sucursal][clave] = [];

      agrupado[sucursal][clave].push({
        id: a._id,

        colores: a.colores?.[0]?._id || a.colores?.[0] || "",
        nombreColor: a.colores?.[0]?.name || "Sin Color",

        tallas: a.tallas?.[0]?._id || a.tallas?.[0] || "",
        nombreTalla: a.tallas?.[0]
          ? `${a.tallas[0].name || ""}${
              a.tallas[0].variantesTallas?.[0]?.name
                ? " " + a.tallas[0].variantesTallas[0].name
                : ""
            }`
          : "Sin Talla",

        cantidad,
        precio,
        total,

        codigoBarras: a.codigoBarras || "",
        tela: a.tela || "",

        areasClientes: areaId,
        articuloId,
        articuloNombre: articulo,
        claveIds: `${areaId}||${articuloId}||${sucursalId}`,

        clienteId: clientePedidoEdit || "",
        sucursalId,
        sucursalNombre: sucursal,
        areaId,
        areaNombre: area,
        departamentoId,
        subDepartamentoId,

        sociedades: a.sociedades?.[0]?._id || a.sociedades?.[0] || "",
        surtido: Number(a.surtido || 0),
        descuento: Number(a.descuento || 0),
        pendiente_surtir: Number(a.pendiente_surtir || 0),
        pendienteCortar: Number(a.pendienteCortar || 0),
        cortado: Number(a.cortado || 0),
        precioEtiqueta: Number(a.precioEtiqueta || 0),
        codigoCliente: a.codigoCliente || "NA",
        observacionesArticulo: a.observacionesArticulo || "NA",
        procesos: Array.isArray(a.procesos) ? a.procesos : [],
        cantidad_procesos: Number(a.cantidad_procesos || 0),
        bordados: Array.isArray(a.bordados) ? a.bordados : [],
      });
    });

    return agrupado;
  };

  let inputFieldsTrabajo = inputFields;

  if (!inputFieldsTrabajo || !Object.keys(inputFieldsTrabajo || {}).length) {
    try {
      Swal.fire({
        title: "Cargando artículos...",
        text: "Se usarán solo para calcular tallas",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      const headers = {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      };

      const res = await axios.get(`${URL_ARTICULOS_PEDIDO}/pedidos/${idEdit}`, {
        headers,
      });

      const data = Array.isArray(res.data) ? res.data : [];
      inputFieldsTrabajo = construirInputFieldsDesdeData(data);

      Swal.close();
    } catch (err) {
      console.log(err);
      Swal.close();
      Swal.fire(
        "Error",
        "No se pudieron cargar los artículos del pedido",
        "error"
      );
      return;
    }
  }

  const makeMatchKey = ({ areaId, departamentoId, subDepartamentoId }) =>
    [
      normalizaId(areaId),
      normalizaId(departamentoId),
      normalizaId(subDepartamentoId),
    ].join("||");

  // (2026-07) El combo ahora incluye el ARTÍCULO, para que cada artículo (saco,
  // blusa, falda, pantalón...) tenga su propio renglón en el prompt aunque
  // compartan área/departamento/subdepartamento/color. Antes se agrupaba solo por
  // área/depto/línea/color y los artículos se fusionaban (solo aparecía uno).
  const makeComboKey = ({ articuloId, areaId, departamentoId, lineaId, colorId }) =>
    [
      normalizaId(articuloId),
      normalizaId(areaId),
      normalizaId(departamentoId),
      normalizaId(lineaId),
      normalizaId(colorId),
    ].join("||");

  const makeItemKey = (item) =>
    [
      normalizaId(item.articuloId),
      normalizaId(item.colores),
      normalizaId(item.tallas),
      normalizaId(item.areaId || item.areasClientes),
      normalizaId(item.departamentoId),
      normalizaId(item.subDepartamentoId),
      normalizaId(item.sucursalId),
    ].join("||");

  const buildTempKey = ({
    articuloId,
    colorId,
    tallaId,
    areaId,
    departamentoId,
    subDepartamentoId,
    sucursalId,
  }) =>
    [
      "tmp",
      normalizaId(articuloId),
      normalizaId(colorId),
      normalizaId(tallaId),
      normalizaId(areaId),
      normalizaId(departamentoId),
      normalizaId(subDepartamentoId),
      normalizaId(sucursalId),
    ].join("-");

  const getLineaDesdeSubDepartamento = (item) => {
    const subDeptId = normalizaId(item?.subDepartamentoId);

    const subDeptObj = (subDepartamentos || []).find(
      (sd) => String(sd?._id || "") === String(subDeptId)
    );

    return {
      lineaId: subDeptId,
      lineaNombre: subDeptObj?.name || "Línea sin nombre",
    };
  };

  const getDepartamentoDesdeCatalogo = (item) => {
    const deptId = normalizaId(item?.departamentoId);

    const deptObj = (departamentos || []).find(
      (d) => String(d?._id || "") === String(deptId)
    );

    return {
      departamentoId: deptId,
      departamentoNombre: deptObj?.name || "Departamento sin nombre",
    };
  };

  if (!inputFieldsTrabajo || typeof inputFieldsTrabajo !== "object") {
    Swal.fire("Error", "No se encontraron artículos en el pedido", "error");
    return;
  }

  const combosMap = {};

  Object.entries(inputFieldsTrabajo || {}).forEach(([sucursalNombre, grupos]) => {
    Object.entries(grupos || {}).forEach(([clave, items]) => {
      const itemsArr = Array.isArray(items) ? items : [];
      if (!itemsArr.length) return;

      const itemBase = itemsArr.find((x) => x.id) || itemsArr[0];

      const areaId = normalizaId(itemBase.areaId || itemBase.areasClientes);
      const areaNombre =
        String(clave || "").split("||")[0]?.trim() ||
        itemBase.areaNombre ||
        "Área sin nombre";

      // (2026-07) artículo de este grupo (clave = area||articulo) para que cada
      // artículo tenga su propio combo/renglón en el prompt.
      const articuloId = normalizaId(itemBase.articuloId);
      const articuloNombre =
        String(clave || "").split("||")[1]?.trim() ||
        itemBase.articuloNombre ||
        "Artículo sin nombre";

      const { departamentoId, departamentoNombre } =
        getDepartamentoDesdeCatalogo(itemBase);

      const { lineaId, lineaNombre } = getLineaDesdeSubDepartamento(itemBase);

      const coloresUnicos = {};

      itemsArr.forEach((it) => {
        // Si el artículo no tiene color capturado, igual se muestra como "Sin Color"
        const colorId = normalizaId(it.colores) || "sin_color";

        if (!coloresUnicos[colorId]) {
          coloresUnicos[colorId] = {
            colorId,
            colorNombre:
              it.nombreColor || it.colorNombre || it.color || "Sin Color",
          };
        }
      });

      Object.values(coloresUnicos).forEach((colorObj) => {
        const comboKey = makeComboKey({
          articuloId,
          areaId,
          departamentoId,
          lineaId,
          colorId: colorObj.colorId,
        });

        if (!combosMap[comboKey]) {
          combosMap[comboKey] = {
            comboKey,
            articuloId,
            articuloNombre,
            areaId,
            areaNombre,
            departamentoId,
            departamentoNombre,
            lineaId,
            lineaNombre,
            colorId: colorObj.colorId,
            colorNombre: colorObj.colorNombre,
            sucursalNombre,
          };
        }
      });
    });
  });

  const combos = Object.values(combosMap);

  // (2026-07) Ordena por Área → Artículo → Color para que el prompt sea legible
  // y los renglones del mismo artículo queden juntos.
  combos.sort((a, b) => {
    const porArea = String(a.areaNombre || "").localeCompare(
      String(b.areaNombre || ""),
      "es",
      { sensitivity: "base" }
    );
    if (porArea !== 0) return porArea;
    const porArticulo = String(a.articuloNombre || "").localeCompare(
      String(b.articuloNombre || ""),
      "es",
      { sensitivity: "base", numeric: true }
    );
    if (porArticulo !== 0) return porArticulo;
    return String(a.colorNombre || "").localeCompare(
      String(b.colorNombre || ""),
      "es",
      { sensitivity: "base" }
    );
  });

  if (!combos.length) {
    Swal.fire(
      "Error",
      "No se encontraron combinaciones de área, departamento, línea y color",
      "error"
    );
    return;
  }

  const htmlInputs = combos
    .map(
      (c, index) => `
        <div style="margin-bottom:14px; text-align:left; border:1px solid #eee; border-radius:8px; padding:10px;">
          <div style="font-weight:700; font-size:15px; margin-bottom:4px; color:#1f2a44;">${c.articuloNombre}</div>
          <div style="font-size:13px; color:#555; margin-bottom:2px;">
            <b>Área:</b> ${c.areaNombre}
          </div>
          <div style="font-size:13px; color:#555; margin-bottom:2px;">
            <b>Departamento:</b> ${c.departamentoNombre}
          </div>
          <div style="font-size:13px; color:#555; margin-bottom:2px;">
            <b>Línea:</b> ${c.lineaNombre}
          </div>
          <div style="font-size:13px; color:#555; margin-bottom:8px;">
            <b>Color:</b> ${c.colorNombre}
          </div>

          <input
            id="combo_prendas_${index}"
            class="swal2-input"
            type="number"
            min="0"
            step="1"
            value="1"
            style="margin:0; width:100%;"
          />
        </div>
      `
    )
    .join("");

  const { value: prendasPorCombo, isConfirmed } = await Swal.fire({
    title: "Prendas por colaborador",
    html: htmlInputs,
    width: 750,
    showCancelButton: true,
    confirmButtonText: "Continuar",
    cancelButtonText: "Cancelar",
    focusConfirm: false,
    preConfirm: () => {
      const resultado = {};

      for (let i = 0; i < combos.length; i++) {
        const combo = combos[i];
        const input = document.getElementById(`combo_prendas_${i}`);
        const value = Number(input?.value || 0);

        if (value < 0) {
          Swal.showValidationMessage(
            `Ingresa un número válido para ${combo.articuloNombre} / ${combo.areaNombre} / ${combo.colorNombre}`
          );
          return false;
        }

        resultado[combo.comboKey] = value;
      }

      return resultado;
    },
  });

  if (!isConfirmed || !prendasPorCombo) return;

  try {
    setActualizandoPorTallas(true);

    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    const getNombreTallaConVariante = (t) => {
      if (!t) return "Sin Talla";
      const base = String(t.name || t.nombre || "").trim();
      const variante = String(t?.variantesTallas?.[0]?.name || "").trim();
      return `${base}${variante ? " " + variante : ""}`.trim();
    };

    const [resTallas, resColaboradores] = await Promise.all([
      axios.get(`${URL_COLABORADORES_TALLAS}/cliente/${clientePedidoEdit}`, {
        headers,
      }),
      axios.get(`${URL_COLABORADORES_CLIENTES}/cliente/${clientePedidoEdit}`, {
        headers,
      }),
    ]);

    const tallasAsignadas = (resTallas.data || []).filter(
      (x) => x.is_active === "Si"
    );

    const colaboradores = (resColaboradores.data || []).filter(
      (x) => x.is_active === "Si"
    );

    const mapColaborador = {};
    const mapSucursalNombre = {};

    colaboradores.forEach((col) => {
      const sucursalObj = col.sucursales?.[0] || "";
      const sucursalId = normalizaId(sucursalObj?._id || sucursalObj);

      mapColaborador[String(col._id)] = {
        _id: String(col._id),
        sucursalId,
        areaId: normalizaId(
          col.areasClientes?.[0]?._id || col.areasClientes?.[0]
        ),
        departamentoId: normalizaId(
          col.departamentos?.[0]?._id || col.departamentos?.[0]
        ),
        subDepartamentoId: normalizaId(
          col.subDepartamentos?.[0]?._id || col.subDepartamentos?.[0]
        ),
      };

      if (sucursalId && !mapSucursalNombre[sucursalId]) {
        mapSucursalNombre[sucursalId] =
          sucursalObj?.alias ||
          sucursalObj?.nombre_comercial ||
          sucursalObj?.nombre ||
          sucursalObj?.name ||
          sucursalObj?.razon_social ||
          sucursalId;
      }
    });

    const getSucursalNombreDesdeItems = (
      items = [],
      sucursalId,
      fallback = ""
    ) => {
      if (mapSucursalNombre[sucursalId]) return mapSucursalNombre[sucursalId];

      const encontrada = (items || []).find(
        (x) => String(x.sucursalId || "") === String(sucursalId || "")
      );

      return (
        encontrada?.sucursalNombre ||
        encontrada?.nombreSucursal ||
        encontrada?.sucursal ||
        fallback ||
        sucursalId ||
        "Sucursal sin nombre"
      );
    };

    const tallasInfo = {};
    const countsPorMatch = {};

    tallasAsignadas.forEach((ct) => {
      const colaboradorId = String(
        ct.colaboradoresClientes?.[0]?._id ||
          ct.colaboradoresClientes?.[0] ||
          ""
      );

      const tallaObj = ct.tallas?.[0] || "";
      const tallaId = String(tallaObj?._id || tallaObj || "");

      const departamentoIdTalla = normalizaId(
        ct.departamentos?.[0]?._id || ct.departamentos?.[0]
      );

      const subDepartamentoIdTalla = normalizaId(
        ct.subDepartamentos?.[0]?._id || ct.subDepartamentos?.[0]
      );

      const colaborador = mapColaborador[colaboradorId];
      if (!colaborador || !tallaId) return;

      const tallaCatalogo = (tallas || []).find(
        (t) => String(t._id) === String(tallaId)
      );

      const nombreTalla = tallaObj?._id
        ? getNombreTallaConVariante(tallaObj)
        : getNombreTallaConVariante(tallaCatalogo);

      tallasInfo[tallaId] = nombreTalla;

      const areaIdFinal = normalizaId(colaborador.areaId);
      const sucursalIdFinal = normalizaId(colaborador.sucursalId);
      const departamentoIdFinal = normalizaId(
        departamentoIdTalla || colaborador.departamentoId
      );
      const subDepartamentoIdFinal = normalizaId(
        subDepartamentoIdTalla || colaborador.subDepartamentoId
      );

      if (!areaIdFinal || !sucursalIdFinal) return;

      const matchKey = makeMatchKey({
        areaId: areaIdFinal,
        departamentoId: departamentoIdFinal,
        subDepartamentoId: subDepartamentoIdFinal,
      });

      if (!countsPorMatch[matchKey]) countsPorMatch[matchKey] = {};
      if (!countsPorMatch[matchKey][sucursalIdFinal]) {
        countsPorMatch[matchKey][sucursalIdFinal] = {};
      }
      if (!countsPorMatch[matchKey][sucursalIdFinal][tallaId]) {
        countsPorMatch[matchKey][sucursalIdFinal][tallaId] = 0;
      }

      countsPorMatch[matchKey][sucursalIdFinal][tallaId] += 1;
    });

    const auditoria = {
      combosSwal: {},
      colaboradoresPorCombo: {},
      esperadoPorCombo: {},
      finalPorCombo: {},
    };

    const sumarEnObjeto = (obj, key, cantidad) => {
      if (!obj[key]) obj[key] = 0;
      obj[key] += Number(cantidad || 0);
    };

    Object.entries(prendasPorCombo || {}).forEach(([key, value]) => {
      auditoria.combosSwal[key] = Number(value || 0);
    });

    Object.entries(inputFieldsTrabajo || {}).forEach(([sucursalOrigen, grupos]) => {
      Object.entries(grupos || {}).forEach(([clave, itemsOriginales]) => {
        const items = Array.isArray(itemsOriginales) ? itemsOriginales : [];
        if (!items.length) return;

        const itemBaseGrupo = items.find((x) => x.id) || items[0];

        const areaId = normalizaId(
          itemBaseGrupo.areaId || itemBaseGrupo.areasClientes
        );
        const departamentoId = normalizaId(itemBaseGrupo.departamentoId);
        const subDepartamentoId = normalizaId(itemBaseGrupo.subDepartamentoId);

        const { lineaId } = getLineaDesdeSubDepartamento(itemBaseGrupo);

        const matchKeyExacto = makeMatchKey({
          areaId,
          departamentoId,
          subDepartamentoId,
        });

        const sucursalesDestino = Object.keys(
          countsPorMatch[matchKeyExacto] || {}
        );

        if (!sucursalesDestino.length) return;

        const coloresMap = {};

        items.forEach((item) => {
          const colorKey = normalizaId(item.colores || "sin_color");
          if (!coloresMap[colorKey]) coloresMap[colorKey] = [];
          coloresMap[colorKey].push(item);
        });

        sucursalesDestino.forEach((sucursalDestino) => {
          const countsGrupoSucursal =
            countsPorMatch[matchKeyExacto]?.[sucursalDestino] || {};

          Object.entries(coloresMap).forEach(([colorKey]) => {
            const comboKey = makeComboKey({
              articuloId: normalizaId(itemBaseGrupo.articuloId),
              areaId,
              departamentoId,
              lineaId,
              colorId: colorKey,
            });

            const totalColaboradoresCombo = Object.values(
              countsGrupoSucursal || {}
            ).reduce((acc, n) => acc + Number(n || 0), 0);

            sumarEnObjeto(
              auditoria.colaboradoresPorCombo,
              comboKey,
              totalColaboradoresCombo
            );

            const multiplicador = Number(prendasPorCombo?.[comboKey] || 0);

            sumarEnObjeto(
              auditoria.esperadoPorCombo,
              comboKey,
              totalColaboradoresCombo * multiplicador
            );
          });
        });
      });
    });

    const nuevoAgrupado = {};

    const ensureBucket = (sucursalKey, clave) => {
      if (!nuevoAgrupado[sucursalKey]) nuevoAgrupado[sucursalKey] = {};
      if (!nuevoAgrupado[sucursalKey][clave]) {
        nuevoAgrupado[sucursalKey][clave] = [];
      }
    };

    const upsertItem = (sucursalKey, clave, itemNuevo) => {
      ensureBucket(sucursalKey, clave);

      const idx = nuevoAgrupado[sucursalKey][clave].findIndex(
        (x) => makeItemKey(x) === makeItemKey(itemNuevo)
      );

      if (idx >= 0) {
        const actual = nuevoAgrupado[sucursalKey][clave][idx];

        nuevoAgrupado[sucursalKey][clave][idx] = {
          ...actual,
          ...itemNuevo,
          cantidad: Number(actual.cantidad || 0) + Number(itemNuevo.cantidad || 0),
          total: Number(actual.total || 0) + Number(itemNuevo.total || 0),
          pendiente_surtir:
            Number(actual.pendiente_surtir || 0) +
            Number(itemNuevo.pendiente_surtir || 0),
          pendienteCortar:
            Number(actual.pendienteCortar || 0) +
            Number(itemNuevo.pendienteCortar || 0),
          cantidad_procesos:
            Number(actual.cantidad_procesos || 0) +
            Number(itemNuevo.cantidad_procesos || 0),
        };
      } else {
        nuevoAgrupado[sucursalKey][clave].push(itemNuevo);
      }
    };

    Object.entries(inputFieldsTrabajo || {}).forEach(([sucursalOrigen, grupos]) => {
      Object.entries(grupos || {}).forEach(([clave, itemsOriginales]) => {
        const items = Array.isArray(itemsOriginales) ? itemsOriginales : [];
        if (!items.length) return;

        const itemBaseGrupo = items.find((x) => x.id) || items[0];

        const areaId = normalizaId(
          itemBaseGrupo.areaId || itemBaseGrupo.areasClientes
        );
        const departamentoId = normalizaId(itemBaseGrupo.departamentoId);
        const subDepartamentoId = normalizaId(itemBaseGrupo.subDepartamentoId);

        const { lineaId } = getLineaDesdeSubDepartamento(itemBaseGrupo);

        const matchKeyExacto = makeMatchKey({
          areaId,
          departamentoId,
          subDepartamentoId,
        });

        const sucursalesDestino = Object.keys(
          countsPorMatch[matchKeyExacto] || {}
        );

        if (!sucursalesDestino.length) return;

        const coloresMap = {};

        items.forEach((item) => {
          const colorKey = normalizaId(item.colores || "sin_color");
          if (!coloresMap[colorKey]) coloresMap[colorKey] = [];
          coloresMap[colorKey].push(item);
        });

        sucursalesDestino.forEach((sucursalDestino) => {
          const countsGrupoSucursal =
            countsPorMatch[matchKeyExacto]?.[sucursalDestino] || {};

          const tallasRequeridas = Object.keys(
            countsGrupoSucursal || {}
          ).filter((tallaId) => Number(countsGrupoSucursal?.[tallaId] || 0) > 0);

          if (!tallasRequeridas.length) return;

          const sucursalTitulo = getSucursalNombreDesdeItems(
            items,
            sucursalDestino,
            sucursalDestino
          );

          Object.entries(coloresMap).forEach(([colorKey, itemsColor]) => {
            const baseColor = itemsColor.find((x) => x.id) || itemsColor[0];

            const comboKey = makeComboKey({
              articuloId: normalizaId(baseColor.articuloId),
              areaId,
              departamentoId,
              lineaId,
              colorId: colorKey,
            });

            const multiplicadorCombo = Number(prendasPorCombo?.[comboKey] || 0);

            if (multiplicadorCombo <= 0) return;

            tallasRequeridas.forEach((tallaId) => {
              const totalColaboradores = Number(
                countsGrupoSucursal?.[tallaId] || 0
              );

              const nuevaCantidad = totalColaboradores * multiplicadorCombo;
              const precio = parseFloat(baseColor.precio || 0);

              const existenteMismaColorYTalla = itemsColor.find(
                (x) => String(x.tallas || "") === String(tallaId)
              );

              const itemFinal = {
                ...(existenteMismaColorYTalla || baseColor),
                id: existenteMismaColorYTalla?.id || null,
                tempKey:
                  existenteMismaColorYTalla?.tempKey ||
                  buildTempKey({
                    articuloId: baseColor.articuloId,
                    colorId: baseColor.colores,
                    tallaId,
                    areaId: itemBaseGrupo.areaId || itemBaseGrupo.areasClientes,
                    departamentoId: itemBaseGrupo.departamentoId,
                    subDepartamentoId: itemBaseGrupo.subDepartamentoId,
                    sucursalId: sucursalDestino,
                  }),
                colores: baseColor.colores || "",
                nombreColor: baseColor.nombreColor || "Sin Color",
                tallas: tallaId,
                nombreTalla:
                  tallasInfo[tallaId] ||
                  existenteMismaColorYTalla?.nombreTalla ||
                  "Sin Talla",

                cantidad: nuevaCantidad,
                total: nuevaCantidad * precio,
                precio,
                codigoBarras: parseFloat(baseColor.codigoBarras || 0),

                areasClientes: itemBaseGrupo.areasClientes || itemBaseGrupo.areaId || "",
                articuloId: baseColor.articuloId || "",
                articuloNombre: baseColor.articuloNombre || "",
                claveIds:
                  baseColor.claveIds ||
                  `${itemBaseGrupo.areaId || itemBaseGrupo.areasClientes}||${
                    baseColor.articuloId
                  }||${sucursalDestino}`,

                clienteId: baseColor.clienteId || clientePedidoEdit || "",
                sucursalId: sucursalDestino,
                sucursalNombre: sucursalTitulo,
                areaId: itemBaseGrupo.areaId || itemBaseGrupo.areasClientes || "",
                departamentoId: itemBaseGrupo.departamentoId || "",
                subDepartamentoId: itemBaseGrupo.subDepartamentoId || "",

                tela: baseColor.tela || "",
                sociedades: baseColor.sociedades || "6775c905d688145c579d8393",
                surtido: parseFloat(baseColor.surtido || 0),
                descuento: parseFloat(baseColor.descuento || 0),
                pendiente_surtir: nuevaCantidad,
                pendienteCortar: nuevaCantidad,
                cortado: parseFloat(baseColor.cortado || 0),
                precioEtiqueta: parseFloat(baseColor.precioEtiqueta || 0),
                codigoCliente: baseColor.codigoCliente || "NA",
                observacionesArticulo: baseColor.observacionesArticulo || "NA",
                procesos: Array.isArray(baseColor.procesos)
                  ? baseColor.procesos
                  : [],
                cantidad_procesos: nuevaCantidad,
                bordados: Array.isArray(baseColor.bordados)
                  ? baseColor.bordados
                  : [],
                esNuevo: !existenteMismaColorYTalla,
              };

              upsertItem(sucursalTitulo, clave, itemFinal);
            });
          });
        });
      });
    });

    // (2026-07) Ya NO se preservan los artículos sin coincidencia: el original se
    // reemplaza por la redistribución. Lo que la redistribución deje por debajo del
    // original (por artículo+área) se maneja abajo como "prendas restantes" (se
    // pregunta si van a la talla comodín — UNITALLA o POR DEFINIR — o se eliminan).

    Object.entries(nuevoAgrupado || {}).forEach(([sucursal, grupos]) => {
      Object.entries(grupos || {}).forEach(([clave, items]) => {
        (items || []).forEach((item) => {
          const areaId = normalizaId(item.areaId || item.areasClientes);
          const departamentoId = normalizaId(item.departamentoId);
          const { lineaId } = getLineaDesdeSubDepartamento(item);

          const comboKey = makeComboKey({
            articuloId: normalizaId(item.articuloId),
            areaId,
            departamentoId,
            lineaId,
            colorId: normalizaId(item.colores),
          });

          sumarEnObjeto(auditoria.finalPorCombo, comboKey, item.cantidad);
        });
      });
    });

    // ============ PRENDAS RESTANTES (por artículo + área + color) ============
    // Compara la cantidad ORIGINAL capturada (por artículo+área+color) contra lo
    // que quedó distribuido por colaboradores/tallas. Si la distribución dejó
    // MENOS, el sobrante se puede mandar a una talla comodín (conserva el total
    // del pedido) o quitarse. Se le pregunta al usuario qué hacer. Se incluye el
    // ÁREA para no mezclar el mismo artículo/color de áreas distintas.

    // (2026-08) UNITALLA y POR DEFINIR son tallas comodín y reciben el MISMO
    // trato: el sobrante regresa a la que se haya capturado originalmente en ese
    // artículo/área; si el original no traía comodín, se usa la que exista.
    const normTalla = (v) =>
      String(v || "").trim().toUpperCase().replace(/\s+/g, " ");
    const TALLAS_COMODIN = ["UNITALLA", "POR DEFINIR"];
    const esTallaComodin = (nombre) => TALLAS_COMODIN.includes(normTalla(nombre));
    const buscaTallaComodin = (preferida) => {
      const porNombre = (n) =>
        (tallas || []).find((t) => normTalla(t.name || t.nombre) === n);
      return (
        (preferida && porNombre(normTalla(preferida))) ||
        porNombre("UNITALLA") ||
        porNombre("POR DEFINIR") ||
        null
      );
    };

    const origPorArtColor = {};
    Object.entries(inputFieldsTrabajo || {}).forEach(([sucursalOrigen, gruposOrig]) => {
      Object.entries(gruposOrig || {}).forEach(([claveOrig, itemsOriginales]) => {
        const itemsOrig = Array.isArray(itemsOriginales) ? itemsOriginales : [];
        itemsOrig.forEach((item) => {
          const artId = normalizaId(item.articuloId);
          if (!artId) return;
          const areaId = normalizaId(item.areaId || item.areasClientes);
          const key = `${artId}||${areaId}`;
          if (!origPorArtColor[key]) {
            origPorArtColor[key] = {
              cantidad: 0,
              base: item,
              sucursal: sucursalOrigen,
              clave: claveOrig,
            };
          }
          origPorArtColor[key].cantidad += Number(item.cantidad || 0);
          // Recuerda con qué comodín se capturó (UNITALLA o POR DEFINIR)
          if (!origPorArtColor[key].tallaComodin && esTallaComodin(item.nombreTalla)) {
            origPorArtColor[key].tallaComodin = normTalla(item.nombreTalla);
          }
          if (!origPorArtColor[key].base?.id && item.id) {
            origPorArtColor[key].base = item;
            origPorArtColor[key].sucursal = sucursalOrigen;
            origPorArtColor[key].clave = claveOrig;
          }
        });
      });
    });

    const newPorArtColor = {};
    const destinoPorArtColor = {};
    Object.entries(nuevoAgrupado || {}).forEach(([sucursalNew, gruposNew]) => {
      Object.entries(gruposNew || {}).forEach(([claveNew, itemsNew]) => {
        (itemsNew || []).forEach((item) => {
          const artId = normalizaId(item.articuloId);
          const areaId = normalizaId(item.areaId || item.areasClientes);
          const key = `${artId}||${areaId}`;
          newPorArtColor[key] =
            (newPorArtColor[key] || 0) + Number(item.cantidad || 0);
          if (!destinoPorArtColor[key]) {
            destinoPorArtColor[key] = {
              sucursal: sucursalNew,
              clave: claveNew,
              ref: item,
            };
          }
        });
      });
    });

    const restantesPorArtColor = {};
    let totalRestante = 0;
    Object.entries(origPorArtColor).forEach(([key, info]) => {
      const restante =
        Number(info.cantidad || 0) - Number(newPorArtColor[key] || 0);
      if (restante > 0) {
        restantesPorArtColor[key] = restante;
        totalRestante += restante;
      }
    });

    let mensajeRestante = "";
    if (totalRestante > 0) {
      const resp = await Swal.fire({
        title: "Prendas restantes",
        html: `La distribución por colaboradores/tallas quedó <b>${totalRestante}</b> prenda(s) por debajo de la cantidad original del pedido.<br/><br/>¿Qué deseas hacer con las restantes?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Dejar en UNITALLA / POR DEFINIR",
        cancelButtonText: "Quitar",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      if (resp.isConfirmed) {
        // El destino se resuelve POR ARTÍCULO/ÁREA: se respeta el comodín con el
        // que se capturó (UNITALLA o POR DEFINIR) y, si no traía, se usa el que
        // exista en el catálogo.
        let agregadasComodin = 0;
        let sinComodin = 0;
        const usados = new Set();

        Object.entries(restantesPorArtColor).forEach(([key, restante]) => {
          const info = origPorArtColor[key];
          if (!info) return;

          const tallaDestino = buscaTallaComodin(info.tallaComodin);
          if (!tallaDestino?._id) {
            sinComodin += Number(restante || 0);
            return;
          }

          const tallaDestinoId = String(tallaDestino._id);
          const tallaDestinoNombre =
            getNombreTallaConVariante(tallaDestino) ||
            info.tallaComodin ||
            "UNITALLA";
          usados.add(normTalla(tallaDestino.name || tallaDestino.nombre));

          const dest = destinoPorArtColor[key] || {
            sucursal: info.sucursal,
            clave: info.clave,
            ref: info.base,
          };
          const refItem = dest.ref || info.base;
          if (!refItem) return;

          const precio = parseFloat(refItem.precio || info.base?.precio || 0);

          const itemComodin = {
            ...refItem,
            id: null,
            esNuevo: true,
            tempKey: buildTempKey({
              articuloId: refItem.articuloId,
              colorId: refItem.colores,
              tallaId: tallaDestinoId,
              areaId: refItem.areaId || refItem.areasClientes,
              departamentoId: refItem.departamentoId,
              subDepartamentoId: refItem.subDepartamentoId,
              sucursalId: refItem.sucursalId,
            }),
            tallas: tallaDestinoId,
            nombreTalla: tallaDestinoNombre,
            cantidad: restante,
            total: restante * precio,
            precio,
            pendiente_surtir: restante,
            pendienteCortar: restante,
            cantidad_procesos: restante,
          };

          upsertItem(dest.sucursal, dest.clave, itemComodin);
          agregadasComodin += Number(restante || 0);
        });

        if (agregadasComodin > 0) {
          mensajeRestante = `\n\nSe dejaron ${agregadasComodin} prenda(s) en ${
            [...usados].join(" / ") || "UNITALLA"
          }.`;
        }
        if (sinComodin > 0) {
          mensajeRestante += `\n\nAviso: no se encontró la talla UNITALLA ni POR DEFINIR en el catálogo, el sobrante (${sinComodin}) no se agregó.`;
        }
      } else {
        mensajeRestante = `\n\nSe quitaron ${totalRestante} prenda(s) restantes.`;
      }
    }

    Object.keys(nuevoAgrupado).forEach((sucursal) => {
      Object.keys(nuevoAgrupado[sucursal] || {}).forEach((clave) => {
        nuevoAgrupado[sucursal][clave] = (nuevoAgrupado[sucursal][clave] || [])
          .filter((item) => Number(item.cantidad || 0) > 0)
          .sort((a, b) => {
            const colorCompare = String(a.nombreColor || "").localeCompare(
              String(b.nombreColor || ""),
              "es",
              { sensitivity: "base" }
            );

            if (colorCompare !== 0) return colorCompare;

            return String(a.nombreTalla || "").localeCompare(
              String(b.nombreTalla || ""),
              "es",
              { sensitivity: "base", numeric: true }
            );
          });

        if (!nuevoAgrupado[sucursal][clave].length) {
          delete nuevoAgrupado[sucursal][clave];
        }
      });

      if (!Object.keys(nuevoAgrupado[sucursal] || {}).length) {
        delete nuevoAgrupado[sucursal];
      }
    });

    let totalFinalDespuesFiltro = 0;

    Object.values(nuevoAgrupado || {}).forEach((grupos) => {
      Object.values(grupos || {}).forEach((items) => {
        (items || []).forEach((item) => {
          totalFinalDespuesFiltro += Number(item.cantidad || 0);
        });
      });
    });

    const totalEsperado = Object.values(auditoria.esperadoPorCombo).reduce(
      (acc, n) => acc + Number(n || 0),
      0
    );

    // (2026-08) Renglones que ya existían en la base y que la redistribución ya
    // no genera (típicamente el comodín UNITALLA / POR DEFINIR del que salió el
    // reparto). savePedido solo escribe lo que está en inputFields, así que sin
    // esta lista se quedaban en la base con su cantidad original y las piezas
    // terminaban contadas dos veces (el comodín + las tallas repartidas).
    const idsDeAgrupado = (agrupado) => {
      const ids = new Set();
      Object.values(agrupado || {}).forEach((grupos) =>
        Object.values(grupos || {}).forEach((items) =>
          (items || []).forEach((it) => {
            if (it?.id) ids.add(String(it.id));
          })
        )
      );
      return ids;
    };

    const idsPrevios = idsDeAgrupado(inputFieldsTrabajo);
    const idsFinales = idsDeAgrupado(nuevoAgrupado);
    setIdsPorCerrar([...idsPrevios].filter((id) => !idsFinales.has(id)));

    setInputFields(nuevoAgrupado);
    recalcularTotalesEditDesdeAgrupado(nuevoAgrupado);
    recalcularTotalesAgrupados(nuevoAgrupado);

    setDetalleEditPedido([]);
    setGrupoSeleccionadoEdit(null);

    const nuevoResumen = [];

    Object.entries(nuevoAgrupado || {}).forEach(([sucursalNombre, grupos]) => {
      Object.entries(grupos || {}).forEach(([clave, items]) => {
        const itemsArray = Array.isArray(items) ? items : [];
        if (!itemsArray.length) return;

        const base = itemsArray[0];
        const [areaNombre, articuloNombre] = String(clave || "").split("||");

        const cantidad = itemsArray.reduce(
          (sum, x) => sum + Number(x.cantidad || 0),
          0
        );

        const total = itemsArray.reduce(
          (sum, x) => sum + Number(x.total || 0),
          0
        );

        nuevoResumen.push({
          key: `${base.sucursalId}||${base.areaId || base.areasClientes}||${
            base.articuloId
          }`,
          sucursalId: base.sucursalId || "",
          sucursal: sucursalNombre,
          areaId: base.areaId || base.areasClientes || "",
          area: areaNombre || "Sin Área",
          articuloId: base.articuloId || "",
          articulo: articuloNombre || base.articuloNombre || "Sin Artículo",
          cantidad,
          total,
        });
      });
    });

    nuevoResumen.sort((a, b) => {
      const s = String(a.sucursal || "").localeCompare(
        String(b.sucursal || ""),
        "es",
        { sensitivity: "base" }
      );

      if (s !== 0) return s;

      const ar = String(a.area || "").localeCompare(String(b.area || ""), "es", {
        sensitivity: "base",
      });

      if (ar !== 0) return ar;

      return String(a.articulo || "").localeCompare(
        String(b.articulo || ""),
        "es",
        { sensitivity: "base" }
      );
    });

    setResumenEditPedido(nuevoResumen);

    Swal.fire(
      "Actualizado",
      `Se reconstruyó el pedido con las tallas de colaboradores.\n\nTotal esperado: ${totalEsperado}\nTotal final: ${totalFinalDespuesFiltro}\nDiferencia: ${
        totalEsperado - totalFinalDespuesFiltro
      }${mensajeRestante}`,
      "success"
    );
  } catch (err) {
    console.log(err);
    Swal.fire(
      "Error",
      "No se pudieron actualizar las tallas del pedido",
      "error"
    );
  } finally {
    setActualizandoPorTallas(false);
  }
}

function handleGroupedInputChange(sucursal, clave, idx, campo, valor) {
  setInputFields((prev) => {
    const nuevo = { ...prev };

    // Clonar fila modificada
    const fila = { ...nuevo[sucursal][clave][idx], [campo]: valor };

    // Recalcular total
    fila.cantidad = Number.isFinite(Number(fila.cantidad)) ? Number(fila.cantidad) : 0;
    fila.precio = Number.isFinite(Number(fila.precio)) ? Number(fila.precio) : 0;
    fila.total = parseFloat((fila.cantidad * fila.precio).toFixed(2));

    // Reemplazar la fila modificada
    nuevo[sucursal][clave][idx] = fila;

    // Aplanar todo para recalcular totales globales
    const flat = Object.values(nuevo)
      .flatMap((grupos) => Object.values(grupos).flat());

    const nuevaCantidad = flat.reduce((acc, f) => acc + (parseFloat(f.cantidad) || 0), 0);
    const nuevoTotal = flat.reduce((acc, f) => acc + (parseFloat(f.total) || 0), 0);

    setTotalCantidadEdit(nuevaCantidad);
    setTotalGeneralEdit(parseFloat(nuevoTotal.toFixed(2)));

    return nuevo;
  });
}

function handleAddColorTalla(sucursal, clave, itemBase) {
  setInputFields((prev) => {
    const nuevo = { ...prev };
    const items = [...(nuevo[sucursal][clave] || [])];

    const nuevaFila = {
      ...itemBase,
      id: "",
      tempKey: uuidv4(),

      colores: "",
      nombreColor: "",
      tallas: "",
      nombreTalla: "",

      cantidad: 0,
      surtido: 0,
      pendiente_surtir: 0,
      pendienteCortar: 0,
      cortado: 0,
      cantidad_procesos: 0,
      total: 0,
    };

    items.push(nuevaFila);
    nuevo[sucursal][clave] = items;

    return nuevo;
  });
}

  function ActualizaTotales() {
    let cantidadExistentes = articulosPedido.map((c) => parseFloat(c.cantidad));
    let cantidadNuevos = inputFields.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosPedido.map((c) => parseFloat(c.total));
    let importesNuevos = inputFields.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  }

// (2026-10) `renglones` permite guardar justo después de armar los renglones
// (Agregar artículo) sin esperar a que React actualice inputFields.
const savePedido = async (event, renglones) => {
  if (event) event.preventDefault();
  const gruposPorGuardar = renglones || inputFields;
  setValidaBoton(false);
  toggleProgreso();

  const URL_PEDIDOS_EDIT = `${process.env.REACT_APP_URL_PEDIDOS}/${idEdit}`;

  const toNumber = (val) => {
    const n = Number(val);
    return Number.isFinite(n) ? n : 0;
  };

  const toStr = (val) =>
    val === null || val === undefined ? "" : String(val);

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  try {
    // 1. Guardar SOLO los grupos editados/cargados en inputFields
    for (const [sucursal, grupos] of Object.entries(gruposPorGuardar || {})) {
      for (const [clave, items] of Object.entries(grupos || {})) {
        const itemBaseGrupo =
          (items || []).find((x) => x.id) || (items || [])[0] || {};

        for (const a of items || []) {
          const cantidad = toNumber(a.cantidad);
          const precio = toNumber(a.precio ?? itemBaseGrupo.precio ?? 0);
          const total = Number((cantidad * precio).toFixed(2));

          const payload = {
            pedidos: toStr(idEdit),
            articulos: toStr(a.articuloId || itemBaseGrupo.articuloId),
            colores: toStr(a.colores || itemBaseGrupo.colores),
            tallas: toStr(a.tallas || itemBaseGrupo.tallas),
            resurtido: toStr(a.resurtido || itemBaseGrupo.resurtido || "Si"),

            cantidad,
            surtido: toNumber(a.surtido ?? itemBaseGrupo.surtido ?? 0),
            pendiente_surtir: cantidad,
            precio,
            descuento: toNumber(a.descuento ?? itemBaseGrupo.descuento ?? 0),
            total,

            pendienteCortar: cantidad,
            cortado: toNumber(a.cortado ?? itemBaseGrupo.cortado ?? 0),
            precioEtiqueta: toNumber(
              a.precioEtiqueta ?? itemBaseGrupo.precioEtiqueta ?? 0
            ),
            codigoBarras: toNumber(
              a.codigoBarras ?? itemBaseGrupo.codigoBarras ?? 0
            ),

            codigoCliente: toStr(
              a.codigoCliente || itemBaseGrupo.codigoCliente || "NA"
            ),

            sociedades: toStr(
              a.sociedades ||
                itemBaseGrupo.sociedades ||
                selectedEmpresaEdit ||
                "6775c905d688145c579d8393"
            ),

            areasClientes: toStr(
              a.areaId ||
                a.areasClientes ||
                itemBaseGrupo.areaId ||
                itemBaseGrupo.areasClientes
            ),

            sucursales: toStr(
              a.sucursalId || itemBaseGrupo.sucursalId
            ),

            tela: toStr(a.tela || itemBaseGrupo.tela || "NA"),

            proveedorTela: toStr(
              a.proveedorTela ||
                itemBaseGrupo.proveedorTela ||
                "NA"
            ),

            composicion: toStr(
              a.composicion || itemBaseGrupo.composicion || "NA"
            ),

            observacionesArticulo: toStr(
              a.observacionesArticulo ||
                itemBaseGrupo.observacionesArticulo ||
                "NA"
            ),

            procesos: Array.isArray(a.procesos)
              ? a.procesos
              : Array.isArray(itemBaseGrupo.procesos)
              ? itemBaseGrupo.procesos
              : [],

            cantidad_procesos: toNumber(
              a.cantidad_procesos ?? itemBaseGrupo.cantidad_procesos ?? 0
            ),

            bordados: Array.isArray(a.bordados)
              ? a.bordados
              : Array.isArray(itemBaseGrupo.bordados)
              ? itemBaseGrupo.bordados
              : [],
          };

          if (!payload.articulos || !payload.colores || !payload.tallas) {
            console.log("Fila incompleta, no se guarda:", payload, a);
            continue;
          }

          if (a.id) {
            await axios.patch(`${URL_ARTICULOS_PEDIDO}/${a.id}`, payload, {
              headers,
            });
          } else {
            await axios.post(URL_ARTICULOS_PEDIDO, payload, {
              headers,
            });
          }
        }
      }
    }

    // 1b. (2026-08) Cerrar en 0 los renglones que la redistribución por tallas
    // dejó fuera. Si no, se quedan en la base con su cantidad vieja y las piezas
    // salen duplicadas (el caso del comodín UNITALLA en el PDFOC).
    const idsGuardados = new Set();
    Object.values(gruposPorGuardar || {}).forEach((grupos) =>
      Object.values(grupos || {}).forEach((items) =>
        (items || []).forEach((it) => {
          if (it?.id) idsGuardados.add(String(it.id));
        })
      )
    );

    const porCerrar = (idsPorCerrar || []).filter(
      (id) => !idsGuardados.has(String(id))
    );

    for (const id of porCerrar) {
      await axios.patch(
        `${URL_ARTICULOS_PEDIDO}/${id}`,
        {
          cantidad: 0,
          pendiente_surtir: 0,
          pendienteCortar: 0,
          total: 0,
          cantidad_procesos: 0,
        },
        { headers }
      );
    }
    setIdsPorCerrar([]);

    // 2. Traer TODO el detalle actualizado del pedido
    const resDetalle = await axios.get(
      `${URL_ARTICULOS_PEDIDO}/pedidos/${idEdit}`,
      { headers }
    );

    const articulosActualizados = Array.isArray(resDetalle.data)
      ? resDetalle.data
      : [];

    // 3. Recalcular encabezado con TODOS los artículos del pedido
    const totalCantidadFinal = articulosActualizados.reduce(
      (sum, x) => sum + toNumber(x.cantidad),
      0
    );

    const totalGeneralFinal = articulosActualizados.reduce((sum, x) => {
      const cantidad = toNumber(x.cantidad);
      const precio = toNumber(x.precio);
      return sum + Number((cantidad * precio).toFixed(2));
    }, 0);

    // 4. Guardar encabezado correcto
    await axios.patch(
      URL_PEDIDOS_EDIT,
      {
        total_piezas: totalCantidadFinal,
        pendiente_surtir: totalCantidadFinal,
        total_general: Number(totalGeneralFinal.toFixed(2)),
        editado: "Si",
      },
      { headers }
    );

    // 5. Actualizar totales visuales
    setTotalCantidadEdit(totalCantidadFinal);
    setTotalGeneralEdit(Number(totalGeneralFinal.toFixed(2)));

    await axios.post(
      URL_LOGS,
      {
        tipo: "Editar Pedido",
        detalle: `${numero_pedido}`,
        user: user.id,
      },
      { headers }
    );

    // (2026-08) Sin window.location.reload(): se rearma el modal (resumen +
    // detalle + inputFields con los _id nuevos) y se actualiza el renglón del
    // pedido en la tabla, todo desde el detalle que ya trajimos.
    refrescarEdicionDesdeDetalle(articulosActualizados);

    // Los renglones de la tabla usan `cantidad` (= total_piezas) y `total_general`
    const parcheaPedido = (p) =>
      String(p._id) === String(idEdit)
        ? {
            ...p,
            cantidad: totalCantidadFinal,
            pendiente_surtir: totalCantidadFinal,
            total_general: Number(totalGeneralFinal.toFixed(2)),
            precioPrenda: totalCantidadFinal
              ? Number(totalGeneralFinal) / totalCantidadFinal
              : 0,
          }
        : p;

    setComments((prev) => (prev || []).map(parcheaPedido));
    setPedidos((prev) => (prev || []).map(parcheaPedido));

    setModalDetalleGrupo(false);

    Swal.fire("¡Éxito!", "Pedido editado correctamente", "success");
  } catch (error) {
    console.log(error);

    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudo guardar el pedido",
      footer: error?.response?.data?.message || error?.response?.data || "",
    });
  } finally {
    setModalProgreso(false);
    setValidaBoton(true);
  }
};

  function abierto(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se Abrira!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Abrir!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_PEDIDOS}/${id}`,
            {
              status: "Abierto",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                `${URL_ARTICULOS_PEDIDO}/baja/${id}`,
                {
                  is_active: "Si",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                const newComments = comments.map((i) => {
                  if (id === i._id) {
                    i.status = "Abierto";
                  }
                  return i;
                });
                setComments(newComments);

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se Abrió",
                  showConfirmButton: false,
                  timer: 2000,
                });
                // setTimeout(() => {
                //   // window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function cerrar(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se Cerrara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cerrar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_PEDIDOS}/${id}`,
            {
              status: "Cerrado",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                `${URL_ARTICULOS_PEDIDO}/baja/${id}`,
                {
                  is_active: "No",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                const newComments = comments.map((i) => {
                  if (id === i._id) {
                    i.status = "Cerrado";
                  }
                  return i;
                });
                setComments(newComments);

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se Cerró",
                  showConfirmButton: false,
                  timer: 2000,
                });

                // setTimeout(() => {
                //   // window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function ordenCorteSi(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se Cerrara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cerrar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_PEDIDOS}/${id}`,
            {
              ordenCorte: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se Cerró",
                  showConfirmButton: false,
                  timer: 2000,
                });

                // setTimeout(() => {
                //   // window.location.reload();
                // }, 1000);

          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function ordenCorteNo(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se Cerrara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cerrar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_PEDIDOS}/${id}`,
            {
              ordenCorte: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se Cerró",
                  showConfirmButton: false,
                  timer: 2000,
                });

                // setTimeout(() => {
                //   // window.location.reload();
                // }, 1000);

          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  // async function requisicion(id, numero) {
  //   setExplosion([]);
  //   setExplosionHab([]);
  //   toggleProgreso();
  //   setIdEdit(id);
  //   setNumeroPedido(numero);
  //   axios
  //     .get(`${URL_ARTICULOS_PEDIDO}/pedidos/${id}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then(async (response) => {
  //       let allArticulosPedido = response.data;
  //       let arrayTabla = await allArticulosPedido
  //         .map((a) => {
  //           return {
  //             id: a._id,
  //             activo: a.is_active,
  //             articulos: a.articulos[0]._id,
  //             articulosCodigo: a.articulos[0].codigo,
  //             colores: a.colores[0]._id,
  //             coloresName: a.colores[0].name,
  //             tallas: a.tallas[0]._id,
  //             tallasName: a.tallas[0].name,
  //             cantidad: a.cantidad,
  //             surtido: a.surtido,
  //             pendiente_surtir: a.pendiente_surtir,
  //           };
  //         })
  //         .filter(function (el) {
  //           return el != null;
  //         });

  //       let data = Object.values(arrayTabla);

  //       let agrupado = data.reduce(function (groups, item) {
  //         const val = item["articulos"];
  //         groups[val] = groups[val] || {
  //           articulos: item.articulos,
  //           cantidad: 0,
  //         };
  //         groups[val].cantidad += item.cantidad;
  //         groups[val].articulos = item.articulos;
  //         groups[val].articulosCodigo = item.articulosCodigo;
  //         return groups;
  //       }, []);

  //       let dataFinal = Object.values(agrupado);

  //       let agrupadoColores = data.reduce(function (groups, item) {
  //         const val = item["articulos"] + item["colores"];
  //         groups[val] = groups[val] || {
  //           articulos: item.articulos,
  //           colores: item.colores,
  //           cantidad: 0,
  //         };
  //         groups[val].cantidad += item.cantidad;
  //         groups[val].articulos = item.articulos;
  //         groups[val].articulosCodigo = item.articulosCodigo;
  //         groups[val].colores = item.colores;
  //         groups[val].coloresName = item.coloresName;
  //         return groups;
  //       }, []);

  //       let dataFinalColores = Object.values(agrupadoColores);

  //       let temp2 = [];
  //       let temp3 = [];

  //       let exp = await dataFinal.map((a) => {
  //         axios
  //           .get(`${URL_EXPLOSION}Articulo/${a.articulos}`, {
  //             headers: {
  //               Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //             },
  //           })
  //           .then((response) => {
  //             let allExplosion = response.data;
  //             let arrayExp = allExplosion
  //               .map((b) => {
  //                 if (b.habilitacion != "") {
  //                   temp2.push({
  //                     // articulos: a.articulos,
  //                     // articulosCodigo: a.articulosCodigo,
  //                     material: b.habilitacion[0].nombre,
  //                     cantidad: b.cantidad * a.cantidad,
  //                     colores: "NA",
  //                     coloresName: "NA",
  //                     tipo: "Habilitacion",
  //                     observaciones: b.observaciones,
  //                   });
  //                 }
  //               })
  //               .filter(function (el) {
  //                 return el != null;
  //               });
  //           })
  //           .catch((err) => {
  //             console.log(err);
  //           });
  //       });

  //       let expColores = await dataFinalColores.map((a) => {
  //         axios
  //           .get(`${URL_EXPLOSION}Articulo/${a.articulos}`, {
  //             headers: {
  //               Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //             },
  //           })
  //           .then((response) => {
  //             let allExplosion = response.data;
  //             let arrayExp = allExplosion
  //               .map((b) => {
  //                 if (b.telas != "") {
  //                   temp3.push({
  //                     articulos: a.articulos,
  //                     articulosCodigo: a.articulosCodigo,
  //                     material:
  //                       b.telas[0].nombre +
  //                       " / " +
  //                       b.telas[0].tiposTelas[0].name,
  //                     cantidad: b.cantidad * a.cantidad,
  //                     colores: a.colores,
  //                     coloresName: a.coloresName,
  //                     tipo: "Tela",
  //                     observaciones: b.observaciones,
  //                   });
  //                 }
  //               })
  //               .filter(function (el) {
  //                 return el != null;
  //               });
  //           })
  //           .catch((err) => {
  //             console.log(err);
  //           });
  //       });
  //       setExplosion(temp3);
  //       setExplosionHab(temp2);
  //       setTimeout(() => {
  //         setModalProgreso(false);
  //         toggleExplosion();
  //       }, 3500);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }

  // async function requisicionGlobal(id, idArticulo, numero) {
  //   setInputFieldsTelaGlobal([
  //     {
  //       id: uuidv4(),
  //       idTela: "",
  //       idColor: "",
  //       cantidad: 0,
  //       cantidadPrenda: 0,
  //       observaciones: "NA",
  //     },
  //   ]);
  //   setExplosionGlobalExistente([]);
  //   setIdEdit(id);
  //   setIdExplosion(idArticulo);
  //   setNumeroPedido(numero);

  //   axios
  //     .get(`${URL_EXPLOSION_GLOBAL}Pedido/${id}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allExplosion = response.data;
  //       let arrayExp = allExplosion
  //         .map((a) => {
  //           return {
  //             _id: a._id,
  //             idTela: a.telas[0]._id,
  //             tela: a.telas[0].nombre,
  //             idColor: a.colores[0]._id,
  //             color: a.colores[0].name,
  //             cantidad: a.cantidad,
  //             cantidadPrenda: a.cantidadPrenda,
  //             observaciones: a.observaciones,
  //           };
  //         })
  //         .filter(function (el) {
  //           return el != null;
  //         });
  //       setExplosionGlobalExistente(arrayExp);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });

  //   toggleExplosionGlobal();
  // }

  const handleChangeInputExistenteGlobal = (id, event) => {
    const newExplosionGlobalExistentes = explosionGlobalExistente.map((i) => {
      if (id === i._id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setExplosionGlobalExistente(newExplosionGlobalExistentes);
  };

  const handleChangeInputTelaGlobal = (id, event) => {
    const newInputFieldsTela = inputFieldsTelaGlobal.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsTelaGlobal(newInputFieldsTela);
  };

  const handleRemoveFieldsTelasGlobal = (id) => {
    const values = [...inputFieldsTelaGlobal];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsTelaGlobal(values);
  };

  const handleAddFieldsTelasGlobal = () => {
    setInputFieldsTelaGlobal([
      ...inputFieldsTelaGlobal,
      {
        id: uuidv4(),
        idTela: "",
        idColor: "",
        cantidad: 0,
        cantidadPrenda: 0,
        observaciones: "NA",
      },
    ]);
  };

const abrirChecklistAutorizacion = (idPedido) => {
  setIdPedidoEditando(idPedido);
  setChecks({
    Etiquetas: false,
    Tallas: false,
    Observaciones: false,
    Bordados: false,
    Modelos: false,
  });
  setModalCheck(true);
};


const autorizarPedido = async () => {
  try {
    const URL = `${process.env.REACT_APP_URL_PEDIDOS}/${idPedidoEditando}`;

    const res = await axios.patch(
      URL,
      {
        autorizacionVarios: "Si",
        // T8 (2026-06) — registrar quién autorizó
        autorizacionVariosColaborador: [user.id],
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    // Actualizar estado local de pedidos
    setComments((prev) =>
      prev.map((p) =>
        p._id === idPedidoEditando
          ? {
              ...p,
              autorizacionVarios: "Si",
              autorizacionVariosColaborador: user.nombre || user.name || "",
            }
          : p
      )
    );

    Swal.fire("Autorizado", "El pedido fue autorizado con éxito", "success");
    setModalCheck(false);
  } catch (error) {
    console.error(error);
    Swal.fire("Error", "No se pudo autorizar el pedido", "error");
  }
}

const cambiarAutorizacionDirecto = async (id, nuevoValor) => {
  try {
    const URL = `${process.env.REACT_APP_URL_PEDIDOS}/${id}`;
    await axios.patch(
      URL,
      {
        autorizacionVarios: nuevoValor,
        // T8 (2026-06) — al des-autorizar, limpiar quien autorizó
        autorizacionVariosColaborador: [],
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    setComments((prev) =>
      prev.map((p) =>
        p._id === id
          ? { ...p, autorizacionVarios: "No", autorizacionVariosColaborador: "" }
          : p
      )
    );

    Swal.fire(
      "Actualizado",
      `El pedido fue marcado como "${nuevoValor}"`,
      "success"
    );
  } catch (error) {
    console.error(error);
    Swal.fire("Error", "No se pudo actualizar el pedido", "error");
  }
}

// L96 (2026-06) — toggle Autorización Dirección
const toggleAutorizacionDireccion = async (id, nuevoValor) => {
  try {
    const URL = `${process.env.REACT_APP_URL_PEDIDOS}/${id}`;
    await axios.patch(
      URL,
      {
        autorizacionDireccion: nuevoValor,
        autorizacionDireccionColaborador: nuevoValor === "Si" ? [user.id] : [],
        autorizacionDireccionFecha:
          nuevoValor === "Si" ? moment().format("YYYY-MM-DD") : "",
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    setComments((prev) =>
      prev.map((p) =>
        p._id === id
          ? {
              ...p,
              autorizacionDireccion: nuevoValor,
              autorizacionDireccionColaborador:
                nuevoValor === "Si" ? user.nombre || user.name || "" : "",
            }
          : p
      )
    );

    Swal.fire(
      "Actualizado",
      nuevoValor === "Si"
        ? "Dirección autorizada"
        : "Se quitó la autorización de Dirección",
      "success"
    );
  } catch (error) {
    console.error(error);
    Swal.fire("Error", "No se pudo actualizar la autorización de Dirección", "error");
  }
};



  function saveExplosionGlobal() {
    setValidaBoton(false);
    toggleProgreso();

    let totalExplosion =
      inputFieldsTelaGlobal.length + explosionGlobalExistente.length;

    inputFieldsTelaGlobal.map((a) => {
      if ((a.idTela != "") & (a.cantidad > 0)) {
        axios
          .post(
            URL_EXPLOSION_GLOBAL,
            {
              articulos: idExplosion,
              pedidos: idEdit,
              telas: a.idTela,
              colores: a.idColor,
              cantidad: a.cantidad,
              cantidadPrenda: a.cantidadPrenda,
              tipo: "Tela",
              observaciones: a.observaciones,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            totalExplosion = totalExplosion - 1;
            if (totalExplosion == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Agregar Explosion",
                    detalle: `${idExplosion} ${a.idTela}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Actualizado con Exito",
                    showConfirmButton: false,
                    timer: 2000,
                  });
                  setTimeout(() => {
                    setModalExplosionGlobal(false);
                    setModalProgreso(false);
                    setValidaBoton(true);
                  }, 1000);
                });
            }
          });
      } else {
        totalExplosion = totalExplosion - 1;
      }
    });

    explosionGlobalExistente.map((a) => {
      axios
        .patch(
          `${URL_EXPLOSION_GLOBAL}/${a._id}`,
          {
            cantidad: a.cantidad,
            cantidadPrenda: a.cantidadPrenda,
            observaciones: a.observaciones,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          totalExplosion = totalExplosion - 1;
          if (totalExplosion == 0) {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Editar Explosion",
                  detalle: `${idExplosion}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Actualizado con Exito",
                  showConfirmButton: false,
                  timer: 2000,
                });
                setTimeout(() => {
                  setModalExplosionGlobal(false);
                  setModalProgreso(false);
                  setValidaBoton(true);
                }, 1000);
              });
          }
        });
    });
  }

  function jalaFoto(idEdit) {
    setPhoto("");
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${idEdit}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        if (data.data.version) {
          setPhoto(data.data.version);
        }
      })
      .catch((err) => console.log(err));

    setIdEdit(idEdit);
    toggleFoto();
  }

  async function coloresInfo(idArticulo, codigo, descripcion, coloresInfo) {
    setArrayColores([]);
    await axios
      .get(`${URL_ARTICULOS}/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;

        let ids = allClientes.colores.map(function (e) {
          return e._id;
        });
        let coloresDany = Object.values(ids);
        setArrayColores(coloresDany);

        setIdColoresArticulos(idArticulo);
        setCodigo(codigo);
        setDescripcion(descripcion);

        toggleColores();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function coloresSeleccionados(checked, idColor) {
    if (checked) {
      arrayColores.push(idColor);
      console.log(arrayColores);
    } else {
      const index = arrayColores.indexOf(idColor);
      if (index > -1) {
        arrayColores.splice(index, 1);
        console.log(arrayColores);
      }
    }
  }

  function guardarColores() {
    const URL_ARTICULOS_COLORES = `${process.env.REACT_APP_URL_ARTICULOS}/${idColoresArticulos}`;
    axios
      .patch(
        URL_ARTICULOS_COLORES,
        {
          colores: arrayColores,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Colores Articulo",
            detalle: `${codigo}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Actualizado con Exito",
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          setModalColores(false);
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  async function tallasInfo(idArticulo, codigo, descripcion, tallasInfo) {
    setArrayTallas([]);
    await axios
      .get(`${URL_ARTICULOS}/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;

        let ids = allClientes.tallas.map(function (e) {
          return e._id;
        });
        let tallasDany = Object.values(ids);
        setArrayTallas(tallasDany);

        setIdTallasArticulos(idArticulo);
        setCodigo(codigo);
        setDescripcion(descripcion);

        toggleTallas();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function tallasSeleccionados(checked, idColor) {
    if (checked) {
      arrayTallas.push(idColor);
      console.log(arrayTallas);
    } else {
      const index = arrayTallas.indexOf(idColor);
      if (index > -1) {
        arrayTallas.splice(index, 1);
        console.log(arrayTallas);
      }
    }
  }

  function guardarTallas() {
    const URL_ARTICULOS_TALLAS = `${process.env.REACT_APP_URL_ARTICULOS}/${idTallasArticulos}`;
    axios
      .patch(
        URL_ARTICULOS_TALLAS,
        {
          tallas: arrayTallas,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Tallas Articulo",
            detalle: `${codigo}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Actualizado con Exito",
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          setModalTallas(false);
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  async function catalogoProcesosInfo(
    idArticulo,
    codigo,
    descripcion,
    catalogoProcesosInfo
  ) {
    setArrayCatalogoProcesos([]);

    await axios
      .get(`${URL_ARTICULOS}/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;

        let ids = allClientes.catalogoProcesos.map(function (e) {
          return e._id;
        });
        let catalogoProcesosDany = Object.values(ids);
        setArrayCatalogoProcesos(catalogoProcesosDany);

        setIdCatalogoProcesosArticulos(idArticulo);
        setCodigo(codigo);
        setDescripcion(descripcion);

        toggleCatalogoProcesos();
      })
      .catch((err) => {
        console.log(err);
      });

    // let ids = catalogoProcesosInfo.map(function (e) {
    //   return e._id;
    // });
    // let catalogoProcesosDany = Object.values(ids);

    // setIdCatalogoProcesosArticulos(idCatalogoProcesos);
    // setCodigo(codigo);
    // setDescripcion(descripcion);
    // setArrayCatalogoProcesos(catalogoProcesosDany);
    // toggleCatalogoProcesos();
  }

  function catalogoProcesosSeleccionados(checked, idCatalogoProceso) {
    if (checked) {
      arrayCatalogoProcesos.push(idCatalogoProceso);
      console.log(arrayCatalogoProcesos);
    } else {
      const index = arrayCatalogoProcesos.indexOf(idCatalogoProceso);
      if (index > -1) {
        arrayCatalogoProcesos.splice(index, 1);
        console.log(arrayCatalogoProcesos);
      }
    }
  }

  function guardarCatalogoProcesos() {
    const URL_ARTICULOS_CATALOGO_PROCESOS = `${process.env.REACT_APP_URL_ARTICULOS}/${idCatalogoProcesosArticulos}`;
    axios
      .patch(
        URL_ARTICULOS_CATALOGO_PROCESOS,
        {
          catalogoProcesos: arrayCatalogoProcesos,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "CatalogoProcesos Articulo",
            detalle: `${codigo}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Actualizado con Exito",
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          setModalCatalogoProcesos(false);
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function explosiones(id, codigo, descripcion) {
    setIdExplosion(id);
    setCodigoExplosion(codigo);
    setDescripcionExplosion(descripcion);

    setInputFieldsHab([
      {
        id: uuidv4(),
        idHab: "",
        cantidad: 0,
        observaciones: "NA",
      },
    ]);
    setInputFieldsTela([
      {
        id: uuidv4(),
        idTela: "",
        cantidad: 0,
        observaciones: "NA",
      },
    ]);

    axios
      .get(`${URL_EXPLOSION}Articulo/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allExplosionExistentes = res.data;
        setExplosionExistentes(allExplosionExistentes);
      })
      .catch((err) => {
        console.log(err);
      });

    toggleExplosiones();
  }

  const handleRemoveFieldsTelas = (id) => {
    const values = [...inputFieldsTela];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsTela(values);
  };

  const handleRemoveFieldsHab = (id) => {
    const values = [...inputFieldsHab];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsHab(values);
  };

  const handleAddFieldsTelas = () => {
    setInputFieldsTela([
      ...inputFieldsTela,
      {
        id: uuidv4(),
        idTela: "",
        cantidad: 0,
        observaciones: "NA",
      },
    ]);
  };

  const handleAddFieldsHab = () => {
    setInputFieldsHab([
      ...inputFieldsHab,
      {
        id: uuidv4(),
        idHab: "",
        cantidad: 0,
        observaciones: "NA",
      },
    ]);
  };

  const handleChangeInputTela = (id, event) => {
    const newInputFieldsTela = inputFieldsTela.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsTela(newInputFieldsTela);
  };

  const handleChangeInputHab = (id, event) => {
    const newInputFieldsHab = inputFieldsHab.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsHab(newInputFieldsHab);
  };

  const handleChangeInputExistente = (id, event) => {
    const newExplosionExistentes = explosionExistentes.map((i) => {
      if (id === i._id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setExplosionExistentes(newExplosionExistentes);
  };

  function saveExplosion() {
    setValidaBoton(false);
    toggleProgreso();

    let totalExplosion =
      inputFieldsHab.length +
      inputFieldsTela.length +
      explosionExistentes.length;

    inputFieldsTela.map((a) => {
      if ((a.idTela != "") & (a.cantidad > 0)) {
        axios
          .post(
            URL_EXPLOSION,
            {
              articulos: idExplosion,
              telas: a.idTela,
              cantidad: a.cantidad,
              tipo: "Tela",
              observaciones: a.observaciones,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            totalExplosion = totalExplosion - 1;
            if (totalExplosion == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Agregar Explosion",
                    detalle: `${idExplosion} ${a.idTela}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Actualizado con Exito",
                    showConfirmButton: false,
                    timer: 2000,
                  });
                  setTimeout(() => {
                    setModalExplosiones(false);
                    setModalProgreso(false);
                    setValidaBoton(true);
                  }, 1000);
                });
            }
          });
      } else {
        totalExplosion = totalExplosion - 1;
      }
    });

    inputFieldsHab.map((a) => {
      if ((a.idHab != "") & (a.cantidad > 0)) {
        axios
          .post(
            URL_EXPLOSION,
            {
              articulos: idExplosion,
              habilitacion: a.idHab,
              cantidad: a.cantidad,
              tipo: "Habilitacion",
              observaciones: a.observaciones,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            totalExplosion = totalExplosion - 1;
            if (totalExplosion == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Agregar Explosion",
                    detalle: `${idExplosion} ${a.idHab}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Actualizado con Exito",
                    showConfirmButton: false,
                    timer: 2000,
                  });
                  setTimeout(() => {
                    setModalExplosiones(false);
                    setModalProgreso(false);
                    setValidaBoton(true);
                  }, 1000);
                });
            }
          });
      } else {
        totalExplosion = totalExplosion - 1;
      }
    });

    explosionExistentes.map((a) => {
      axios
        .patch(
          `${URL_EXPLOSION}/${a._id}`,
          {
            cantidad: a.cantidad,
            observaciones: a.observaciones,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          totalExplosion = totalExplosion - 1;
          if (totalExplosion == 0) {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Editar Explosion",
                  detalle: `${idExplosion}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Actualizado con Exito",
                  showConfirmButton: false,
                  timer: 2000,
                });
                setTimeout(() => {
                  setModalExplosiones(false);
                  setModalProgreso(false);
                  setValidaBoton(true);
                }, 1000);
              });
          }
        });
    });
  }

  function jalaInfoArticulo(
    codigo,
    codigoCliente,
    descripcion,
    venta,
    precioEtiqueta,
    observaciones,
    observacionesProduccion,
    // idMarca,
    idEdit
  ) {
    // console.log(idMarca)
    setCodigoEdit(codigo);
    setCodigoClienteEdit(codigoCliente);
    setDescripcionEdit(descripcion);
    setVentaEdit(venta);
    setPrecioEtiquetaEdit(precioEtiqueta);
    setObservacionesEdit(observaciones);
    setObservacionesProduccionEdit(observacionesProduccion);
    // setSelectedMarcaEdit(idMarca);
    setIdEditArticuloEdit(idEdit);
    toggleEditInfoArticulo();
  }

// (2026-10) Consumos de tela: el modal (ConsumosTelasModal) carga y guarda
// sus propios datos; aquí sólo se abre con el pedido.
async function ConsumoTelas(idOC, numero_pedido, cliente) {
  setIdEdit(idOC);
  setNumeroPedido(numero_pedido);
  setNombreEdit(cliente);
  setModalConsumos(true);
}

async function PDFConsumosPorArticulo(numeroPedido, clienteNombre, idPedido) {
  try {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    // 1. Obtener consumos por pedido
    const { data: consumos } = await axios.get(
      `${URL_CONSUMO_TELAS}Pedido/${idPedido}`,
      { headers }
    );

    if (!consumos.length) {
      return Swal.fire("Sin consumos", "No hay consumos para este pedido", "info");
    }

    // 2. Obtener artículos del pedido
    const { data: articulosPedido } = await axios.get(
      `${URL_ARTICULOS_PEDIDO}/pedidos/${idPedido}`,
      { headers }
    );

    // 3. Construir mapa de cantidades por artículo + color (para multiplicar
    //    el consumo por la cantidad de ese color del artículo)
    const cantidadesPorArticuloColor = {};
    articulosPedido.forEach((ap) => {
  const articuloId = ap.articulos?.[0]?._id || ap.articulos;
  const colorId = ap.colores?.[0]?._id || ap.colores;
  if (articuloId && colorId) {
    const key = `${articuloId}|${colorId}`;
    cantidadesPorArticuloColor[key] =
      (cantidadesPorArticuloColor[key] || 0) + (ap.cantidad || 0);
  }
});

    // 4. Agrupar consumos por artículo
    const agrupado = {};
    consumos.forEach((c) => {
      if ((c.cantidad || 0) <= 0) return; // 👈 filtro directo

      const articuloRaw = Array.isArray(c.articulos) ? c.articulos[0] : c.articulos;
      const telaRaw = Array.isArray(c.telas) ? c.telas[0] : c.telas;
      const colorRaw = Array.isArray(c.colores) ? c.colores[0] : c.colores;

      if (!articuloRaw) return;

      const articuloId = typeof articuloRaw === "object" ? articuloRaw._id : articuloRaw;
      if (!articuloId) return;

      const articuloNombre =
        typeof articuloRaw === "object"
          ? `${articuloRaw.codigo || ""} ${articuloRaw.descripcion || ""}`.trim()
          : "Articulo sin nombre";

      const telaNombre =
        typeof telaRaw === "object" ? telaRaw.nombre || "Sin nombre" : telaRaw || "Sin nombre";

      const ancho =
        typeof telaRaw === "object" ? telaRaw.ancho || "NA" : "NA";

      // color: puede venir poblado o como id suelto → en ese caso buscamos en el catálogo en memoria
      let colorNombre = "NA";
      if (colorRaw) {
        if (typeof colorRaw === "object") colorNombre = colorRaw.name || "NA";
        else colorNombre = colores.find((cc) => cc._id === colorRaw)?.name || "NA";
      }

      // (2026-07) color de la tela (campo aparte)
      const colorTelaRaw = Array.isArray(c.coloresTela)
        ? c.coloresTela[0]
        : c.coloresTela;
      let colorTelaNombre = "NA";
      if (colorTelaRaw) {
        if (typeof colorTelaRaw === "object")
          colorTelaNombre = colorTelaRaw.name || "NA";
        else
          colorTelaNombre =
            colores.find((cc) => cc._id === colorTelaRaw)?.name || "NA";
      }

      // cantidad de este color del artículo (no el total del artículo)
      const colorIdMult = colorRaw
        ? typeof colorRaw === "object"
          ? colorRaw._id
          : colorRaw
        : "";
      const cantidadColor =
        cantidadesPorArticuloColor[`${articuloId}|${colorIdMult}`] || 0;

      const clave = articuloId.toString();

      if (!agrupado[clave]) {
        agrupado[clave] = {
          nombre: articuloNombre,
          consumos: [],
        };
      }

      agrupado[clave].consumos.push({
        color: colorNombre,
        tela: telaNombre,
        colorTela: colorTelaNombre,
        cantidad: c.cantidad || 0,
        observaciones: c.observaciones?.trim() || "NA",
        ancho,
        cantidadColor,
      });
    });

    // 5. Crear PDF
    const doc = new jsPDF();

    // Logos
    const img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 165, 10, 25, 7.5);

    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 165, 18, 25, 14);

    doc.setFontSize(12);
    doc.text(`Consumos del Pedido #${numeroPedido}`, 20, 20);
    doc.text(`Cliente: ${clienteNombre}`, 20, 27);
    doc.setFontSize(10);

    let currentY = 35;
    let totalGlobal = 0;

    for (const idArticulo in agrupado) {
      const grupo = agrupado[idArticulo];

      doc.setFont(undefined, "bold");
      doc.text(`Modelo: ${grupo.nombre}`, 20, currentY);
      currentY += 6;

      const body = grupo.consumos.map((c) => {
        const totalConsumo = (c.cantidad || 0) * (c.cantidadColor || 0);
        totalGlobal += totalConsumo;

        return [
          c.color,
          c.tela,
          c.colorTela,
          c.ancho,
          c.cantidad,
          c.cantidadColor,
          totalConsumo.toFixed(2),
          c.observaciones,
        ];
      });

      // Fila total por artículo
      const totalArticulo = grupo.consumos.reduce(
        (sum, c) => sum + (c.cantidad || 0) * (c.cantidadColor || 0),
        0
      );

      body.push([
        {
          content: "Total",
          colSpan: 6,
          styles: { halign: "right", fontStyle: "bold" },
        },
        totalArticulo.toFixed(2),
        "",
      ]);

      doc.autoTable({
        head: [["Color", "Tela", "Color Tela", "Ancho", "Consumo Unitario", "Cantidad Color", "Total", "Observaciones"]],
        body,
        startY: currentY,
        styles: { fontSize: 10, halign: "center" },
        headStyles: {
          fillColor: [41, 128, 186],
          textColor: [255, 255, 255],
          fontStyle: "bold",
        },
      });

      currentY = doc.autoTable.previous.finalY + 10;
      if (currentY > 260) {
        doc.addPage();
        currentY = 20;
      }
    }

    // 6. Mostrar PDF
    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDF de consumos:", err);
    Swal.fire("Error", "No se pudo generar el PDF de consumos", "error");
  }
}

  function editArticulos(event) {
    event.preventDefault();
    const URL_ARTICULOS_EDIT = `${process.env.REACT_APP_URL_ARTICULOS}/${idEditArticuloEdit}`;
    axios
      .patch(
        URL_ARTICULOS_EDIT,
        {
          codigo: codigoEdit,
          codigoCliente: codigoClienteEdit,
          descripcion: descripcionEdit,
          venta: ventaEdit,
          precioEtiqueta: precioEtiquetaEdit,
          observaciones: observacionesEdit,
          observacionesProduccion: observacionesProduccionEdit,
          // marcas: selectedMarcaEdit,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Articulo",
            detalle: `${codigo}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        // (2026-10) Sin recargar la página: se cierra el modal y se refresca
        // el catálogo de artículos (código/descripción editados).
        setModalEditInfoArticulo(false);
        Swal.fire("Good job!", "Actualizado con exito", "success");
        cargarArticulos();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }


  function desarrollo(){
    axios
      .get(
        `${URL_PEDIDOS}Desarrollo`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
}


async function precosteo(id, numero, idPedido, cantidadPedido) {
  setExplosion([]);
  toggleProgreso();
  setIdEdit(id);
  setNumeroPedido(numero);

  axios
  .get(`${URL_EXPLOSION_GLOBAL}Pedido/${idPedido}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allExplosion = response.data;
    let arrayExp = allExplosion
      .map((a) => {
          return{
            _id: a._id,
            idTela: a.telas[0]._id,
            tela: a.telas[0].nombre,
            idColor: a.colores[0]._id,
            color: a.colores[0].name,
            cantidad: a.cantidad,
            cantidadPrenda: a.cantidadPrenda,
            costo: a.telas[0].costo,
            total: a.telas[0].costo * a.cantidad,
            totalPrenda: (a.telas[0].costo * a.cantidad) / cantidadPedido
          };
      })
      .filter(function (el) {
        return el != null;
      });
      setPrecosteoTelas(arrayExp);
  })
  .catch((err) => {
    console.log(err);
  });

  axios
  .get(`${URL_EXPLOSION}Articulo/${id}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allExplosion = response.data;
    let arrayExpHab = allExplosion
      .map((a) => {
        if(a.tipo == "Habilitacion")
          return{
            _id: a._id,
            idHabilitacion: a.habilitacion[0]._id,
            habilitacion: a.habilitacion[0].nombre + " " + a.habilitacion[0].descripcion,
            cantidad: a.cantidad,
            costo: a.habilitacion[0].costo,
            total: (a.habilitacion[0].costo * a.cantidad) * cantidadPedido,
            totalPrenda: a.habilitacion[0].costo * a.cantidad
          };
      })
      .filter(function (el) {
        return el != null;
      });
      setPrecosteoHab(arrayExpHab);
  })
  .catch((err) => {
    console.log(err);
  });

      setTimeout(() => {
        setModalProgreso(false);
        togglePrecosteo();
      }, 3500);
}

const obtenerFichasTecnicasActuales = async (areaId, articuloId, pedidoId, sucursalId) => {
  try {
    const res = await axios.get(`${URL_ARTICULOS_PEDIDO}/obtenerBordados/bordadosGlobal`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
      params: {
        areaId,
        articuloId,
        pedidoId,
        sucursalId, // 👈 importante
      },
    });

    setBordados(res.data.bordados || []);
  } catch (error) {
    console.error("Error al obtener fichas técnicas:", error);
    setBordados([]);
  }
};


// (2026-10) Sube la imagen de un bordado a Cloudinary y regresa su URL. La usan
// el alta de un bordado nuevo y "Cambiar imagen" de uno ya guardado.
const subeImagenBordado = async (archivo, publicIdEsperado) => {
  const formData = new FormData();
  formData.append("file", archivo);
  formData.append("folder", "langianiArticulos");
  formData.append("public_id", publicIdEsperado);

  const uploadRes = await axios.post(
    process.env.REACT_APP_URL_UPPROFILE,
    formData,
    {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    }
  );

  // Cloudinary puede fallar y aun así responder 200: si no regresó la imagen
  // no guardamos el renglón, porque quedaría apuntando a una foto inexistente.
  const urlImagen =
    uploadRes?.data?.secure_url ||
    uploadRes?.data?.url ||
    uploadRes?.data?.public_id;

  if (!urlImagen) {
    throw new Error(
      `La imagen no se subió: ${uploadRes?.data?.message || uploadRes?.data?.error?.message || "respuesta inesperada del servidor"}`
    );
  }
  return urlImagen;
};

// Mensaje de error legible a partir de la respuesta del back / Cloudinary
const detalleErrorBordado = (err) => {
  const d = err?.response?.data;
  const detalle =
    (typeof d === "string" ? d : d?.message || d?.error?.message || d?.error) ||
    err?.message ||
    "Error desconocido";
  const status = err?.response?.status ? ` (${err.response.status})` : "";
  return `${status}: ${detalle}`;
};

const handleSubirNuevoBordado = async () => {
  // La observación es opcional: no debe impedir dar de alta el bordado.
  if (!nuevoBordadoFile) {
    return Swal.fire("Falta la imagen", "Selecciona la imagen del bordado", "warning");
  }
  if (!areaFoto || !articuloFoto || !pedidoId || !sucursalFoto) {
    return Swal.fire("Faltan datos", "No se encontró área, artículo, pedido o sucursal", "warning");
  }
  if (!process.env.REACT_APP_URL_UPPROFILE) {
    return Swal.fire("Error de configuración", "No está configurada la URL de subida de imágenes (REACT_APP_URL_UPPROFILE)", "error");
  }
  if (subiendoBordado) return;

  const version = `${Date.now()}`; // 👈 Como string, una sola vez
  const publicIdEsperado = `langianiArticulos/${areaFoto}_${articuloFoto}_${pedidoId}_${sucursalFoto}_${version}`;

  setSubiendoBordado(true);
  try {
    const urlImagen = await subeImagenBordado(nuevoBordadoFile, publicIdEsperado);

await axios.patch(
  `${URL_ARTICULOS_PEDIDO}/bordadoGlobal/add`,
  {
    areaId: areaFoto,
    articuloId: articuloFoto,
    pedidoId,
    sucursalId: sucursalFoto,
    version,
    observacion: nuevaObservacion || "Sin observación",
    public_id: urlImagen,
  },
  {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  }
);

    Swal.fire("Guardado", "Ficha técnica registrada correctamente", "success");
    setNuevaObservacion("");
    setNuevoBordadoFile(null);
    obtenerFichasTecnicasActuales(areaFoto, articuloFoto, pedidoId, sucursalFoto);
  } catch (err) {
    console.error(err);
    Swal.fire("Error", `No se pudo guardar la ficha técnica${detalleErrorBordado(err)}`, "error");
  } finally {
    setSubiendoBordado(false);
  }
};

// (2026-10) Editar un bordado ya guardado (instrucciones o imagen) y recargar
// la lista del modal
const editarBordadoGuardado = async (version, cambios) => {
  await axios.patch(
    `${URL_ARTICULOS_PEDIDO}/bordadoGlobal/edit`,
    { areaId: areaFoto, articuloId: articuloFoto, version, ...cambios },
    {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    }
  );
  await obtenerFichasTecnicasActuales(areaFoto, articuloFoto, pedidoId, sucursalFoto);
};

const guardarInstruccionesBordado = async () => {
  if (!editandoBordado) return;
  try {
    await editarBordadoGuardado(editandoBordado.version, {
      observacion: editandoBordado.texto,
    });
    setEditandoBordado(null);
    Swal.fire("Guardado", "Instrucciones actualizadas", "success");
  } catch (err) {
    console.error(err);
    Swal.fire("Error", `No se pudieron guardar las instrucciones${detalleErrorBordado(err)}`, "error");
  }
};

const cambiarImagenBordado = async (version, archivo) => {
  if (!archivo || cambiandoImagenBordado) return;
  if (!process.env.REACT_APP_URL_UPPROFILE) {
    return Swal.fire("Error de configuración", "No está configurada la URL de subida de imágenes (REACT_APP_URL_UPPROFILE)", "error");
  }
  setCambiandoImagenBordado(version);
  try {
    // public_id nuevo para que no se quede la imagen anterior en caché
    const urlImagen = await subeImagenBordado(
      archivo,
      `langianiArticulos/${areaFoto}_${articuloFoto}_${pedidoId}_${sucursalFoto}_${version}_${Date.now()}`
    );
    await editarBordadoGuardado(version, { public_id: urlImagen });
    Swal.fire("Guardado", "Imagen del bordado actualizada", "success");
  } catch (err) {
    console.error(err);
    Swal.fire("Error", `No se pudo cambiar la imagen${detalleErrorBordado(err)}`, "error");
  } finally {
    setCambiandoImagenBordado(null);
  }
};





const handleEliminarFichaTecnica = async (version) => {
  try {
    const confirm = await Swal.fire({
      title: "¿Eliminar bordado?",
      text: "Esta acción eliminará la imagen del sistema.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (!confirm.isConfirmed) return;

    await axios.patch(
      `${URL_ARTICULOS_PEDIDO}/bordadoGlobal/delete`,
      {
        areaId: areaFoto,
        articuloId: articuloFoto,
        version,
        pedidoId,
        sucursalId: sucursalFoto
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    Swal.fire("¡Eliminado!", "El bordado fue eliminado correctamente", "success");
    obtenerFichasTecnicasActuales(areaFoto, articuloFoto, pedidoId, sucursalFoto); // Recarga
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "No se pudo eliminar el bordado", "error");
  }
};




let totalPrecosteoTela = 0
let totalPrecosteoHab = 0
  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_pedidos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.pedidos_create ? (
                <>
                  {/* <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    href="/ArticulosCreate"
                  >
                    Nuevo Pedido
                  </Button> */}

                  <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    href="/PedidosCreate"
                  >
                    {/* Pedido Resurtido */}
                    Nuevo Pedido
                  </Button>

                  {/* <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    href="/PedidosCreateTallas"
                  >
                    Nuevo Pedido Toma Tallas
                  </Button> */}
                </>
              ) : (
                <>
                  {/* <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    disabled
                  >
                    Nuevo Pedido
                  </Button> */}

                  <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    disabled
                  >
                    Nuevo Pedido
                  </Button>
                  {/* <Button
                    size="sm"
                    type="submit"
                    className="btn btn-success"
                    disabled
                  >
                    Nuevo Pedido Toma Tallas
                  </Button> */}
                </>
              )}
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                {/* <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={desarrollo}
                >
                  Desarrollo
                </Button> */}
                {user.ped_pdf && (
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                )}
                {user.ped_email && (
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                )}
                {user.ped_excel && (
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                )}
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Pedidos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Pedidos</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            {/* (2026-07) filtro is_active — default "Si" */}
            <Col md={2}>
              <Label className="mr-sm-2">Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="Si">Si</option>
                <option value="No">No</option>
                <option value="">Todos</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedMarca}
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {marcas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCliente}
                  onChange={(e) => {
                    setSelectedCliente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1,
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedEmpresa}
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedComprador}
                  onChange={(e) => {
                    setSelectedComprador(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {compradores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td> */}
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedColaborador}
                  onChange={(e) => {
                    setSelectedColaborador(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {colaboradores
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return (
                        <option value={a._id}>
                          {a.nombre} {a.apellido}
                        </option>
                      );
                    })}
                </Input>
              </td>
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArticulo}
                  onChange={(e) => {
                    setSelectedArticulo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {articulos
                    .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                    .map((a) => {
                      return (
                        <option value={a._id}>
                          {a.codigo} {a.codigoCliente} {a.descripcion}
                        </option>
                      );
                    })}
                </Input>
              </td> */}
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedMarca}
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {marcas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td> */}
              <td></td>
              {/* <td></td> */}
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedPendFechaConf}
                  onChange={(e) => {
                    setSelectedPendFechaConf(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </td> */}
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              {/* columna Surtido (sin filtro) */}
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedStatus}
                  required
                  onChange={(e) => {
                    setSelectedStatus(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Abierto">Abierto</option>
                  <option value="Cerrado">Cerrado</option>
                </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                return (
                  // <tr style={ a.activo == "Si" ? { backgroundColor: "#ffff00" } : undefined}>
                  <tr>
                    <td>{a.numero}</td>
                    <td>{a.fecha}</td>
                    <td>{a.marcas}</td>
                    <td>{a.clientes}</td>
                    <td>{a.empresas}</td>
                    {/* <td>{a.compradores}</td> */}
                    <td>{a.colaboradores}</td>
                    {/* <td>{a.articulos}</td> */}
                    {/* <td>{a.marcas}</td> */}
                    {/* <td>{a.colores.map((c)=>{
                        return c.name
                      })}</td> */}
                    <td>{a.fecha_cancelacion}</td>
                    {/* <td>{a.fecha_confirmacion}</td> */}
                    {/* <td>{a.pendFechaConf}</td> */}
                    <td>{new Intl.NumberFormat("en-US").format(a.cantidad)}</td>
                    <td>{new Intl.NumberFormat("en-US").format(a.surtido || 0)}</td>
                   {/* <td>
                      {new Intl.NumberFormat("en-US").format(
                        a.pendiente_surtir,
                      )}
                    </td> */}
                    {/* <td>
                      {"$" +
                        new Intl.NumberFormat("en-US").format(a.precioPrenda)}
                    </td> */}
                    {user.pedidos_create && (
                      <td>
                        {"$" +
                          new Intl.NumberFormat("en-US").format(
                            a.total_general,
                          )}
                      </td>
                    )}
                    <td>
                      {/* <Button
                            color="danger"
                            id="Editar"
                            size="sm"
                            onClick={(e) =>
                              requisicionGlobal(a._id, a.idArticulo, a.numero)
                            }
                          >
                            <i class="fas fa-tape"></i>
                          </Button>
                          <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) => requisicion(a._id, a.numero)}
                          >
                            <i class="fas fa-tag"></i>
                          </Button> */}

                      {/* <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={(e) =>
                          PDFOC(
                            a.fecha,
                            a.colaboradores,
                            a.fecha_cancelacion,
                            a.fecha_confirmacion,
                            a.idClientes,
                            a.clientes,
                            a.pedidoCliente,
                            a.total_kilos,
                            a.total_metros,
                            a.total_general,
                            a.observacionesMarca,
                            a.numero,
                            a._id,
                            a.condiciones,
                            a.nombreFirma,
                            a.puestoFirma,
                            a.nombreComprador,
                            a.puestoComprador,
                            a.impuestos,
                            a.observaciones
                          )
                        }
                      >
                        <i class="far fa-file-pdf"></i>
                      </Button> */}



<Button
  size="sm"
  className="btn"
  color="danger"
  onClick={async () => {
    const respBordados = await Swal.fire({
      title: "¿Incluir bordados?",
      text: "¿Deseas agregar la hoja de bordados al PDF?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      reverseButtons: true,
    });
    // L95 (2026-06) — datos fiscales de la empresa propia
    const empresaObj =
      empresas.find((x) => String(x._id) === String(a.idEmpresas)) || null;

    PDFOCResumen(
      a.fecha,
      a.colaboradores,
      a.fecha_cancelacion,
      a.fecha_confirmacion,
      a.idClientes,
      a.clientes,
      a.pedidoCliente,
      a.total_kilos,
      a.total_metros,
      a.total_general,
      a.observaciones,
      a.numero,
      a._id,
      a.condiciones,
      a.nombreFirma,
      a.puestoFirma,
      a.nombreComprador,
      a.puestoComprador,
      a.impuestos,
      a.marcas,
      respBordados.isConfirmed,
      // L95 (2026-06)
      empresaObj,
      a.direccionCliente
    );
  }}
>
  <i className="far fa-file-pdf"></i>
</Button>

                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={async (e) => {
                          // L32 (2026-06) — buscar datos fiscales de la empresa propia
                          const empresaObj =
                            empresas.find(
                              (x) => String(x._id) === String(a.idEmpresas)
                            ) || null;
                          // L41 (2026-06) — preguntar bordados igual que PDFOCResumen
                          const respBordados = await Swal.fire({
                            title: "¿Incluir bordados?",
                            text: "¿Deseas agregar la hoja de bordados al PDF?",
                            icon: "question",
                            showCancelButton: true,
                            confirmButtonText: "Sí",
                            cancelButtonText: "No",
                            reverseButtons: true,
                          });
                          PDFOCPorArea(
                            a.fecha,
                            a.colaboradores,
                            a.fecha_cancelacion,
                            a.fecha_confirmacion,
                            a.idClientes,
                            a.clientes,
                            a.pedidoCliente,
                            a.total_kilos,
                            a.total_metros,
                            a.total_general,
                            a.observaciones,
                            a.numero,
                            a._id,
                            a.condiciones,
                            a.nombreFirma,
                            a.puestoFirma,
                            a.nombreComprador,
                            a.puestoComprador,
                            a.impuestos,
                            a.marcas,
                            empresaObj,
                            respBordados.isConfirmed,
                            a.direccionCliente
                          );
                        }}
                      >
                        <i class="far fa-file-pdf"></i>
                      </Button>

                      {/* <Button
                        size="sm"
                        className="btn"
                        color="warning"
                        onClick={(e) =>
                          PDFTicketColaborador(
                            a.fecha,
                            a.idClientes,
                            a.clientes,
                            a.observaciones,
                            a.numero,
                            a._id,
                            a.pedidoCliente
                          )
                        }
                      >
                        <i class="fas fa-ticket-alt"></i>
                      </Button> */}

                      {/* <BajaMultiple
                              idStatus={a._id}
                              is_active={a.activo}
                              URL_BAJA={process.env.REACT_APP_URL_PEDIDOS}
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_PEDIDO}/baja`}
                            /> */}
                      {/* <StatusMultiple
                              idStatus={a._id}
                              status={a.status}
                              URL_STATUS={process.env.REACT_APP_URL_PEDIDOS}
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_PEDIDO}/baja`}
                            /> */}
                      {/* (2026-07) marcar el pedido como activo/baja (is_active Sí/No) */}
                      <Baja
                        idStatus={a._id}
                        is_active={a.activo}
                        URL_BAJA={process.env.REACT_APP_URL_PEDIDOS}
                        onDone={() => cargarPedidos()}
                      />
                    </td>
                    <td>
                      {a.status == "Abierto" && a.activo == "Si" ? (
                        <div>
                          <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) =>
                              jalaInfo(
                                a.fecha,
                                a.idColaboradores,
                                a.idMarcas,
                                a.fecha_cancelacion,
                                a.fecha_confirmacion,
                                a.idClientes,
                                a.idEmpresas,
                                // a.idCompradores,
                                a.total_kilos,
                                a.total_metros,
                                a.total_general,
                                a.observaciones,
                                a.observacionesMarca,
                                a.numero,
                                a._id,
                                // a.idMuestrista,
                                // a.idPatronista,
                                // a.idPloter,
                                a.idArticulo,
                                a.pedidoCliente,

                                a.nombreFirma,
                                a.puestoFirma,
                                a.nombreComprador,
                                a.puestoComprador,
                                a.condiciones,
                                a.impuestos,
                                a.tipo,
                                a.subCliente,
                              )
                            }
                          >
                            <i class="far fa-edit"></i>
                          </Button>
                          <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) => EditArticulos(a._id, a.numero, a.idClientes)}
                          >
                            <i class="fas fa-cart-plus"></i>
                          </Button>

                          <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) =>
                              ConsumoTelas(a._id, a.numero, a.clientes)
                            }
                          >
                            <i class="fas fa-tape"></i>
                          </Button>
                          {/* {a.fotoArticulo == "No" ? (
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              // onClick={(e) => jalaFoto(a.idArticulo)}
                              disabled
                            >
                              <i class="fas fa-camera"></i>
                            </Button>
                          ) : (
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => jalaFoto(a.idArticulo)}
                            >
                              <i class="fas fa-camera"></i>
                            </Button>
                          )} */}
                        </div>
                      ) : (
                        <div>
                          <Button color="info" id="Editar" size="sm" disabled>
                            <i class="far fa-edit"></i>
                          </Button>
                          <Button color="info" id="Editar" size="sm" disabled>
                            <i class="fas fa-cart-plus"></i>
                          </Button>
                          <Button color="info" id="Editar" size="sm" disabled>
                            <i class="fas fa-tape"></i>
                          </Button>
                        </div>
                      )}
                    </td>
                    <td>
                      {a.autorizacionVarios === "Si" ? (
                        <>
                          <Button
                            color="primary"
                            size="sm"
                            onClick={() =>
                              cambiarAutorizacionDirecto(a._id, "No")
                            }
                          >
                            <i className="fas fa-check-circle"></i>
                          </Button>
                          {/* T8 (2026-06) — quien autorizó */}
                          {a.autorizacionVariosColaborador && (
                            <div
                              style={{
                                fontSize: "10px",
                                color: "#6b7280",
                                marginTop: "2px",
                              }}
                            >
                              {a.autorizacionVariosColaborador}
                            </div>
                          )}
                        </>
                      ) : (
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => abrirChecklistAutorizacion(a._id)}
                        >
                          <i className="fas fa-times-circle"></i>
                        </Button>
                      )}
                    </td>
                    {/* L96 (2026-06) — Autorización Dirección */}
                    <td>
                      {a.autorizacionDireccion === "Si" ? (
                        <>
                          <Button
                            color="primary"
                            size="sm"
                            onClick={() =>
                              toggleAutorizacionDireccion(a._id, "No")
                            }
                          >
                            <i className="fas fa-check-circle"></i>
                          </Button>
                          {a.autorizacionDireccionColaborador && (
                            <div
                              style={{
                                fontSize: "10px",
                                color: "#6b7280",
                                marginTop: "2px",
                              }}
                            >
                              {a.autorizacionDireccionColaborador}
                            </div>
                          )}
                        </>
                      ) : (
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() =>
                            toggleAutorizacionDireccion(a._id, "Si")
                          }
                        >
                          <i className="fas fa-times-circle"></i>
                        </Button>
                      )}
                    </td>
                    <td>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={(e) =>
                          PDFOCSurtido(
                            a.fecha,
                            a.colaboradores,
                            a.fecha_cancelacion,
                            a.fecha_confirmacion,
                            a.idClientes,
                            a.clientes,
                            a.pedidoCliente,
                            a.total_kilos,
                            a.total_metros,
                            a.total_general,
                            a.observacionesMarca,
                            a.numero,
                            a._id,
                            a.condiciones,
                            a.nombreFirma,
                            a.puestoFirma,
                            a.nombreComprador,
                            a.puestoComprador,
                            a.impuestos,
                            a.direccionCliente
                          )
                        }
                      >
                        <i class="far fa-file-pdf"></i>
                      </Button>

                                            <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={(e) =>
                          PDFOCComparativo(
                            a.fecha,
                            a.colaboradores,
                            a.fecha_cancelacion,
                            a.fecha_confirmacion,
                            a.idClientes,
                            a.clientes,
                            a.pedidoCliente,
                            a.total_kilos,
                            a.total_metros,
                            a.total_general,
                            a.observacionesMarca,
                            a.numero,
                            a._id,
                            a.condiciones,
                            a.nombreFirma,
                            a.puestoFirma,
                            a.nombreComprador,
                            a.puestoComprador,
                            a.impuestos,
                            a.direccionCliente
                          )
                        }
                      >
                        <i class="far fa-file-pdf"></i>
                      </Button>
                    </td>
                    <td>
                      {a.status == "Abierto" && a.activo == "Si" ? (
                        <div>
                          <Button
                            color="primary"
                            id="Cerrar"
                            onClick={(e) => cerrar(a._id)}
                            size="sm"
                          >
                            <i class="fas fa-lock-open"></i>
                          </Button>
                         {/* {a.ordenCorte == "No" ? (
                            <Button
                              color="danger"
                              id="Cerrar"
                              onClick={(e) => ordenCorteSi(a._id)}
                              size="sm"
                            >
                              <i class="fas fa-cut"></i>
                            </Button>
                          ) : (
                            <Button
                              color="primary"
                              id="Cerrar"
                              onClick={(e) => ordenCorteNo(a._id)}
                              size="sm"
                            >
                              <i class="fas fa-cut"></i>
                            </Button>
                          )} */}
                        </div>
                      ) : (
                        <div>
                          <Button
                            color="danger"
                            onClick={(e) => abierto(a._id)}
                            size="sm"
                          >
                            <i class="fas fa-lock"></i>
                          </Button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar Pedido {numero_pedido}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={4}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                onChange={(e) => {
                  setFecha(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label className="mr-sm-2">Cliente</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedClienteEdit}
                required
                onChange={(e) => {
                  setSelectedClienteEdit(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1,
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            {/* <Col md={4}>
              <Label className="mr-sm-2">Comprador</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedCompradorEdit}
                required
                onChange={(e) => {
                  setSelectedCompradorEdit(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {compradores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col> */}
            <Col md={4}>
              <Label>Vendedor</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedColaboradorEdit}
                required
                onChange={(e) => {
                  setSelectedColaboradorEdit(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label className="mr-sm-2">Empresa</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedEmpresaEdit}
                required
                onChange={(e) => {
                  setSelectedEmpresaEdit(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {empresas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={4}>
              {/* (2026-07) tipo de pedido, editable desde el modal de editar */}
              <Label className="mr-sm-2">Tipo</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedTipoEdit}
                onChange={(e) => setSelectedTipoEdit(e.target.value)}
              >
                <option value="Por definir">Por definir</option>
                <option value="Personalizado">Personalizado</option>
                <option value="Granel">Granel</option>
              </Input>
            </Col>

            <Col md={4}>
              <Label className="mr-sm-2">Pedido Cliente</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={pedidoCliente}
                required
                onChange={(e) => {
                  setPedidoCliente(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {empresas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            {/* (2026-09) Subcliente */}
            <Col md={4}>
              <Label className="mr-sm-2">Subcliente</Label>
              <Input
                className="col-sm-12"
                type="text"
                placeholder="Subcliente"
                value={subClienteEdit}
                onChange={(e) => setSubClienteEdit(e.target.value)}
              />
            </Col>
            {/* </Row>
          <Row> */}
            <Col md={4}>
              <Label>Fecha Entrega</Label>
              <Input
                type="date"
                placeholder="Fecha Entrega"
                value={fecha_cancelacion}
                required
                onChange={(e) => {
                  setFechaCancelacion(e.target.value);
                  let inicio = new Date(e.target.value);
                  let bla = inicio.setDate(inicio.getDate() - 41);
                  setFechaConfirmacion(moment(bla).format("YYYY-MM-DD"));
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Marca</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedMarcaEdit}
                required
                onChange={(e) => {
                  setSelectedMarcaEdit(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {marcas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            {/* <Col md={4}>
              <Label>Fecha Confirmacion</Label>
              <Input
                type="date"
                placeholder="Fecha Confirmacion"
                value={fecha_confirmacion}
                required
                onChange={(e) => {
                  setFechaConfirmacion(e.target.value);
                }}
              />
            </Col> */}
          </Row>
          <Row>
            <Col md={4}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="text"
                placeholder="ObservacionesMarca"
                value={observacionesMarca}
                required
                onChange={(e) => {
                  setObservacionesMarca(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label for="exampleEmail" className="mr-sm-2">
                Nombre Firma
              </Label>
              <Input
                type="text"
                placeholder="NombreFirma"
                value={nombreFirmaEdit}
                required
                onChange={(e) => {
                  setNombreFirmaEdit(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label for="exampleEmail" className="mr-sm-2">
                Puesto Firma
              </Label>
              <Input
                type="text"
                placeholder="PuestoFirma"
                value={puestoFirmaEdit}
                required
                onChange={(e) => {
                  setPuestoFirmaEdit(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label for="exampleEmail" className="mr-sm-2">
                Nombre Comprador
              </Label>
              <Input
                type="text"
                placeholder="NombreComprador"
                value={nombreCompradorEdit}
                required
                onChange={(e) => {
                  setNombreCompradorEdit(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label for="exampleEmail" className="mr-sm-2">
                Puesto Comprador
              </Label>
              <Input
                type="text"
                placeholder="PuestoComprador"
                value={puestoCompradorEdit}
                required
                onChange={(e) => {
                  setPuestoCompradorEdit(e.target.value);
                }}
              />
            </Col>

            <Col md={2}>
              <Label>Impuestos</Label>
              <Input
                type="select"
                // placeholder="Puesto Comprador"
                value={impuestosEdit}
                required
                onChange={(e) => {
                  setImpuestosEdit(e.target.value);
                }}
              >
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones Monarch
              </Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
            <Col md={6}>
              <Label>Foto</Label>
              <Input
                type="file"
                onChange={(e) => {
                  setFile(e.target.files[0]);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Label for="exampleEmail" className="mr-sm-2">
                Condiciones
              </Label>
              <Input
                type="textarea"
                placeholder="Condiciones"
                value={condicionesEdit}
                required
                onChange={(e) => {
                  setCondicionesEdit(e.target.value);
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editPedidos}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

<Modal
  size="xxl"
  isOpen={modalEditArticulos}
  toggle={toggleEditArticulos}
>
  <ModalHeader toggle={toggleEditArticulos}>
    <h4>Editar Articulos Pedido {numero_pedido}</h4>

    <h4>
      TOTALES{" "}
      {new Intl.NumberFormat("en-US").format(total_cantidad_edit)} pzas. /
      {" $" + new Intl.NumberFormat("en-US").format(total_general_edit)}
    </h4>
  </ModalHeader>

  <ModalBody>
    <Row className="mb-3">
      <Col md={12}>
        <Button
          type="button"
          color="info"
          className="me-2"
          onClick={() => {
            Swal.fire({
              title: "¿Actualizar tallas?",
              text: "Se agregarán las tallas faltantes y se recalcularán las cantidades según colaboradores.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Sí, actualizar",
              cancelButtonText: "Cancelar",
            }).then((result) => {
              if (result.isConfirmed) {
                actualizarCantidadesPorColaboradoresTallas();
              }
            });
          }}
          disabled={actualizandoPorTallas}
        >
          {actualizandoPorTallas
            ? "Actualizando..."
            : "Actualizar por colaboradores/tallas"}
        </Button>

        <Button
          type="button"
          color="success"
          className="ms-2"
          onClick={async () => {
            await cargarSucursalesAreasClienteEdit(clientePedidoEdit);

            setNuevoArticuloEdit({
              sucursalId: "",
              sucursalNombre: "",
              areaId: "",
              areaNombre: "",
              articuloId: "",
              articuloNombre: "",
              departamentoId: "",
              subDepartamentoId: "",
              colorId: "",
              colorNombre: "",
              tallaId: "",
              tallaNombre: "",
              cantidad: 0,
              precio: 0,
              tela: "",
            });

            toggleAddArticuloEdit();
          }}
        >
          + Agregar artículo
        </Button>
      </Col>
    </Row>

    <Row>
      {/* ================= RESUMEN (ancho completo) ================= */}
      <Col md={12}>
        <div
          style={{
            border: "1px solid #dee2e6",
            borderRadius: "8px",
            padding: "1rem",
            backgroundColor: "#f8f9fa",
            maxHeight: "70vh",
            overflowY: "auto",
          }}
        >
          <h4 className="text-success fw-bold mb-3">
            Resumen del pedido
          </h4>

          <table className="table table-sm table-bordered table-hover">
            <thead>
              <tr>
                <th>Sucursal</th>
                <th>Área</th>
                <th>Modelo</th>
                <th>Tela</th>
                <th className="text-end">Pzas</th>
                <th className="text-end">Surtido</th>
                <th className="text-center">Orden</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {(resumenEditPedido || []).length > 0 ? (
                (resumenEditPedido || []).map((r, idx) => (
                  <tr
                    key={
                      r.key ||
                      `${r.sucursalId}-${r.areaId}-${r.articuloId}-${idx}`
                    }
                    style={{
                      backgroundColor:
                        grupoSeleccionadoEdit?.key === r.key
                          ? "#d1ecf1"
                          : "",
                    }}
                  >
                    <td>{r.sucursal || ""}</td>
                    <td>{r.area || ""}</td>
                    <td>{r.articulo || ""}</td>

                    <td>{r.tela || "NA"}</td>

                    <td className="text-end">
                      {new Intl.NumberFormat("en-US").format(
                        r.cantidad || 0
                      )}
                    </td>

                    <td className="text-end">
                      {new Intl.NumberFormat("en-US").format(
                        r.surtido || 0
                      )}
                    </td>

                    {/* (2026-07) Orden de impresión del artículo en el PDF
                        (2026-08) se guarda con el botón de abajo, ya no por renglón */}
                    <td className="text-center" style={{ minWidth: 70 }}>
                      <div className="d-flex align-items-center justify-content-center">
                        <Input
                          bsSize="sm"
                          type="number"
                          value={r.orden || 0}
                          style={{ width: 55 }}
                          onChange={(e) => {
                            const val = parseInt(e.target.value) || 0;
                            setResumenEditPedido((prev) =>
                              prev.map((x) =>
                                x.key === r.key ? { ...x, orden: val } : x
                              )
                            );
                          }}
                        />
                      </div>
                    </td>

                   <td className="text-center">
  <Button
    size="sm"
    color="primary"
    type="button"
    className="me-1"
    onClick={() => {
      cargarDetalleGrupoPedido(r);

      setGrupoSeleccionadoEdit({
        ...r,
        tela: r.tela || "NA",
      });

      setModalDetalleGrupo(true);
    }}
  >
    Editar
  </Button>

  <Button
    size="sm"
    color="warning"
    type="button"
    onClick={async () => {
      const areaId = r.areaId || "";
      const articuloId = r.articuloId || "";
      const sucursalId = r.sucursalId || "";

      if (!areaId || !articuloId || !idEdit || !sucursalId) {
        return Swal.fire(
          "Faltan datos",
          "No se encontró área, artículo, pedido o sucursal",
          "warning"
        );
      }

      setAreaFoto(areaId);
      setArticuloFoto(articuloId);
      setPedidoId(idEdit);
      setSucursalFoto(sucursalId);

      setNuevaObservacion("");
      setNuevoBordadoFile(null);

      await obtenerFichasTecnicasActuales(
        areaId,
        articuloId,
        idEdit,
        sucursalId
      );

      setEditandoBordado(null);
      setModalBordados(true);
    }}
  >
    Bordado
  </Button>
</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center text-muted">
                    No hay datos para mostrar
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* (2026-08) Un solo botón para guardar el orden de todos los artículos */}
          {(resumenEditPedido || []).length > 0 && (
            <div className="d-flex justify-content-end">
              <Button
                size="sm"
                color="success"
                type="button"
                disabled={guardandoOrden}
                title="Guardar el orden de impresión de todos los artículos"
                onClick={guardarOrdenTodos}
              >
                <i className="fas fa-save"></i>{" "}
                {guardandoOrden ? "Guardando..." : "Guardar orden"}
              </Button>
            </div>
          )}
        </div>
      </Col>

      {/* ================= DETALLE (modal aparte, encima) ================= */}
      <Modal
        size="xl"
        isOpen={modalDetalleGrupo}
        toggle={toggleDetalleGrupo}
        zIndex={1060}
        style={{ maxWidth: "95vw" }}
      >
        <ModalHeader toggle={toggleDetalleGrupo}>
          Editar {grupoSeleccionadoEdit?.articulo || "artículo"}
        </ModalHeader>
        <ModalBody style={{ height: "85vh", overflowY: "auto" }}>
        <Form
          onSubmit={(e) => {
            sincronizarDetalleConInputFields(
              detalleEditPedido || []
            );

            savePedido(e);
          }}
        >
          <div
            style={{
              border: "1px solid #dee2e6",
              borderRadius: "8px",
              padding: "1rem",
              backgroundColor: "#ffffff",
            }}
          >
            {!grupoSeleccionadoEdit ? (
              <div className="text-center text-muted p-5">
                Selecciona un área/modelo para editar.
              </div>
            ) : (
              <>
                <h4 className="text-primary fw-bold">
                  {grupoSeleccionadoEdit?.sucursal || ""}
                </h4>

                <h5 className="mb-3">
                  Modelo: {grupoSeleccionadoEdit?.articulo || ""}
                </h5>

                {/* ================= ÁREA (editable) ================= */}
                <Row className="mb-3">
                  <Col md={6}>
                    <Label>Área</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={grupoSeleccionadoEdit?.areaId || ""}
                      onChange={(e) => {
                        const nuevaAreaId = e.target.value;
                        const areaObj = (areasClienteEdit || []).find(
                          (x) => String(x._id) === String(nuevaAreaId)
                        );
                        const nuevaAreaNombre =
                          areaObj?.nombre || areaObj?.name || "Sin Área";

                        const sucursalNombre =
                          grupoSeleccionadoEdit?.sucursal ||
                          detalleEditPedido?.[0]?.sucursalNombre ||
                          "Sin Sucursal";
                        const articuloNombre =
                          grupoSeleccionadoEdit?.articulo ||
                          detalleEditPedido?.[0]?.articuloNombre ||
                          "Sin Artículo";

                        const areaVieja = grupoSeleccionadoEdit?.area || "Sin Área";
                        const claveVieja = `${areaVieja}||${articuloNombre}`;
                        const claveNueva = `${nuevaAreaNombre}||${articuloNombre}`;
                        const keyVieja = grupoSeleccionadoEdit?.key;
                        const keyNueva = `${grupoSeleccionadoEdit?.sucursalId || ""}||${nuevaAreaId}||${grupoSeleccionadoEdit?.articuloId || ""}`;

                        // 1) detalle con la nueva área (por item: areaId/areaNombre/areasClientes)
                        const nuevoDetalle = (detalleEditPedido || []).map(
                          (item) => ({
                            ...item,
                            areaId: nuevaAreaId,
                            areaNombre: nuevaAreaNombre,
                            areasClientes: nuevaAreaId,
                          })
                        );
                        setDetalleEditPedido(nuevoDetalle);

                        // 2) grupo seleccionado (incl. key recalculada)
                        setGrupoSeleccionadoEdit((prev) => ({
                          ...prev,
                          area: nuevaAreaNombre,
                          areaId: nuevaAreaId,
                          areasClientes: nuevaAreaId,
                          key: keyNueva,
                        }));

                        // 3) fila del resumen (misma fila): area/areaId/key
                        setResumenEditPedido((prev) =>
                          (prev || []).map((r) =>
                            r.key === keyVieja
                              ? {
                                  ...r,
                                  area: nuevaAreaNombre,
                                  areaId: nuevaAreaId,
                                  key: keyNueva,
                                }
                              : r
                          )
                        );

                        // 4) mover el grupo en inputFields: borrar clave vieja, escribir la nueva
                        setInputFields((prev) => {
                          const nuevo = { ...(prev || {}) };
                          const grupoSuc = { ...(nuevo[sucursalNombre] || {}) };
                          const itemsPrevios =
                            grupoSuc[claveVieja] || nuevoDetalle;
                          delete grupoSuc[claveVieja];
                          grupoSuc[claveNueva] = (itemsPrevios || []).map(
                            (item) => ({
                              ...item,
                              areaId: nuevaAreaId,
                              areaNombre: nuevaAreaNombre,
                              areasClientes: nuevaAreaId,
                              sucursalNombre,
                              articuloNombre,
                            })
                          );
                          nuevo[sucursalNombre] = grupoSuc;
                          return nuevo;
                        });
                      }}
                    >
                      <option value="">Selecciona</option>
                      {(areasClienteEdit || [])
                        .slice()
                        .sort((a, b) =>
                          String(a.nombre || a.name || "").localeCompare(
                            String(b.nombre || b.name || ""),
                            "es",
                            { sensitivity: "base" }
                          )
                        )
                        .map((ar) => (
                          <option value={ar._id} key={ar._id}>
                            {ar.nombre || ar.name || ar._id}
                          </option>
                        ))}
                    </Input>
                  </Col>
                </Row>

                {/* ================= TELA GENERAL ================= */}
                <Row className="mb-3">
                  <Col md={6}>
                    <Label>Tela del artículo</Label>

                    <Input
                      bsSize="sm"
                      type="select"
                      value={grupoSeleccionadoEdit?.tela || ""}
                      onChange={(e) => {
                        const nuevaTela = e.target.value;
                        const telaObj = telas.find(
                          (t) => t.nombre === nuevaTela
                        );
                        const nuevaComp = telaObj?.composicion || "";

                        setGrupoSeleccionadoEdit((prev) => ({
                          ...prev,
                          tela: nuevaTela,
                          composicion: nuevaComp,
                        }));

                        setResumenEditPedido((prev) =>
                          (prev || []).map((r) =>
                            r.key === grupoSeleccionadoEdit.key
                              ? {
                                  ...r,
                                  tela: nuevaTela,
                                  composicion: nuevaComp,
                                }
                              : r
                          )
                        );

                        const nuevoDetalle = (
                          detalleEditPedido || []
                        ).map((item) => ({
                          ...item,
                          tela: nuevaTela,
                          composicion: nuevaComp,
                        }));

                        setDetalleEditPedido(nuevoDetalle);

                        sincronizarDetalleConInputFields(
                          nuevoDetalle
                        );
                      }}
                    >
                      <option value="">Selecciona</option>
                      {telas
                        .slice()
                        .sort((a, b) =>
                          (a.nombre || "") > (b.nombre || "") ? 1 : -1
                        )
                        .map((t) => (
                          <option value={t.nombre} key={t._id}>
                            {t.nombre}
                          </option>
                        ))}
                    </Input>
                    <Button
                      size="sm"
                      color="success"
                      style={{ marginTop: 4 }}
                      onClick={() => openNuevaTelaEdit()}
                    >
                      <i className="fas fa-plus"></i> Nueva tela
                    </Button>
                    {grupoSeleccionadoEdit?.composicion ? (
                      <div className="mt-1">
                        <small className="text-muted">
                          Composición: {grupoSeleccionadoEdit.composicion}
                        </small>
                      </div>
                    ) : null}
                  </Col>
                  <Col md={6}>
                    <Label>Proveedor de Tela</Label>

                    <Input
                      bsSize="sm"
                      type="text"
                      value={grupoSeleccionadoEdit?.proveedorTela || ""}
                      onChange={(e) => {
                        const nuevoProv = e.target.value;

                        setGrupoSeleccionadoEdit((prev) => ({
                          ...prev,
                          proveedorTela: nuevoProv,
                        }));

                        setResumenEditPedido((prev) =>
                          (prev || []).map((r) =>
                            r.key === grupoSeleccionadoEdit.key
                              ? {
                                  ...r,
                                  proveedorTela: nuevoProv,
                                }
                              : r
                          )
                        );

                        const nuevoDetalle = (
                          detalleEditPedido || []
                        ).map((item) => ({
                          ...item,
                          proveedorTela: nuevoProv,
                        }));

                        setDetalleEditPedido(nuevoDetalle);

                        sincronizarDetalleConInputFields(
                          nuevoDetalle
                        );
                      }}
                      placeholder="Nombre del proveedor"
                    />
                  </Col>
                </Row>

                {/* ================= TELA POR COLOR (L68 2026-06) ================= */}
                {(() => {
                  // Colores únicos del detalle, con tela/proveedor actual de la
                  // primera fila de cada color. Cada cambio aquí propaga SOLO
                  // a las filas de ese color.
                  const detalleArr = Array.isArray(detalleEditPedido)
                    ? detalleEditPedido
                    : [];
                  const byColor = {};
                  detalleArr.forEach((it) => {
                    const cName = it.nombreColor || it.color || "";
                    const cId = String(it.idColor || it.colores || "");
                    const key = cId || cName;
                    if (!key) return;
                    if (!byColor[key]) {
                      byColor[key] = {
                        nombre: cName,
                        idColor: cId,
                        tela: it.tela || "",
                        composicion: it.composicion || "",
                        proveedorTela: it.proveedorTela || "",
                      };
                    }
                  });
                  const colores = Object.values(byColor);
                  if (!colores.length) return null;
                  return (
                    <Row className="mb-3">
                      <Col md={12}>
                        <Label
                          style={{ fontWeight: 600 }}
                          className="text-primary"
                        >
                          Tela por color (opcional, anular la tela general)
                        </Label>
                        <small className="d-block text-muted mb-2">
                          Si dejas en blanco usa la tela general del artículo.
                        </small>
                        {colores.map((c) => (
                          <Row
                            key={c.idColor || c.nombre}
                            className="align-items-center mb-1"
                          >
                            <Col md={2}>
                              <strong>{c.nombre || "Sin color"}</strong>
                            </Col>
                            <Col md={5}>
                              <Input
                                bsSize="sm"
                                type="select"
                                value={c.tela || ""}
                                onChange={(e) => {
                                  const nuevaTela = e.target.value;
                                  const telaObj = telas.find(
                                    (t) => t.nombre === nuevaTela
                                  );
                                  const nuevaComp = telaObj?.composicion || "";
                                  const nuevoDetalle = (
                                    detalleEditPedido || []
                                  ).map((item) => {
                                    const matchById =
                                      c.idColor &&
                                      String(
                                        item.idColor || item.colores || ""
                                      ) === c.idColor;
                                    const matchByName =
                                      !c.idColor &&
                                      (item.nombreColor || item.color) ===
                                        c.nombre;
                                    if (matchById || matchByName) {
                                      return {
                                        ...item,
                                        tela: nuevaTela,
                                        composicion: nuevaComp,
                                      };
                                    }
                                    return item;
                                  });
                                  setDetalleEditPedido(nuevoDetalle);
                                  sincronizarDetalleConInputFields(
                                    nuevoDetalle
                                  );
                                }}
                              >
                                <option value="">(usa tela general)</option>
                                {telas
                                  .slice()
                                  .sort((a, b) =>
                                    (a.nombre || "") > (b.nombre || "")
                                      ? 1
                                      : -1
                                  )
                                  .map((t) => (
                                    <option value={t.nombre} key={t._id}>
                                      {t.nombre}
                                    </option>
                                  ))}
                              </Input>
                            </Col>
                            <Col md={5}>
                              <Input
                                bsSize="sm"
                                type="text"
                                placeholder="Proveedor de tela (opcional)"
                                value={c.proveedorTela || ""}
                                onChange={(e) => {
                                  const nuevoProv = e.target.value;
                                  const nuevoDetalle = (
                                    detalleEditPedido || []
                                  ).map((item) => {
                                    const matchById =
                                      c.idColor &&
                                      String(
                                        item.idColor || item.colores || ""
                                      ) === c.idColor;
                                    const matchByName =
                                      !c.idColor &&
                                      (item.nombreColor || item.color) ===
                                        c.nombre;
                                    if (matchById || matchByName) {
                                      return {
                                        ...item,
                                        proveedorTela: nuevoProv,
                                      };
                                    }
                                    return item;
                                  });
                                  setDetalleEditPedido(nuevoDetalle);
                                  sincronizarDetalleConInputFields(
                                    nuevoDetalle
                                  );
                                }}
                              />
                            </Col>
                          </Row>
                        ))}
                      </Col>
                    </Row>
                  );
                })()}

                {/* ================= OBSERVACIONES DEL ARTÍCULO (L10 2026-06) ================= */}
                <Row className="mb-3">
                  <Col md={12}>
                    <Label>Observaciones del Artículo</Label>
                    <Input
                      bsSize="sm"
                      type="textarea"
                      rows={2}
                      value={
                        grupoSeleccionadoEdit?.observacionesArticulo &&
                        grupoSeleccionadoEdit.observacionesArticulo !== "NA"
                          ? grupoSeleccionadoEdit.observacionesArticulo
                          : ""
                      }
                      placeholder="Notas específicas para este artículo (visibles en PDF)"
                      onChange={(e) => {
                        const nuevaObs = e.target.value;

                        setGrupoSeleccionadoEdit((prev) => ({
                          ...prev,
                          observacionesArticulo: nuevaObs,
                        }));

                        setResumenEditPedido((prev) =>
                          (prev || []).map((r) =>
                            r.key === grupoSeleccionadoEdit.key
                              ? {
                                  ...r,
                                  observacionesArticulo: nuevaObs,
                                }
                              : r
                          )
                        );

                        const nuevoDetalle = (
                          detalleEditPedido || []
                        ).map((item) => ({
                          ...item,
                          observacionesArticulo: nuevaObs,
                        }));

                        setDetalleEditPedido(nuevoDetalle);

                        sincronizarDetalleConInputFields(nuevoDetalle);
                      }}
                    />
                  </Col>
                </Row>

                {/* ================= BOTON NUEVA TALLA ================= */}
                <Row className="mb-3">
                  <Col md={12}>
                    <Button
                      size="sm"
                      color="success"
                      type="button"
                      onClick={() => {
                        const base =
                          (detalleEditPedido || [])[0] || {
                            areasClientes:
                              grupoSeleccionadoEdit?.areaId || "",

                            articuloId:
                              grupoSeleccionadoEdit?.articuloId || "",

                            articuloNombre:
                              grupoSeleccionadoEdit?.articulo || "",

                            sucursalId:
                              grupoSeleccionadoEdit?.sucursalId || "",

                            sucursalNombre:
                              grupoSeleccionadoEdit?.sucursal || "",

                            areaId:
                              grupoSeleccionadoEdit?.areaId || "",

                            areaNombre:
                              grupoSeleccionadoEdit?.area || "",

                            clienteId:
                              clientePedidoEdit || "",

                            claveIds: `${grupoSeleccionadoEdit?.areaId || ""}||${grupoSeleccionadoEdit?.articuloId || ""}||${grupoSeleccionadoEdit?.sucursalId || ""}`,

                            tela:
                              grupoSeleccionadoEdit?.tela || "NA",
                          };

                        const nuevo = {
                          ...base,

                          id: null,

                          tempKey: `nuevo-${Date.now()}-${Math.random()}`,

                          colores: "",
                          nombreColor: "",

                          tallas: "",
                          nombreTalla: "",

                          cantidad: 0,

                          precio: Number(base?.precio || 0),

                          total: 0,

                          tela:
                            grupoSeleccionadoEdit?.tela || "NA",

                          pendiente_surtir: 0,
                          pendienteCortar: 0,
                          cantidad_procesos: 0,

                          esNuevo: true,
                        };

                        const nuevoDetalle = [
                          ...(detalleEditPedido || []),
                          nuevo,
                        ];

                        setDetalleEditPedido(nuevoDetalle);

                        sincronizarDetalleConInputFields(
                          nuevoDetalle
                        );
                      }}
                    >
                      + Color / Talla
                    </Button>
                  </Col>
                </Row>

                {/* ================= HEADERS ================= */}
                <Row className="fw-bold text-center mb-2">
                  <Col md={3}>Color</Col>
                  <Col md={3}>Talla</Col>
                  <Col md={2}>Cantidad</Col>
                  <Col md={2}>Precio</Col>
                  <Col md={2}>Total</Col>
                </Row>

                {/* ================= ROWS ================= */}
                {(detalleEditPedido || []).map((item, idx) => (
                  <Row
                    key={
                      item?.id ||
                      item?.tempKey ||
                      `${grupoSeleccionadoEdit?.key}-${idx}`
                    }
                    className="align-items-center text-center mb-2"
                  >
                    {/* COLOR */}
                    <Col md={3}>
                      <Input
                        type="select"
                        bsSize="sm"
                        value={item?.colores || ""}
                        onChange={(e) => {
                          const colorId = e.target.value;

                          const colorObj = (colores || []).find(
                            (c) =>
                              String(c._id) === String(colorId)
                          );

                          const nuevoDetalle = (
                            detalleEditPedido || []
                          ).map((row, i) =>
                            i === idx
                              ? {
                                  ...row,
                                  colores: colorId,
                                  nombreColor:
                                    colorObj?.name ||
                                    colorObj?.nombre ||
                                    "",
                                }
                              : row
                          );

                          setDetalleEditPedido(nuevoDetalle);

                          sincronizarDetalleConInputFields(
                            nuevoDetalle
                          );
                        }}
                      >
                        <option value="">Color</option>

                        {(colores || []).map((c) => (
                          <option key={c._id} value={c._id}>
                            {c.name || c.nombre}
                          </option>
                        ))}
                      </Input>
                    </Col>

                    {/* TALLA */}
                    <Col md={3}>
                      <Input
                        type="select"
                        bsSize="sm"
                        value={item?.tallas || ""}
                        onChange={(e) => {
                          const tallaId = e.target.value;

                          const tallaObj = (tallas || []).find(
                            (t) =>
                              String(t._id) === String(tallaId)
                          );

                          const nombreTalla = tallaObj
                            ? `${tallaObj.name || ""}${
                                tallaObj.variantesTallas?.[0]
                                  ?.name
                                  ? ` ${tallaObj.variantesTallas[0].name}`
                                  : ""
                              }`
                            : "";

                          const nuevoDetalle = (
                            detalleEditPedido || []
                          ).map((row, i) =>
                            i === idx
                              ? {
                                  ...row,
                                  tallas: tallaId,
                                  nombreTalla,
                                }
                              : row
                          );

                          setDetalleEditPedido(nuevoDetalle);

                          sincronizarDetalleConInputFields(
                            nuevoDetalle
                          );
                        }}
                      >
                        <option value="">Talla</option>

                        {(tallas || []).map((t) => (
                          <option key={t._id} value={t._id}>
                            {t.name || t.nombre}
                            {t.variantesTallas?.[0]?.name
                              ? ` ${t.variantesTallas[0].name}`
                              : ""}
                          </option>
                        ))}
                      </Input>
                    </Col>

                    {/* CANTIDAD */}
                    <Col md={2}>
                      <Input
                        type="number"
                        bsSize="sm"
                        value={item?.cantidad || 0}
                        onChange={(e) => {
                          const cantidad =
                            parseFloat(e.target.value) || 0;

                          const nuevoDetalle = (
                            detalleEditPedido || []
                          ).map((row, i) =>
                            i === idx
                              ? {
                                  ...row,
                                  cantidad,
                                  total:
                                    cantidad *
                                    Number(row?.precio || 0),
                                }
                              : row
                          );

                          setDetalleEditPedido(nuevoDetalle);

                          sincronizarDetalleConInputFields(
                            nuevoDetalle
                          );
                        }}
                      />
                    </Col>

                    {/* PRECIO */}
                    <Col md={2}>
                      <Input
                        type="number"
                        bsSize="sm"
                        value={item?.precio || 0}
                        onChange={(e) => {
                          const precio =
                            parseFloat(e.target.value) || 0;

                          const nuevoDetalle = (
                            detalleEditPedido || []
                          ).map((row, i) =>
                            i === idx
                              ? {
                                  ...row,
                                  precio,
                                  total:
                                    Number(row?.cantidad || 0) *
                                    precio,
                                }
                              : row
                          );

                          setDetalleEditPedido(nuevoDetalle);

                          sincronizarDetalleConInputFields(
                            nuevoDetalle
                          );
                        }}
                      />
                    </Col>

                    {/* TOTAL */}
                    <Col md={2}>
                      <Input
                        type="number"
                        bsSize="sm"
                        value={item?.total || 0}
                        disabled
                      />
                    </Col>
                  </Row>
                ))}
              </>
            )}
          </div>

          {/* ================= FOOTER ================= */}
          <Row className="mt-4">
            <Col md={6}>
              <h4>
                TOTALES{" "}
                {new Intl.NumberFormat("en-US").format(
                  total_cantidad_edit
                )}{" "}
                pzas. /
                {" $" +
                  new Intl.NumberFormat("en-US").format(
                    total_general_edit
                  )}
              </h4>
            </Col>

            <Col md={6} className="text-end">
              <Button
                type="submit"
                color="success"
                disabled={!validaBoton}
              >
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
        </ModalBody>
      </Modal>
    </Row>
  </ModalBody>
</Modal>

<Modal isOpen={modalAddArticuloEdit} toggle={toggleAddArticuloEdit} size="xl">
  <ModalHeader toggle={toggleAddArticuloEdit}>
    Agregar artículo al pedido
  </ModalHeader>

  <ModalBody>
    <Row>
      <Col md={6}>
        <Label>Sucursal</Label>
        <Input
          type="select"
          value={nuevoArticuloEdit?.sucursalId || ""}
          onChange={(e) => {
            const id = e.target.value;
            const obj = (sucursalesClienteEdit || []).find(
              (x) => String(x?._id) === String(id)
            );

            setNuevoArticuloEdit((prev) => ({
              ...(prev || {}),
              sucursalId: id,
              sucursalNombre:
                obj?.alias ||
                obj?.nombre_comercial ||
                obj?.nombre ||
                obj?.name ||
                "Sin Sucursal",
            }));
          }}
        >
          <option value="">Selecciona sucursal</option>
          {(sucursalesClienteEdit || []).map((suc) => (
            <option key={suc._id} value={suc._id}>
              {suc.alias || suc.nombre_comercial || suc.nombre || suc.name || suc._id}
            </option>
          ))}
        </Input>
      </Col>

      <Col md={6}>
        <Label>Área</Label>
        <Input
          type="select"
          value={nuevoArticuloEdit?.areaId || ""}
          onChange={(e) => {
            const id = e.target.value;
            const obj = (areasClienteEdit || []).find(
              (x) => String(x?._id) === String(id)
            );

            setNuevoArticuloEdit((prev) => ({
              ...(prev || {}),
              areaId: id,
              areaNombre: obj?.nombre || obj?.name || "Sin Área",
            }));
          }}
        >
          <option value="">Selecciona área</option>
          {(areasClienteEdit || []).map((area) => (
            <option key={area._id} value={area._id}>
              {area.nombre || area.name || area._id}
            </option>
          ))}
        </Input>
      </Col>

      {/* (2026-09) Artículo con buscador (código - línea) */}
      <Col md={12} className="mt-2">
        <Label>Artículo</Label>
        <Autocomplete
          size="small"
          options={[...(articulos || [])].sort((a, b) =>
            etiquetaArticulo(a).localeCompare(etiquetaArticulo(b), "es", {
              numeric: true,
            })
          )}
          value={
            (articulos || []).find(
              (x) => String(x?._id) === String(nuevoArticuloEdit?.articuloId)
            ) || null
          }
          getOptionLabel={(o) => etiquetaArticulo(o)}
          getOptionSelected={(o, v) => String(o?._id) === String(v?._id)}
          renderOption={(o) => (
            <div>
              <b>{etiquetaArticulo(o)}</b>
              {o?.descripcion ? (
                <div style={{ fontSize: "0.8rem", color: "#6b7280" }}>
                  {o.descripcion}
                </div>
              ) : null}
            </div>
          )}
          onChange={(e, obj) => {
            if (!obj) {
              setNuevoArticuloEdit((prev) => ({
                ...(prev || {}),
                articuloId: "",
                articuloNombre: "",
                coloresSel: [],
                tallasSel: [],
                celdas: [],
              }));
              return;
            }
            // colores y tallas dados de alta en el artículo, como propuesta
            const coloresSel = (obj?.colores || [])
              .filter((c) => c && typeof c === "object")
              .map((c) => ({ _id: String(c._id), name: c.name || c.nombre || "" }));
            const tallasSel = ordenaTallasCatalogo(
              (obj?.tallas || []).filter((x) => x && typeof x === "object")
            );

            setNuevoArticuloEdit((prev) => ({
              ...(prev || {}),
              articuloId: String(obj._id),
              codigo: obj?.codigo || "",
              articuloNombre: etiquetaArticulo(obj),
              departamentoId:
                obj?.departamentos?.[0]?._id || obj?.departamentos?.[0] || "",
              subDepartamentoId:
                obj?.subDepartamentos?.[0]?._id ||
                obj?.subDepartamentos?.[0] ||
                "",
              precio: Number(obj?.venta || obj?.precio || prev?.precio || 0),
              codigoCliente: obj?.codigoCliente || "NA",
              tela: prev?.tela || obj?.tela || "",
              coloresSel,
              tallasSel,
              celdas: armaCeldasNuevoArticulo(coloresSel, tallasSel, []),
            }));
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="Busca por código o línea"
            />
          )}
        />
      </Col>

      <Col md={6} className="mt-2">
        <Label>Colores</Label>
        <Autocomplete
          multiple
          size="small"
          disableCloseOnSelect
          options={[...(colores || [])].sort((a, b) =>
            String(a?.name || a?.nombre || "").localeCompare(
              String(b?.name || b?.nombre || ""),
              "es"
            )
          )}
          value={nuevoArticuloEdit?.coloresSel || []}
          getOptionLabel={(o) => o?.name || o?.nombre || ""}
          getOptionSelected={(o, v) => String(o?._id) === String(v?._id)}
          onChange={(e, val) => {
            const coloresSel = (val || []).map((c) => ({
              _id: String(c._id),
              name: c.name || c.nombre || "",
            }));
            setNuevoArticuloEdit((prev) => ({
              ...(prev || {}),
              coloresSel,
              celdas: armaCeldasNuevoArticulo(
                coloresSel,
                prev?.tallasSel || [],
                prev?.celdas || []
              ),
            }));
          }}
          renderInput={(params) => (
            <TextField {...params} variant="outlined" placeholder="Colores" />
          )}
          disabled={!nuevoArticuloEdit?.articuloId}
        />
      </Col>

      <Col md={6} className="mt-2">
        <Label>Tallas</Label>
        <Autocomplete
          multiple
          size="small"
          disableCloseOnSelect
          options={ordenaTallasCatalogo(tallas || [])}
          value={nuevoArticuloEdit?.tallasSel || []}
          getOptionLabel={(o) => {
            const base = String(o?.name || o?.nombre || "");
            const vars = (Array.isArray(o?.variantesTallas) ? o.variantesTallas : [])
              .map((v) => (v && typeof v === "object" ? v.name || v.nombre || "" : ""))
              .filter(Boolean)
              .join(", ");
            return vars ? `${base} (${vars})` : base;
          }}
          getOptionSelected={(o, v) => String(o?._id) === String(v?._id)}
          onChange={(e, val) => {
            const tallasSel = ordenaTallasCatalogo(val || []);
            setNuevoArticuloEdit((prev) => ({
              ...(prev || {}),
              tallasSel,
              celdas: armaCeldasNuevoArticulo(
                prev?.coloresSel || [],
                tallasSel,
                prev?.celdas || []
              ),
            }));
          }}
          renderInput={(params) => (
            <TextField {...params} variant="outlined" placeholder="Tallas" />
          )}
          disabled={!nuevoArticuloEdit?.articuloId}
        />
      </Col>

      <Col md={8} className="mt-2">
        <Label>Tela (la misma para todos los renglones)</Label>
        <Input
          type="text"
          value={nuevoArticuloEdit?.tela || ""}
          onChange={(e) => {
            const value = e.target.value;
            setNuevoArticuloEdit((prev) => ({ ...(prev || {}), tela: value }));
          }}
          placeholder="Ej. poliester - viscosa"
        />
      </Col>

      <Col md={4} className="mt-2">
        <Label>Precio (el mismo para todos)</Label>
        <Input
          type="number"
          min="0"
          step="any"
          value={nuevoArticuloEdit?.precio ?? 0}
          onChange={(e) => {
            const value = Number(e.target.value || 0);
            setNuevoArticuloEdit((prev) => ({ ...(prev || {}), precio: value }));
          }}
        />
      </Col>

      <Col md={12} className="mt-3">
        <Label>Cantidades por color y talla</Label>
        <CapturaTallasColores
          colores={nuevoArticuloEdit?.coloresSel || []}
          celdas={nuevoArticuloEdit?.celdas || []}
          precio={Number(nuevoArticuloEdit?.precio) || 0}
          ordenTallas={ordenTallas}
          onChange={(celda, valor) => {
            const cantidad = Math.max(0, parseInt(valor, 10) || 0);
            setNuevoArticuloEdit((prev) => ({
              ...(prev || {}),
              celdas: (prev?.celdas || []).map((c) =>
                c.colores === celda.colores &&
                c.tallas === celda.tallas &&
                c.tallaNombre === celda.tallaNombre
                  ? { ...c, cantidad }
                  : c
              ),
            }));
          }}
        />
      </Col>
    </Row>
  </ModalBody>

  <ModalFooter>
    <Button color="secondary" type="button" onClick={toggleAddArticuloEdit}>
      Cancelar
    </Button>

    <Button color="success" type="button" onClick={agregarArticuloAlPedidoEdit}>
      Agregar
    </Button>
  </ModalFooter>
</Modal>

      <ConsumosTelasModal
        isOpen={modalConsumos}
        toggle={toggleConsumos}
        idPedido={idEdit}
        numeroPedido={numero_pedido}
        cliente={nombreEdit}
        onPDF={() => PDFConsumosPorArticulo(numero_pedido, nombreEdit, idEdit)}
      />

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios minutos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size="xl" isOpen={modalExplosion} toggle={toggleExplosion}>
        <ModalHeader toggle={toggleExplosion}>
          <h4>Explosion</h4>
        </ModalHeader>
        <ModalBody>
          <h5>Tela</h5>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <tr>
              <th>Articulo</th>
              <th>Material</th>
              <th>Color</th>
              <th>Cantidad</th>
              <th>Observaciones</th>
            </tr>
            {explosion.map((a) => (
              <tr>
                <td>{a.articulosCodigo}</td>
                <td>{a.material}</td>
                <td>{a.coloresName}</td>
                <td>{a.cantidad}</td>
                <td>{a.observaciones}</td>
              </tr>
            ))}
          </Table>
          <br />

          <h5>Habilitacion</h5>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <tr>
              {/* <th>Articulo</th> */}
              <th>Material</th>
              <th>Cantidad</th>
              <th>Observaciones</th>
            </tr>
            {explosionHab.map((a) => (
              <tr>
                {/* <td>{a.articulosCodigo}</td> */}
                <td>{a.material}</td>
                <td>{a.cantidad}</td>
                <td>{a.observaciones}</td>
              </tr>
            ))}
          </Table>
        </ModalBody>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalExplosionGlobal}
        toggle={toggleExplosionGlobal}
      >
        <ModalHeader toggle={toggleExplosionGlobal}>
          <h4>Explosion Global Tela</h4>
        </ModalHeader>
        <ModalBody>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <Row>
              <Col md={3}>Tela</Col>
              <Col md={2}>Color</Col>
              <Col md={1}>Metros Totales</Col>
              <Col md={1}>Consumo Por Prenda</Col>
              <Col md={3}>Observaciones</Col>
            </Row>
            {explosionGlobalExistente.map((a) => (
              <div key={a._id}>
                <Row>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="telas"
                      type="select"
                      value={a.idTela}
                      required
                      disabled
                    >
                      <option value="">Selecciona</option>
                      {telas
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.nombre} / {a.tiposTelas[0].name}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="colores"
                      type="select"
                      value={a.idColor}
                      required
                      disabled
                    >
                      <option value="">Selecciona</option>
                      {colores
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      value={a.cantidad}
                      onChange={(event) => {
                        handleChangeInputExistenteGlobal(a._id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidadPrenda"
                      type="number"
                      value={a.cantidadPrenda}
                      onChange={(event) => {
                        handleChangeInputExistenteGlobal(a._id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="observaciones"
                      type="text"
                      value={a.observaciones}
                      onChange={(event) => {
                        handleChangeInputExistenteGlobal(a._id, event);
                      }}
                    ></Input>
                  </Col>
                </Row>
              </div>
            ))}
            {inputFieldsTelaGlobal.map((a) => (
              <div key={a.id}>
                <Row>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="idTela"
                      type="select"
                      value={a.idTela}
                      required
                      onChange={(event) => {
                        handleChangeInputTelaGlobal(a.id, event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {telas
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.nombre} / {a.tiposTelas[0].name}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="idColor"
                      type="select"
                      value={a.idColor}
                      required
                      onChange={(event) => {
                        handleChangeInputTelaGlobal(a.id, event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {colores
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      value={a.cantidad}
                      onChange={(event) => {
                        handleChangeInputTelaGlobal(a.id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidadPrenda"
                      type="number"
                      value={a.cantidadPrenda}
                      onChange={(event) => {
                        handleChangeInputTelaGlobal(a.id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="observaciones"
                      type="text"
                      value={a.observaciones}
                      onChange={(event) => {
                        handleChangeInputTelaGlobal(a.id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFieldsTelaGlobal.length === 1}
                      onClick={() => handleRemoveFieldsTelasGlobal(a.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFieldsTelasGlobal}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
          </Table>
          <br />
        </ModalBody>

        <ModalFooter>
          {validaBoton ? (
            <Button
              type="submit"
              className="btn btn-success"
              onClick={saveExplosionGlobal}
            >
              Guardar
            </Button>
          ) : (
            <Button type="submit" className="btn btn-success" disabled>
              Guardar
            </Button>
          )}
        </ModalFooter>
      </Modal>

<Modal size="lg" isOpen={modalBordados} toggle={() => setModalBordados(false)}>
  <ModalHeader toggle={() => setModalBordados(false)}>
    <h4>Bordados</h4>
  </ModalHeader>

  <ModalBody>
    {bordados.length > 0 ? (
      <Row className="mb-3">
        {bordados.map((b, idx) => {
          const publicId = String(b?.public_id || "").trim();

          const baseCloudinary = String(
            process.env.REACT_APP_URL_FOTO_CLOUDINARY || ""
          )
            .replace(/\/$/, "")
            .replace(/\/image\/upload$/, "");

          const imgUrl = publicId.startsWith("http")
            ? publicId
            : `${baseCloudinary}/image/upload/${publicId}`;

          return (
            <Col key={idx} md={6} className="mb-3 text-center">
              <img
                src={imgUrl}
                alt="Bordado"
                style={{
                  width: "140px",
                  height: "140px",
                  objectFit: "contain",
                  border: "1px solid #ddd",
                  borderRadius: "10px",
                  padding: "6px",
                  background: "#fff",
                  cursor: "default",
                }}
              />

              {/* (2026-10) instrucciones e imagen se editan por separado */}
              {editandoBordado && editandoBordado.version === b.version ? (
                <div className="mt-2 text-start">
                  <Input
                    type="textarea"
                    rows="3"
                    value={editandoBordado.texto}
                    placeholder="Instrucciones del bordado"
                    onChange={(e) => {
                      const texto = e.target.value;
                      setEditandoBordado((prev) => ({ ...prev, texto }));
                    }}
                  />
                  <div className="mt-2 text-center">
                    <Button
                      color="success"
                      size="sm"
                      type="button"
                      onClick={guardarInstruccionesBordado}
                    >
                      Guardar
                    </Button>{" "}
                    <Button
                      color="secondary"
                      size="sm"
                      type="button"
                      onClick={() => setEditandoBordado(null)}
                    >
                      Cancelar
                    </Button>
                  </div>
                </div>
              ) : (
                <>
                  <p className="mt-2 mb-2">
                    {b?.observacion || "Sin observación"}
                  </p>

                  <Button
                    color="info"
                    size="sm"
                    type="button"
                    onClick={() =>
                      setEditandoBordado({
                        version: b.version,
                        texto:
                          !b?.observacion || b.observacion === "Sin observación"
                            ? ""
                            : b.observacion,
                      })
                    }
                  >
                    Editar instrucciones
                  </Button>{" "}
                  <Button
                    tag="label"
                    color="warning"
                    size="sm"
                    className="mb-0"
                    style={{ cursor: "pointer" }}
                    disabled={cambiandoImagenBordado === b.version}
                  >
                    {cambiandoImagenBordado === b.version
                      ? "Subiendo..."
                      : "Cambiar imagen"}
                    <input
                      type="file"
                      hidden
                      accept=".png,.jpg,.jpeg,image/png,image/jpeg"
                      onChange={(e) => {
                        const archivo = e.target.files && e.target.files[0];
                        e.target.value = "";
                        cambiarImagenBordado(b.version, archivo);
                      }}
                    />
                  </Button>{" "}
                  <Button
                    color="danger"
                    size="sm"
                    type="button"
                    onClick={() => handleEliminarFichaTecnica(b.version)}
                  >
                    Eliminar
                  </Button>
                </>
              )}
            </Col>
          );
        })}
      </Row>
    ) : (
      <h5>No hay bordados registrados.</h5>
    )}

    <hr />

    <h5>Subir nuevo bordado</h5>

    <Form>
      <Row className="mb-3">
        <Col>
          <Label>Imagen:</Label>
          <Input
            type="file"
            accept=".png,.jpg,.jpeg,image/png,image/jpeg"
            onChange={(e) => setNuevoBordadoFile(e.target.files[0])}
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <Label>Instrucciones (opcional, se pueden editar después):</Label>
          <Input
            type="textarea"
            rows="3"
            value={nuevaObservacion}
            onChange={(e) => setNuevaObservacion(e.target.value)}
          />
        </Col>
      </Row>

      <Row className="text-end">
        <Col>
          <Button
            color="primary"
            type="button"
            disabled={subiendoBordado}
            onClick={handleSubirNuevoBordado}
          >
            {subiendoBordado ? "Guardando..." : "Guardar nuevo bordado"}
          </Button>
        </Col>
      </Row>
    </Form>
  </ModalBody>
</Modal>

      <Modal size="xl" isOpen={modalExplosiones} toggle={toggleExplosiones}>
        <ModalHeader toggle={toggleExplosiones}>
          <h4>
            Explosion Modelo {codigoExplosion} / {descripcionExplosion}
          </h4>
        </ModalHeader>
        <ModalBody>
          {/* <Row>
            <Col md={4}>
              <Label>Tela</Label>
            </Col>
            <Col md={3}>
              <Label>Consumo X Prenda</Label>
            </Col>
            <Col md={3}>
              <Label>Observaciones</Label>
            </Col>
          </Row> */}
          {/* {explosionExistentes.map((a) =>
            a.tipo == "Tela" ? (
              <div key={a._id}>
                <Row>
                  <Col md={4}>
                    <Input
                      bsSize="sm"
                      name="telas"
                      type="select"
                      value={a.telas[0]._id}
                      required
                      disabled
                    >
                      <option value="">Selecciona</option>
                      {telas
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.nombre} / {a.tiposTelas[0].name}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      value={a.cantidad}
                      onChange={(event) => {
                        handleChangeInputExistente(a._id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="observaciones"
                      type="text"
                      value={a.observaciones}
                      onChange={(event) => {
                        handleChangeInputExistente(a._id, event);
                      }}
                    ></Input>
                  </Col>
                </Row>
              </div>
            ) : undefined
          )}
          {inputFieldsTela.map((a) => (
            <div key={a.id}>
              <Row>
                <Col md={4}>
                  <Input
                    bsSize="sm"
                    name="idTela"
                    type="select"
                    value={a.idTela}
                    required
                    onChange={(event) => {
                      handleChangeInputTela(a.id, event);
                    }}
                  >
                    <option value="">Selecciona</option>
                    {telas
                      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.nombre} / {a.tiposTelas[0].name}
                          </option>
                        );
                      })}
                  </Input>
                </Col>
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    name="cantidad"
                    type="number"
                    value={a.cantidad}
                    onChange={(event) => {
                      handleChangeInputTela(a.id, event);
                    }}
                  ></Input>
                </Col>
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    name="observaciones"
                    type="text"
                    value={a.observaciones}
                    onChange={(event) => {
                      handleChangeInputTela(a.id, event);
                    }}
                  ></Input>
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="danger"
                    disabled={inputFieldsTela.length === 1}
                    onClick={() => handleRemoveFieldsTelas(a.id)}
                    tabindex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>
                  <Button
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFieldsTelas}
                    tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))} */}
          <br />
          <Row>
            <Col md={4}>
              <Label>Habilitacion</Label>
            </Col>
            <Col md={3}>
              <Label>Consumo X Prenda</Label>
            </Col>
            <Col md={3}>
              <Label>Observaciones</Label>
            </Col>
          </Row>
          {explosionExistentes.map((a) =>
            a.tipo == "Habilitacion" ? (
              <div key={a._id}>
                <Row>
                  <Col md={4}>
                    <Input
                      bsSize="sm"
                      name="habilitacion"
                      type="select"
                      value={a.habilitacion[0]._id}
                      required
                      disabled
                    >
                      <option value="">Selecciona</option>
                      {habilitacion
                        .sort((a, b) =>
                          a.descripcion > b.descripcion ? 1 : -1,
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.descripcion} {a.nombre}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      value={a.cantidad}
                      onChange={(event) => {
                        handleChangeInputExistente(a._id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="observaciones"
                      type="text"
                      value={a.observaciones}
                      onChange={(event) => {
                        handleChangeInputExistente(a._id, event);
                      }}
                    ></Input>
                  </Col>
                </Row>
              </div>
            ) : undefined,
          )}
          {inputFieldsHab.map((a) => (
            <div key={a.id}>
              <Row>
                <Col md={4}>
                  <Input
                    bsSize="sm"
                    name="idHab"
                    type="select"
                    value={a.idHab}
                    required
                    onChange={(event) => {
                      handleChangeInputHab(a.id, event);
                    }}
                  >
                    <option value="">Selecciona</option>
                    {habilitacion
                      .sort((a, b) => (a.descripcion > b.descripcion ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.descripcion} {a.nombre}
                          </option>
                        );
                      })}
                  </Input>
                </Col>
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    name="cantidad"
                    type="number"
                    value={a.cantidad}
                    onChange={(event) => {
                      handleChangeInputHab(a.id, event);
                    }}
                  ></Input>
                </Col>
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    name="observaciones"
                    type="text"
                    value={a.observaciones}
                    onChange={(event) => {
                      handleChangeInputHab(a.id, event);
                    }}
                  ></Input>
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="danger"
                    disabled={inputFieldsHab.length === 1}
                    onClick={() => handleRemoveFieldsHab(a.id)}
                    tabindex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>
                  <Button
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFieldsHab}
                    tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
        </ModalBody>
        <ModalFooter>
          {validaBoton ? (
            <Button
              type="submit"
              className="btn btn-success"
              onClick={saveExplosion}
            >
              Guardar
            </Button>
          ) : (
            <Button type="submit" className="btn btn-success" disabled>
              Guardar
            </Button>
          )}
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={modalColores} toggle={toggleColores}>
        <ModalHeader toggle={toggleColores}>
          <h4>
            Colores del Articulo {codigo} / {descripcion}
          </h4>
        </ModalHeader>
        <ModalBody>
          {colores
            .sort((a, b) => (a.name > b.name ? 1 : -1))
            .map((a, index) => {
              if (!arrayColores.includes(a._id)) {
                return (
                  <table>
                    <td>
                      <Input
                        type="checkbox"
                        key={index}
                        onChange={(e) => {
                          coloresSeleccionados(e.currentTarget.checked, a._id);
                        }}
                        className="subMenu"
                      />
                      <h5 className="subMenuTitulo">{a.name}</h5>
                    </td>
                  </table>
                );
              } else {
                return <h5 className="subMenuTitulo">{a.name}</h5>;
              }
            })}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardarColores}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={modalTallas} toggle={toggleTallas}>
        <ModalHeader toggle={toggleTallas}>
          <h4>
            Tallas del Articulo {codigo} / {descripcion}
          </h4>
        </ModalHeader>
        <ModalBody>
          {tallas
            .sort((a, b) => (a.name > b.name ? 1 : -1))
            .map((a, index) => {
              if (!arrayTallas.includes(a._id)) {
                return (
                  <table>
                    <td>
                      <Input
                        type="checkbox"
                        key={index}
                        onChange={(e) => {
                          tallasSeleccionados(e.currentTarget.checked, a._id);
                        }}
                        className="subMenu"
                      />
                      <h5 className="subMenuTitulo">{a.name}</h5>
                    </td>
                  </table>
                );
              } else {
                return <h5 className="subMenuTitulo">{a.name}</h5>;
              }
            })}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardarTallas}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        size="lg"
        isOpen={modalCatalogoProcesos}
        toggle={toggleCatalogoProcesos}
      >
        <ModalHeader toggle={toggleCatalogoProcesos}>
          <h4>
            Procesos del Articulo {codigo} / {descripcion}
          </h4>
        </ModalHeader>
        <ModalBody>
          {catalogoProcesos
            .sort((a, b) => (a.name > b.name ? 1 : -1))
            .map((a, index) => {
              if (!arrayCatalogoProcesos.includes(a._id)) {
                return (
                  <table>
                    <td>
                      <Input
                        type="checkbox"
                        key={index}
                        onChange={(e) => {
                          catalogoProcesosSeleccionados(
                            e.currentTarget.checked,
                            a._id,
                          );
                        }}
                        className="subMenu"
                      />
                      <h5 className="subMenuTitulo">{a.name}</h5>
                    </td>
                  </table>
                );
              } else {
                return <h5 className="subMenuTitulo">{a.name}</h5>;
              }
            })}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardarCatalogoProcesos}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        size="xl"
        isOpen={modalEditInfoArticulo}
        toggle={toggleEditInfoArticulo}
      >
        <ModalHeader toggle={toggleEditInfoArticulo}>
          <h4>
            Editar Modelo {codigoEdit} / {descripcionEdit}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>Codigo</Label>
              <Input
                type="text"
                placeholder="Codigo"
                value={codigoEdit}
                required
                onChange={(e) => {
                  setCodigoEdit(e.target.value);
                }}
              />
            </Col>

            <Col md={3}>
              <Label>Descripcion</Label>
              <Input
                type="text"
                placeholder="Descripcion"
                value={descripcionEdit}
                required
                onChange={(e) => {
                  setDescripcionEdit(e.target.value);
                }}
              />
            </Col>

            {/* <Col md={3}>
                <Label className="mr-sm-2">Marca</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedMarcaEdit}
                  required
                  onChange={(e) => {
                    setSelectedMarcaEdit(e.target.value);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {marcas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col> */}
          </Row>
          <Row>
            <Col md={3}>
              <Label>CodigoCliente</Label>
              <Input
                type="text"
                placeholder="CodigoCliente"
                value={codigoClienteEdit}
                required
                onChange={(e) => {
                  setCodigoClienteEdit(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row></Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editArticulos}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="xl" isOpen={modalPrecosteo} toggle={togglePrecosteo}>
        <ModalHeader toggle={togglePrecosteo}>
          <h4>Precosteo</h4>
        </ModalHeader>
        <ModalBody>
          {/* <h3>Tela</h3> */}
          <Table size="xl" striped borderless>
            <thead>
              <tr>
                <th>Tela</th>
                <th>Color</th>
                <th>Cantidad</th>
                <th>Costo</th>
                <th>Costo x Prenda</th>
              </tr>
            </thead>
            <tbody>
              {precosteoTelas.map(
                (a) => (
                  (totalPrecosteoTela = totalPrecosteoTela + a.totalPrenda),
                  (
                    <tr>
                      <td>{a.tela}</td>
                      <td>{a.color}</td>
                      <td>{a.cantidad}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.costo)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.totalPrenda)}
                      </td>
                    </tr>
                  )
                ),
              )}
              <br />
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  Total Tela
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalPrecosteoTela)}
                </td>
              </tr>
            </tbody>
          </Table>
          {/* <br /> */}

          {/* <h3>Habilitacion</h3> */}
          <Table size="xl" striped borderless>
            <thead>
              <tr>
                <th>Habilitacion</th>
                <th>Cantidad</th>
                <th>Costo</th>
                <th>Costo x Prenda</th>
              </tr>
            </thead>
            <tbody>
              {precosteoHab.map(
                (a) => (
                  (totalPrecosteoHab = totalPrecosteoHab + a.totalPrenda),
                  (
                    <tr>
                      <td>{a.habilitacion}</td>
                      <td>{a.cantidad}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.costo)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.totalPrenda)}
                      </td>
                    </tr>
                  )
                ),
              )}
              <tr>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  Total Habilitacion
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalPrecosteoHab)}
                </td>
                <td></td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  Total General
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalPrecosteoTela + totalPrecosteoHab)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
        </ModalBody>
      </Modal>



      <Modal isOpen={modalCheck} toggle={() => setModalCheck(false)}>
        <ModalHeader toggle={() => setModalCheck(false)}>
          Verificación antes de autorizar
        </ModalHeader>
        <ModalBody>
          <table style={{ width: "100%" }}>
            <tbody>
              {Object.entries(checks).map(([key, value]) => (
                <tr key={key} style={{ height: "40px" }}>
                  <td style={{ width: "40px", verticalAlign: "middle" }}>
                    <Input
                      type="checkbox"
                      checked={value}
                      onChange={() =>
                        setChecks((prev) => ({ ...prev, [key]: !prev[key] }))
                      }
                    />
                  </td>
                  <td style={{ verticalAlign: "middle", fontSize: "16px" }}>
                    {key}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            disabled={!Object.values(checks).every((v) => v)}
            onClick={autorizarPedido}
          >
            Autorizar
          </Button>
          <Button color="secondary" onClick={() => setModalCheck(false)}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={modalNuevaTela}
        toggle={() => setModalNuevaTela(!modalNuevaTela)}
      >
        <ModalHeader toggle={() => setModalNuevaTela(!modalNuevaTela)}>
          Dar de alta tela
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Nombre</Label>
            <Input
              value={nuevaTela.nombre}
              onChange={(e) => {
                const val = e.target.value;
                setNuevaTela((p) => ({ ...p, nombre: val }));
              }}
              placeholder='Ej. "Algodón gris"'
            />
          </FormGroup>
          <FormGroup>
            <Label>Composición</Label>
            <Input
              value={nuevaTela.composicion}
              onChange={(e) => {
                const val = e.target.value;
                setNuevaTela((p) => ({ ...p, composicion: val }));
              }}
              placeholder='Ej. "100% algodón"'
            />
          </FormGroup>
          <FormGroup>
            <Label>Tipo de tela</Label>
            <Input
              type="select"
              value={nuevaTela.tipoTela}
              onChange={(e) => {
                const val = e.target.value;
                setNuevaTela((p) => ({ ...p, tipoTela: val }));
              }}
            >
              <option value="">Selecciona</option>
              {tiposTelas
                .slice()
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((t) => (
                  <option value={t._id} key={t._id}>
                    {t.name}
                  </option>
                ))}
            </Input>
          </FormGroup>
          <small className="text-muted">
            Los demás campos (ancho, peso, costo, etc.) se podrán editar
            después en el catálogo de Telas.
          </small>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={guardarNuevaTelaEdit}
            disabled={
              savingTela ||
              !String(nuevaTela.nombre || "").trim() ||
              !String(nuevaTela.composicion || "").trim() ||
              !String(nuevaTela.tipoTela || "").trim()
            }
          >
            {savingTela ? "Guardando..." : "Guardar"}
          </Button>
          <Button
            color="secondary"
            onClick={() => setModalNuevaTela(false)}
            disabled={savingTela}
          >
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoPedidos;
